import React, { useState, useEffect, useRef, useCallback } from 'react';
import { holeToken, setzeToken, erneuereToken, abmeldenUndAufraeumen, istInstallierteApp, tokenDaten } from './lib/sitzung';
import { SitzungWaechter } from './components/ui/SitzungWaechter';
import { MIcon } from './lib/micon';
import { LdSheet } from './components/ui/LdSheet';
import { LdFeld, LdFeldReihe, LdEingabe, LdTextfeld, LdAuswahl, LdDatum, LdUhrzeit, LdChips, LdFensterFuss, datumLang, LdZahl, LdKiHinweis } from './components/ld/LdFenster';
import { Button } from './components/ld/Button';
import { IconButton } from './components/ld/IconButton';
import { UniversaldiktatFAB, DIKTAT_AUS_ROUTEN } from './components/diktat/UniversaldiktatFAB';
import { QuickMicButton } from './components/diktat/QuickMicButton';
import { OfflineQueueIndicator } from './components/diktat/OfflineQueueIndicator';
import { registerSyncListener } from './lib/diktat-sync';
import { useZeitraster, fmtZeit } from './lib/zeitraster';
import { oeffneUnterrichtszeiten, ZeitrasterHinweis } from './features/settings/Unterrichtszeiten';
import { schuljahrFenster, fruehereSchuljahre, schuljahrKurz } from './lib/schuljahr';
import { zaehltText } from './lib/noten-zaehlt';
import { KarussellHeader } from './components/patterns/KarussellHeader';
import { API_BASE, apiHeaders, apiFetch, apiGet, apiPost, apiPut, apiDelete, leseFallback, zeigeApiFehler } from './lib/api';
import { FEHLZEITEN_GRENZEN_KEY, notenFarbeKMK } from './lib/utils';
import { note as noteKomma, notenStufe } from './features/schueler/profil/format';
import { useIsMobile, isStandalone, isIosSafari, useEscapeKey, useEindeutigeKlassen, vergleicheKlassen, eindeutigeKlassen, useOhneMikroKnopf } from './lib/hooks';
import { Schueler, KlasseFachEintrag, NutzerProfil, Lehrerrolle, LehrerProfil, SchuelerEintrag, KlasseKonfig, AppKonfig, TerminEinstellungen, NavItem, DbNote, HjEndnote, MitarbeitExtracted, SetupTab, ProfilZiel } from './types';
import { FabProvider, useFab } from './contexts/FabContext';
import { SchuelerProvider, useSchueler } from './contexts/SchuelerContext';
import { toast, registerToastSetter, schliesseToast, ToastEntry } from './lib/toast';
import { confirm } from './lib/confirm';
import { ConfirmHost } from './components/ui/ConfirmHost';
import { MikrofonHinweisHost } from './components/ui/MikrofonHinweisHost';
import { mikrofonAnfragen, zeigeMikrofonFehler, fokussiere } from './lib/mikrofon';
import { BLUE, DEFAULT_TERMIN_EINST, ART_LABEL, ART_FARBE } from './lib/constants';
import { registerNav, globalNav, registerAusflugOpener, openAusflugDetail, nimmTerminZiel, istProfilHerkunft, merkeProfilHerkunft, ProfilHerkunft, oeffneMailVonAussen, oeffneTerminBearbeiten, oeffneKlassenbuch, oeffneNotizen, oeffneKlassenAktionen, oeffneKlasse, oeffneFehlzeiten, zeigeNoteVorschlaege, registerProfilOeffner, oeffneGespraechAusTermin, oeffneKlassenarbeitListe, oeffneKonferenzliste, oeffneBeitrag } from './lib/nav';
import { pushZiel, istPushStart, ohnePushParameter } from './lib/push-ziel';
import { datumTTMMJJJJ, datumTTMM } from './lib/datum';
import { registerAktuellerNutzer, getAktuellerNutzer } from './lib/aktuellerNutzer';
import { NotizenBereich } from './features/notizen/NotizenBereich';
import { NoteSheet } from './features/noten/NoteSheet';
import { Hj1EndnoteSheet } from './features/noten/Hj1EndnoteSheet';
import { NotenEinstellungenSheet } from './features/noten/NotenEinstellungenSheet';
import { NOTIZ_KATEGORIEN, signalNotizenGeaendert } from './features/notizen/notizen-lib';
import { EinstellungenAnsicht } from './features/settings';
import { DatenschutzerklaerungText, RechtsLinks, VerarbeitungsListe } from './features/rechtliches/RechtsTexte';
import { SchuelerProfil } from './features/schueler';
import { KlasseTab } from './features/schueler/KlasseTab';
import { SchuelerListe } from './features/klasse/SchuelerListe';
import { PortalMenu, KkMenu, KopfMenuEintrag } from './features/klasse/KlassenKopf';
import { kalenderwoche } from './features/klassenbuch/MitarbeitImEintrag';
import { heuteIso, wtKommaTm } from './features/schueler/profil/format';
import './features/meintag/meintag.css';
import { KlasseEinrichtenModal } from './features/klassen-verwaltung';
import { FehlzeitenScreen } from './features/fehlzeiten/FehlzeitenScreen';
import { KlassenarbeitListeHost } from './features/noten/KlassenarbeitListe';
import { KonferenzHosts } from './features/konferenz/Konferenz';
import { KlassenbuchNachtragenHost } from './features/klassenbuch/NachtragenSheet';
import { KlassenbuchScreen } from './features/klassenbuch/KlassenbuchScreen';
import { MailScreen } from './features/mail/MailScreen';
import { HeuteScreen } from './features/heute/HeuteScreen';
import { KlaerungInbox } from './features/klaerung/KlaerungInbox';
import { UebergangWizard } from './features/uebergang/UebergangWizard';
import { HardCutoffModal } from './features/uebergang/HardCutoffModal';
import { ArchivScreen } from './features/uebergang/ArchivScreen';
import { SicherheitSeite } from './features/sicherheit/SicherheitSeite';
import { PasswortFenster } from './features/sicherheit/aktionen';
import { useLader } from './features/heute/widgets/lader';
import { TasksAnsicht } from './components/tasks/TasksAnsicht';
import { AusflugDetail } from './features/ausflug/AusflugDetail';
import { LoadingBlock } from './components/ui/LoadingSpinner';
import { KlassenProvider } from './contexts/KlassenContext';

// Admin-Konsole: eigener Chunk, wird nur beim Öffnen durch Admins geladen
const AdminKonsole = React.lazy(() => import('./features/admin/AdminKonsole'));

// ── PWA / Mobile Utilities ─────────────────────────────────────────────────

/** Vibrate on Android (graceful no-op on iOS/Desktop) */
function haptic(pattern: number | number[]) {
  try { navigator.vibrate?.(pattern); } catch {}
}

// Module-level bridge: MailsAnsicht registers mail pre-fill opener here
let _openNeueMailMitEmpfaenger: ((email: string, betreff?: string) => void) | null = null;

// ── Splash Screen ──────────────────────────────────────────────────────────
function SplashScreen({ onDone }: { onDone: () => void }) {
  useEffect(() => {
    const t = setTimeout(onDone, 1600);
    return () => clearTimeout(t);
  }, [onDone]);
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'linear-gradient(160deg, #4132A8 0%, #6B5FD4 50%, #5245BA 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      animation: 'splashFade 1.4s ease forwards',
    }}>
      <style>{`
        @keyframes splashFade { 0%,70% { opacity:1; } 100% { opacity:0; pointer-events:none; } }
        @keyframes splashPop  { from { opacity:0; transform:scale(.7); } to { opacity:1; transform:scale(1); } }
        @keyframes splashSpin { to { transform:rotate(360deg); } }
      `}</style>
      <div style={{ animation: 'splashPop .5s cubic-bezier(.34,1.56,.64,1) forwards', textAlign: 'center' }}>
        <div style={{
          width: 96, height: 96, borderRadius: 'var(--ld-radius-2xl)', margin: '0 auto 20px',
          background: 'rgba(255,255,255,0.15)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        }}>
          <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
            <rect x="4"  y="4"  width="20" height="20" rx="5" fill="white" opacity=".9"/>
            <rect x="28" y="4"  width="20" height="20" rx="5" fill="white" opacity=".7"/>
            <rect x="4"  y="28" width="20" height="20" rx="5" fill="white" opacity=".7"/>
            <rect x="28" y="28" width="20" height="20" rx="5" fill="white" opacity=".5"/>
          </svg>
        </div>
        <div style={{ fontSize: 28, fontWeight: 800, color: 'white', letterSpacing: -0.5 }}>LehrerDesk</div>
        <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', marginTop: 6, letterSpacing: 0.3 }}>Hessen 2026</div>
        <div style={{
          marginTop: 40, width: 36, height: 36,
          border: '3px solid rgba(255,255,255,0.3)',
          borderTopColor: 'white', borderRadius: '50%',
          animation: 'splashSpin .8s linear infinite',
          margin: '40px auto 0',
        }} />
      </div>
    </div>
  );
}

// ── Toast Notification ────────────────────────────────────────────────────
function ToastContainer() {
  const [toasts, setToasts] = useState<ToastEntry[]>([]);
  useEffect(() => { registerToastSetter(setToasts); return () => { registerToastSetter(null); }; }, []);

  if (toasts.length === 0) return null;
  return (
    <div style={{
      position: 'fixed', bottom: 90, left: '50%', transform: 'translateX(-50%)',
      zIndex: 9000, display: 'flex', flexDirection: 'column', gap: 8,
      pointerEvents: 'none', alignItems: 'center',
    }}>
      {toasts.map(t => (
        <div key={t.id} className={`ld-toast ld-toast--${t.type}${t.exiting ? ' ld-toast--exit' : ''}${t.aktion ? ' ld-toast--mit-aktion' : ''}`}>
          <span>{t.message}</span>
          {t.aktion && (
            <button className="ld-toast__aktion" onClick={() => { t.aktion!.onClick(); schliesseToast(t.id); }}>{t.aktion.label}</button>
          )}
        </div>
      ))}
    </div>
  );
}

// ── Offline Banner ─────────────────────────────────────────────────────────
function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const goOff = () => setOffline(true);
    const goOn  = () => setOffline(false);
    window.addEventListener('offline', goOff);
    window.addEventListener('online',  goOn);
    return () => { window.removeEventListener('offline', goOff); window.removeEventListener('online', goOn); };
  }, []);
  if (!offline) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 8000,
      background: 'var(--ld-warning-soft)', borderBottom: '1px solid var(--ld-warning)',
      color: 'var(--ld-warning-text)', padding: '10px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
      fontSize: 13, fontWeight: 600,
      boxShadow: 'var(--ld-shadow-sm)',
    }}>
      <MIcon name="cloud_off" size={18} />
      Keine Verbindung — Änderungen werden gespeichert, wenn Sie wieder online sind
    </div>
  );
}

// ── Count-Up Hook ─────────────────────────────────────────────────────────

// ── Spinner / Loading ─────────────────────────────────────────────────────

// ── Swipeable Row ──────────────────────────────────────────────────────────
function SwipeRow({
  children, onSwipeLeft, onSwipeRight,
  leftLabel = 'Fehlzeit', rightLabel = 'Notiz',
  leftColor = '#FF6B6B', rightColor = '#4ECDC4',
}: {
  children: React.ReactNode;
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  leftLabel?: string; rightLabel?: string;
  leftColor?: string; rightColor?: string;
}) {
  const [dx, setDx] = useState(0);
  const startX = useRef(0);
  const startY = useRef(0);
  const swiping = useRef(false);
  const THRESHOLD = 80;
  const MAX = 110;

  function onTouchStart(e: React.TouchEvent) {
    startX.current = e.touches[0].clientX;
    startY.current = e.touches[0].clientY;
    swiping.current = false;
  }
  function onTouchMove(e: React.TouchEvent) {
    const dX = e.touches[0].clientX - startX.current;
    const dY = Math.abs(e.touches[0].clientY - startY.current);
    if (!swiping.current && dY > 12) return; // vertical scroll dominates
    if (Math.abs(dX) > 8) swiping.current = true;
    if (!swiping.current) return;
    setDx(Math.max(-MAX, Math.min(MAX, dX)));
  }
  function onTouchEnd() {
    if (dx < -THRESHOLD && onSwipeLeft) {
      haptic(30);
      onSwipeLeft();
    } else if (dx > THRESHOLD && onSwipeRight) {
      haptic(30);
      onSwipeRight();
    }
    setDx(0);
    swiping.current = false;
  }

  const showLeft  = dx < -20;
  const showRight = dx > 20;

  return (
    <div style={{ position: 'relative', overflow: 'hidden' }}>
      {showLeft && (
        <div style={{
          position: 'absolute', right: 0, top: 0, bottom: 0,
          width: Math.min(Math.abs(dx), MAX), background: leftColor,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'white', fontWeight: 700, fontSize: 12,
        }}>
          {Math.abs(dx) > 50 && leftLabel}
        </div>
      )}
      {showRight && (
        <div style={{
          position: 'absolute', left: 0, top: 0, bottom: 0,
          width: Math.min(dx, MAX), background: rightColor,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'white', fontWeight: 700, fontSize: 12,
        }}>
          {dx > 50 && rightLabel}
        </div>
      )}
      <div
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        style={{ transform: `translateX(${dx}px)`, transition: dx === 0 ? 'transform .2s ease' : 'none', background: 'transparent' }}
      >
        {children}
      </div>
    </div>
  );
}

// ── iOS Install Banner ─────────────────────────────────────────────────────
function IosInstallBanner({ onClose }: { onClose: () => void }) {
  return (
    <div style={{
      // Welle D3b: oben statt unten — unten rechts liegt der Mikro-Knopf, den der Hinweis sonst verdeckt
      position: 'fixed', top: 'calc(env(safe-area-inset-top, 0px) + 12px)', left: 12, right: 12,
      background: '#1E1631', borderRadius: 18, padding: '16px 18px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.4)', zIndex: 900,
      animation: 'slideDownIn .3s ease',
    }}>
      <style>{`@keyframes slideDownIn { from { opacity:0; transform:translateY(-20px); } to { opacity:1; transform:none; } }`}</style>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <MIcon name="install_mobile" size={26} />
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'white' }}>LehrerDesk installieren</div>
            <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)', marginTop: 2 }}>Zum Home-Bildschirm hinzufügen</div>
          </div>
        </div>
        <IconButton variant="bare" size={36} label="Schließen" onClick={onClose} style={{ fontSize: 22 }}>×</IconButton>
      </div>
      <div style={{ background: '#2A1F4F', borderRadius: 'var(--ld-radius-md)', padding: '12px 14px' }}>
        <div style={{ fontSize: 13, color: '#D1D1D6', lineHeight: 1.7 }}>
          <div style={{ marginBottom: 6 }}>
            1. Tippe auf{' '}
            <span style={{ display: 'inline-block', background: '#3D2A6E', borderRadius: 6, padding: '1px 8px', fontSize: 12 }}>
              Teilen <MIcon name="ios_share" size={15} />
            </span>
            {' '}unten in Safari
          </div>
          <div>
            2. Wähle{' '}
            <span style={{ display: 'inline-block', background: '#3D2A6E', borderRadius: 6, padding: '1px 8px', fontSize: 12 }}>
              Zum Home-Bildschirm ＋
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── FAB (Floating Action Button) ──────────────────────────────────────────
function FAB({ onNav, activeNav }: { onNav: (k: NavItem) => void; activeNav: NavItem }) {
  const { fabHandler } = useFab();
  const [popup, setPopup] = useState(false);
  const [auswahlOffen, setAuswahlOffen] = useState(false);
  const longPressRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  function handleTap() {
    haptic(20);
    if (fabHandler) {
      fabHandler();
    } else {
      // Kein screen-spezifischer Handler → UniversaldiktatFAB via Custom-Event
      window.dispatchEvent(new CustomEvent('ld-diktat'));
    }
  }

  function startLongPress() {
    longPressRef.current = setTimeout(() => {
      haptic(40);
      setPopup(true);
    }, 600);
  }

  function cancelLongPress() {
    if (longPressRef.current) clearTimeout(longPressRef.current);
  }

  // Welle B2: kein Knopf, wo das Diktat aus ist und der Bildschirm keinen eigenen Mikro-Weg hat
  // (Mein Tag → Mehrarbeit setzt einen fabHandler und behält den Knopf). Sichtbarkeit am body
  // für den Abstand unten (index.css, body[data-mikroknopf]).
  // Welle K1: auch im Klassen-Bereich (dort startet er z. B. bei Fehlzeiten das Fehlzeit-Diktat); über einem offenen
  // Profil blenden SchuelerAnsicht/FehlzeitenScreen ihn per useOhneMikroKnopf aus (feste Leiste unten).
  const sichtbar = !(DIKTAT_AUS_ROUTEN.has(activeNav) && !fabHandler);
  useEffect(() => {
    if (!sichtbar) return;
    document.body.dataset.mikroknopf = '1';
    return () => { delete document.body.dataset.mikroknopf; };
  }, [sichtbar]);
  if (!sichtbar) return null;

  return (
    <>
      <button
        className="ld-fab ld-btn-press"
        onClick={handleTap}
        onTouchStart={e => { startLongPress(); (e.currentTarget as HTMLButtonElement).style.transform = 'scale(.92)'; }}
        onTouchEnd={e => { cancelLongPress(); (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)'; }}
        onMouseDown={startLongPress}
        onMouseUp={cancelLongPress}
        style={{
          position: 'fixed',
          bottom: 'calc(var(--ld-bottom-nav-h) + var(--ld-dock-offset) + env(safe-area-inset-bottom, 0px) + var(--ld-space-base))',
          right: 'var(--ld-space-base)',
          width: 56, height: 56, borderRadius: 'var(--ld-radius-full)',
          background: 'var(--ld-primary)',
          color: 'white', border: 'none', cursor: 'pointer',
          boxShadow: 'var(--ld-shadow-fab)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 22, zIndex: 450,
          WebkitTapHighlightColor: 'transparent' as any,
          transition: 'transform var(--ld-transition-fast), box-shadow var(--ld-transition-fast)',
        }}
        onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.05)'; (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 28px rgba(107, 95, 212,0.35)'; }}
        onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)'; (e.currentTarget as HTMLButtonElement).style.boxShadow = 'var(--ld-shadow-accent)'; }}
        title="Diktat starten"
      >
        <MIcon name="mic" size={24} />
      </button>

      {/* Standard-Auswahl-Modal (wenn kein Screen-Handler registriert) */}
      {auswahlOffen && (
        <div onClick={() => setAuswahlOffen(false)} style={{ position: 'fixed', inset: 0, zIndex: 500, background: 'rgba(0,0,0,0.3)', backdropFilter: 'blur(4px)' }}>
          <div onClick={e => e.stopPropagation()} style={{
            position: 'fixed', bottom: 148, right: 20,
            background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)', padding: 8,
            boxShadow: 'var(--ld-shadow-lg)',
            minWidth: 200, zIndex: 501,
          }}>
            {([
              { label: 'Klassenbuch', icon: <MIcon name="menu_book" size={18} />, nav: 'klassenbuch' as NavItem },
              { label: 'Fehlzeit erfassen', icon: <MIcon name="warning" size={18} />, nav: 'fehlzeiten' as NavItem },
              { label: 'Mehrarbeit eintragen', icon: <MIcon name="schedule" size={18} />, nav: 'mehrarbeit' as NavItem },
              { label: 'Notiz', icon: <MIcon name="description" size={18} />, nav: 'notizen' as NavItem },
            ] as { label: string; icon: React.ReactNode; nav: NavItem }[]).map((item, i, arr) => (
              <button key={item.label} onClick={() => { setAuswahlOffen(false); onNav(item.nav); }} style={{
                display: 'flex', alignItems: 'center', gap: 12, width: '100%',
                padding: '12px 14px', background: 'var(--ld-bg-input)', border: 'none', cursor: 'pointer',
                borderRadius: 'var(--ld-radius-md)', marginBottom: i < arr.length - 1 ? 4 : 0,
                fontSize: 14, fontWeight: 500, color: 'var(--ld-text-primary)', textAlign: 'left',
              }}>
                <span style={{ color: 'var(--ld-text-secondary)', display: 'flex' }}>{item.icon}</span>
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Long-press Schnellzugriff-Popup */}
      {popup && (
        <div onClick={() => setPopup(false)} style={{ position: 'fixed', inset: 0, zIndex: 500, background: 'rgba(0,0,0,0.3)', backdropFilter: 'blur(4px)' }}>
          <div onClick={e => e.stopPropagation()} style={{
            position: 'fixed', bottom: 148, right: 20,
            background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)', padding: 8,
            boxShadow: 'var(--ld-shadow-lg)',
            minWidth: 200, zIndex: 501,
          }}>
            {([
              { label: 'Notiz diktieren', icon: <MIcon name="description" size={18} />, nav: 'notizen' as NavItem },
              { label: 'Klassenbuch', icon: <MIcon name="menu_book" size={18} />, nav: 'unterricht' as NavItem },
              { label: 'Fehlzeit erfassen', icon: <MIcon name="warning" size={18} />, nav: 'fehlzeiten' as NavItem },
              { label: 'Mehrarbeit eintragen', icon: <MIcon name="schedule" size={18} />, nav: 'mehrarbeit' as NavItem },
            ] as { label: string; icon: React.ReactNode; nav: NavItem }[]).map((item, i, arr) => (
              <button key={item.label} onClick={() => { setPopup(false); onNav(item.nav); }} style={{
                display: 'flex', alignItems: 'center', gap: 12, width: '100%',
                padding: '12px 14px', background: 'var(--ld-bg-input)', border: 'none', cursor: 'pointer',
                borderRadius: 'var(--ld-radius-md)', marginBottom: i < arr.length - 1 ? 4 : 0,
                fontSize: 14, fontWeight: 500, color: 'var(--ld-text-primary)', textAlign: 'left',
              }}>
                <span style={{ color: 'var(--ld-text-secondary)', display: 'flex' }}>{item.icon}</span>
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

// ── Types (local to App.tsx) ────────────────────────────────────────────────

interface BackendEintrag {
  schueler: string;
  kategorie: string;
  aktion: string;
  zusammenfassung?: string;
  valenz?: 'positiv' | 'negativ' | null;
}

interface Mail {
  id: number;
  von: string;
  betreff: string;
  vorschau: string;
  zeit: string;
  gelesen: boolean;
}

type NotizenModus = 'sprechen' | 'tippen' | 'schnell';

interface KIEintrag {
  id: number;
  modus: NotizenModus;
  schueler: string;
  aktion: string;
  raw?: string;
  farbe: string;
  zeit: string;
}

const mails: Mail[] = [];


// ── Icons (inline SVG als Komponenten) ─────────────────────────────────────
const icons: Record<NavItem | 'logo', React.ReactNode> = {
  schulrecht: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 2L3 7l9 5 9-5-9-5z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M3 12l9 5 9-5M3 17l9 5 9-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    </svg>
  ),
  kalender: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
      <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="8"  cy="16" r="1.5" fill="currentColor"/>
      <circle cx="12" cy="16" r="1.5" fill="currentColor"/>
      <circle cx="16" cy="16" r="1.5" fill="currentColor"/>
    </svg>
  ),
  stundenplan: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
      <path d="M3 8h18M8 3v5M16 3v5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M7 12h2M11 12h2M15 12h2M7 16h2M11 16h2M15 16h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  unterricht: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
      <path d="M3 9h18M9 3v18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="15" cy="15" r="2.5" fill="currentColor" opacity=".5"/>
    </svg>
  ),
  logo: (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <rect x="2" y="3" width="20" height="14" rx="2" stroke="white" strokeWidth="2"/>
      <path d="M8 21h8M12 17v4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  home: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M9 21V12h6v9" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    </svg>
  ),
  schueler: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
      <path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  notizen: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <polyline points="14,2 14,8 20,8" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <line x1="8" y1="13" x2="16" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="8" y1="17" x2="13" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  fehlzeiten: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
      <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M9 16l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  mails: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/>
      <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    </svg>
  ),
  klassenbuch: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
      <path d="M3 9h18M9 3v18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  einstellungen: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" stroke="currentColor" strokeWidth="2"/>
    </svg>
  ),
  klasse: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
      <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
      <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
      <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
    </svg>
  ),
  mehrarbeit: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <polyline points="14,2 14,8 20,8" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <line x1="12" y1="18" x2="12" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="9" y1="15" x2="15" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  datenschutz: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  meinTag: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
      <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  stoffplan: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M4 6h16M4 10h10M4 14h12M4 18h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  klaerung: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="12" cy="17" r="1" fill="currentColor"/>
    </svg>
  ),
  uebergang: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  archiv: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="2" y="4" width="20" height="5" rx="1" stroke="currentColor" strokeWidth="2"/>
      <path d="M4 9v10a1 1 0 001 1h14a1 1 0 001-1V9" stroke="currentColor" strokeWidth="2"/>
      <path d="M10 13h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  ausflug: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M4 16V6a2 2 0 012-2h9a2 2 0 012 2v10M3 16h18M7 20v-2M17 20v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="7.5" cy="16.5" r="1.5" fill="currentColor"/>
      <circle cx="16.5" cy="16.5" r="1.5" fill="currentColor"/>
    </svg>
  ),
  admin: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    </svg>
  ),
  mitteilungen: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M9.5 12l1.8 1.8L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
};

// ── Sidebar ────────────────────────────────────────────────────────────────
const navGroups: { label: string; items: { key: NavItem; label: string }[] }[] = [
  { label: 'Tagesgeschäft', items: [
    { key: 'home',        label: 'Heute'       },
    { key: 'klassenbuch', label: 'Klassenbuch' },
    { key: 'fehlzeiten',  label: 'Fehlzeiten'  },
    { key: 'meinTag',     label: 'Mein Tag'    },   // Welle U7: Aufgaben (Tasks) auch im Web
  ]},
  { label: 'Schüler', items: [
    { key: 'klasse',  label: 'Klasse'   },
    { key: 'notizen', label: 'Notizen'  },   // Welle U4b
  ]},
  { label: 'Organisation', items: [
    { key: 'kalender',    label: 'Kalender'          },
    { key: 'stundenplan', label: 'Stundenplan'        },
    { key: 'mails',       label: 'Mails'             },
    { key: 'mehrarbeit',  label: 'Mehrarbeit'        },
    { key: 'stoffplan',   label: 'Stoffverteilung'   },
  ]},
  { label: 'System', items: [
    { key: 'mitteilungen',  label: 'Sicherheit & Tipps' },
    { key: 'einstellungen', label: 'Einstellungen'      },
  ]},
];

// ── localStorage ──────────────────────────────────────────────────────────
const STORAGE_KEY = 'lehrerdesk_v1';

function ladeKonfig(): AppKonfig | null {
  try { const r = localStorage.getItem(STORAGE_KEY); return r ? JSON.parse(r) : null; } catch { return null; }
}

function speichereKonfig(k: AppKonfig): void {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(k)); } catch {}
}

const DEFAULT_KONFIG: AppKonfig = {
  onboardingAbgeschlossen: false,
  demoModus: true,
  lehrer: { name: '', kuerzel: '', schule: '', bundesland: 'Hessen', schulform: 'Gymnasium' },
  klassen: [],
  aktiveKlasseId: '',
};

const SIDEBAR_W = 220;

function Sidebar({
  active, onNav, konfig, nutzer, onSuche,
}: {
  active: NavItem;
  onNav: (k: NavItem) => void;
  konfig: AppKonfig;
  nutzer: NutzerProfil | null;
  onSuche: () => void;
}) {
  const ungelesen = mails.filter(m => !m.gelesen).length;
  const { isRecording } = useFab();
  // Welle A3: ungelesene Beiträge in „Sicherheit & Tipps“ (dieselbe Anfrage wie die Seite)
  const beitraegeNeu = useLader<{ ungelesen: number }>('/api/beitraege', 10 * 60_000).daten?.ungelesen ?? 0;

  // Welle K1: „Erzählen“ (und Strg+D über ld-diktat) öffnet am PC das allgemeine Diktat — mit Mitarbeit,
  // Note und Gespräch. Vorher liefen hier nur die Modul-Diktate des Bildschirms oder eine Bildschirm-Auswahl (B3-Befund).
  function erzaehlen() {
    window.dispatchEvent(new CustomEvent('ld-universaldiktat', { detail: { seitenleiste: true } }));
  }
  useEffect(() => {
    window.addEventListener('ld-diktat', erzaehlen);
    return () => window.removeEventListener('ld-diktat', erzaehlen);
  }, []);

  const lehrerName   = nutzer ? `${nutzer.vorname} ${nutzer.nachname}` : (konfig.lehrer.name || '–');
  const kuerzel      = nutzer ? nutzerInitialen(nutzer)
    : (konfig.lehrer.kuerzel || konfig.lehrer.name.slice(0,2).toUpperCase() || '?');
  const schulInfo    = nutzer
    ? `${nutzer.schule}`
    : `${konfig.lehrer.schule || '–'}`;

  return (
    <aside style={{
      width: SIDEBAR_W, minHeight: '100vh', background: 'var(--ld-bg)',
      display: 'flex', flexDirection: 'column', flexShrink: 0,
      boxShadow: 'var(--ld-shadow-sidebar)', position: 'relative',
      borderRadius: '0 20px 20px 0',
    }}>
      {/* Logo */}
      <div style={{ padding: '24px 16px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{
          width: 40, height: 40, borderRadius: 'var(--ld-radius-md)',
          background: 'var(--ld-accent-gradient)', display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: 'var(--ld-shadow-accent)',
        }}>
          {icons.logo}
        </div>
        <div>
          <div style={{ color: 'var(--ld-primary)', fontWeight: 'var(--ld-font-weight-bold)' as any, fontSize: 'var(--ld-font-size-lg)', lineHeight: 1.2 }}>LehrerDesk</div>
          <div style={{ color: 'var(--ld-text-secondary)', fontSize: 'var(--ld-font-size-xs)' }}>Hessen 2026</div>
        </div>
      </div>

      {/* Welle U6b: globale Suche auch im Web (dasselbe Overlay wie mobil) */}
      <div style={{ padding: '0 12px 12px' }}>
        <button onClick={onSuche} className="ld-sidebar-suche" aria-label="Suchen">
          <MIcon name="search" size={18} />
          <span>Suchen</span>
        </button>
      </div>

      {/* Divider */}
      <div style={{ height: 1, background: 'var(--ld-bg-input)', margin: '0 16px 12px' }} />

      {/* Nav */}
      <nav style={{ flex: 1, padding: '0 12px', overflowY: 'auto' }}>
        {navGroups.map(({ label: groupLabel, items }) => (
          <div key={groupLabel} style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 'var(--ld-font-size-xs)', fontWeight: 'var(--ld-font-weight-bold)' as any, color: 'var(--ld-text-tertiary)', padding: '8px 8px 6px' }}>
              {groupLabel}
            </div>
            <div style={{ background: 'var(--ld-surface)', borderRadius: 16, boxShadow: 'var(--ld-shadow-elev-med)', padding: 6 }}>
            {items.map(({ key, label }) => {
              const isActive = active === key;
              return (
                <button key={key} onClick={() => onNav(key)} style={{
                  width: '100%', display: 'flex', alignItems: 'center', gap: 10,
                  padding: '10px 12px', marginBottom: 2,
                  background: isActive ? 'var(--ld-brand-gradient)' : 'transparent',
                  border: 'none', borderRadius: 'var(--ld-radius-md)', cursor: 'pointer',
                  color: isActive ? '#fff' : 'var(--ld-text-secondary)',
                  boxShadow: isActive ? '0 4px 12px rgba(107, 95, 212, 0.30)' : 'none',
                  fontSize: 'var(--ld-font-size-base)', fontWeight: isActive ? 'var(--ld-font-weight-semibold)' : 'var(--ld-font-weight-medium)',
                  textAlign: 'left', transition: 'var(--ld-transition-fast)',
                }}
                onMouseEnter={e => { if (!isActive) { (e.currentTarget as HTMLButtonElement).style.background = 'var(--ld-bg-input)'; (e.currentTarget as HTMLButtonElement).style.color = 'var(--ld-text-primary)'; } }}
                onMouseLeave={e => { if (!isActive) { (e.currentTarget as HTMLButtonElement).style.background = 'transparent'; (e.currentTarget as HTMLButtonElement).style.color = 'var(--ld-text-secondary)'; } }}
                >
                  {icons[key]}
                  {label}
                  {((key === 'mails' && ungelesen > 0) || (key === 'mitteilungen' && beitraegeNeu > 0)) && (
                    <span aria-label={key === 'mitteilungen' ? `${beitraegeNeu} ungelesen` : undefined} style={{
                      marginLeft: 'auto', background: 'var(--ld-accent)',
                      color: 'white', borderRadius: 'var(--ld-radius-pill)', fontSize: 11,
                      padding: '2px 8px', fontWeight: 700,
                    }}>
                      {key === 'mitteilungen' ? beitraegeNeu : ungelesen}
                    </span>
                  )}
                </button>
              );
            })}
            </div>
          </div>
        ))}
      </nav>

      {/* ── Diktat-Button ── */}
      <div style={{ padding: '8px 12px 4px' }}>
        <style>{`
          @keyframes diktatPulse {
            0%   { box-shadow: 0 0 0 0 rgba(255,107,107,0.7), 0 4px 16px rgba(255,107,107,0.4); transform: scale(1); }
            50%  { box-shadow: 0 0 0 12px rgba(255,107,107,0), 0 4px 16px rgba(255,107,107,0.4); transform: scale(1.02); }
            100% { box-shadow: 0 0 0 0 rgba(255,107,107,0.7), 0 4px 16px rgba(255,107,107,0.4); transform: scale(1); }
          }
          @keyframes dotBlink { 0%,100% { opacity:1; } 50% { opacity:0.2; } }
        `}</style>
        <button
          onClick={erzaehlen}
          title="Erzählen: Mitarbeit, Noten, Gespräche und mehr (Strg+D)"
          style={{
            width: '100%', display: 'flex', alignItems: 'center', gap: 10,
            padding: '10px 14px', border: 'none', borderRadius: 'var(--ld-radius-md)', cursor: 'pointer',
            background: isRecording
              ? 'var(--ld-danger)'
              : 'var(--ld-brand-gradient)',
            color: 'white', fontSize: 14, fontWeight: 600,
            boxShadow: isRecording
              ? '0 4px 16px rgba(255,107,107,0.45)'
              : 'var(--ld-shadow-accent)',
            animation: isRecording ? 'diktatPulse 1.2s ease-in-out infinite' : 'none',
            transition: 'background 0.3s, box-shadow 0.3s, opacity var(--ld-transition-fast)',
            marginTop: 'var(--ld-space-lg)',
          }}
        >
          {isRecording ? (
            <>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'white', flexShrink: 0, animation: 'dotBlink 0.8s step-end infinite' }} />
              <span style={{ flex: 1 }}>Aufnahme läuft …</span>
            </>
          ) : (
            <>
              <MIcon name="mic" size={17} style={{ flexShrink: 0 }} />
              <span style={{ flex: 1 }}>Erzählen</span>
              <span style={{ fontSize: 10, opacity: 0.55, fontWeight: 400, letterSpacing: 0 }}>Strg+D</span>
            </>
          )}
        </button>
      </div>

      {/* User */}
      <div style={{ padding: '12px 16px 16px', display: 'flex', alignItems: 'center', gap: 10, borderTop: '1px solid var(--ld-bg-input)', marginTop: 4 }}>
        <div style={{
          width: 36, height: 36, borderRadius: '50%',
          background: 'var(--ld-accent-gradient)', display: 'flex', alignItems: 'center',
          justifyContent: 'center', color: 'white', fontSize: 13, fontWeight: 700,
          boxShadow: 'var(--ld-shadow-accent)',
        }}>{kuerzel}</div>
        <div>
          <div style={{ color: 'var(--ld-text-primary)', fontSize: 13, fontWeight: 600 }}>{lehrerName}</div>
          <div style={{ color: 'var(--ld-text-secondary)', fontSize: 11 }}>{schulInfo}</div>
        </div>
      </div>
      <RechtsLinks style={{ padding: '0 16px 14px', fontSize: 11 }} />
    </aside>
  );
}

// ── (old dashboard widgets removed) ───────────────────────────────────────

// ── Sheet-Komponente (zentral, wiederverwendbar) ───────────────────────────
// ── Stundenplan ────────────────────────────────────────────────────────────
interface StundenplanEintrag {
  id: number;
  wochentag: number;
  stunde: number;
  fach: string;
  klasse_id: number | null;
  klasse_name: string | null;
  raum: string | null;
}

// Welle K3: menuSetzen = seltene Aktionen (Zeiten ändern, Bearbeiten, leere Stunden) im ⋯-Menü von Mein Tag
function StundenplanAnsicht({ menuSetzen }: { menuSetzen?: MenuSetzen } = {}) {
  const isMobile = useIsMobile();
  const [bearbeiten, setBearbeiten] = useState(false);       // Handy: alle Stunden zum Bearbeiten
  const [leereZeigen, setLeereZeigen] = useState(false);     // PC: leere Stunden am Ende einblenden
  const [kbOffen, setKbOffen] = useState<{ eintraege: { datum: string; stunde_nr: number; klasse_id: number }[]; gesamt: number } | null>(null);
  const [schultage, setSchultage] = useState<Record<string, boolean>>({});
  useEffect(() => {
    apiFetch<{ eintraege: { datum: string; stunde_nr: number; klasse_id: number }[]; gesamt: number }>('/api/heute/klassenbuch-offen').then(setKbOffen).catch(() => {});
    apiFetch<{ tage: { datum: string; schultag: boolean }[] }>('/api/heute/woche')
      .then(w => setSchultage(Object.fromEntries((w.tage ?? []).map(t => [t.datum, t.schultag])))).catch(() => {});
  }, []);
  const [eintraege, setEintraege] = useState<StundenplanEintrag[]>([]);
  const [meineKlassen, setMeineKlassen] = useState<KlasseFachEintrag[]>([]);
  const [laden, setLaden] = useState(true);

  const heuteWt = new Date().getDay(); // 1=Mo…5=Fr
  const [aktiverTag, setAktiverTag] = useState(() => (heuteWt >= 1 && heuteWt <= 5) ? heuteWt : 1);

  const [offeneZelle, setOffeneZelle] = useState<{ wochentag: number; stunde: number; eintragId?: number } | null>(null);
  const [editFach, setEditFach] = useState('');
  const [editKlasseId, setEditKlasseId] = useState<number | ''>('');
  const [editRaum, setEditRaum] = useState('');
  const [editLaden, setEditLaden] = useState(false);
  // Welle Z1: Unterrichtszeiten der Lehrkraft (statt fester Hessen-Tabelle)
  const { zeiten, standard: rasterStandard } = useZeitraster();

  useEffect(() => {
    Promise.all([
      fetch(`${API_BASE}/api/stundenplan`,  { headers: apiHeaders() }).then(leseFallback<any[]>([], '/api/stundenplan')),
      fetch(`${API_BASE}/api/meine-klassen`, { headers: apiHeaders() }).then(leseFallback<any[]>([], '/api/meine-klassen')),
    ]).then(([sp, kl]) => {
      // Welle A6: Stundenplan ist statischer Mo-Fr-Wochenplan. Defensiv nur Mo-Fr (1–5)
      // rendern, falls je Alt-/Fremddaten mit Sa/So existieren (DB-CHECK verhindert das normal).
      setEintraege(Array.isArray(sp) ? sp.filter((e: StundenplanEintrag) => e.wochentag >= 1 && e.wochentag <= 5) : []);
      setMeineKlassen(kl);
      setLaden(false);
    }).catch(() => setLaden(false));
  }, []);

  function eintragFuer(wt: number, std: number) {
    return eintraege.find(e => e.wochentag === wt && e.stunde === std) ?? null;
  }

  function zelleOeffnen(wt: number, std: number) {
    const e = eintragFuer(wt, std);
    setOffeneZelle({ wochentag: wt, stunde: std, eintragId: e?.id });
    setEditFach(e?.fach ?? '');
    setEditKlasseId(e?.klasse_id ?? '');
    setEditRaum(e?.raum ?? '');
  }

  async function speichern() {
    if (!offeneZelle || !editFach.trim()) return;
    setEditLaden(true);
    try {
      const felder = { fach: editFach.trim(), klasse_id: editKlasseId !== '' ? editKlasseId : null, raum: editRaum.trim() || null };
      // Welle U6a: bestehende Zelle über PUT (stabile ID), neue Zelle wie bisher über POST
      const neu = offeneZelle.eintragId
        ? await apiPut<StundenplanEintrag>(`/api/stundenplan/${offeneZelle.eintragId}`, felder)
        : await apiPost<StundenplanEintrag>('/api/stundenplan', { wochentag: offeneZelle.wochentag, stunde: offeneZelle.stunde, ...felder });
      setEintraege(prev => [...prev.filter(e => !(e.wochentag === offeneZelle.wochentag && e.stunde === offeneZelle.stunde)), neu]);
      setOffeneZelle(null);
    } catch (e) { zeigeApiFehler(e, 'Speichern fehlgeschlagen'); } finally { setEditLaden(false); }
  }

  async function loeschen() {
    if (!offeneZelle?.eintragId) return;
    const zelle = offeneZelle;
    setOffeneZelle(null);   // modales Sheet zuerst schließen, sonst blockiert es den Dialog
    if (!(await confirm(`${['Mo', 'Di', 'Mi', 'Do', 'Fr'][zelle.wochentag - 1]}, ${zelle.stunde}. Stunde (${editFach}) aus dem Stundenplan löschen? Bestehende Klassenbuch-Einträge bleiben unverändert.`,
      { title: 'Stunde löschen?', confirmLabel: 'Löschen', danger: true }))) { setOffeneZelle(zelle); return; }
    setEditLaden(true);
    try {
      await apiDelete(`/api/stundenplan/${zelle.eintragId}`);
      setEintraege(prev => prev.filter(e => e.id !== zelle.eintragId));
      toast('Stunde gelöscht', 'success');
    } catch (e) { zeigeApiFehler(e, 'Löschen fehlgeschlagen'); } finally { setEditLaden(false); }
  }

  const faecher = Array.from(new Set(meineKlassen.map(k => k.fach))).sort();
  const uniqueKlassen = eindeutigeKlassen(meineKlassen);
  const TAGE = ['Mo', 'Di', 'Mi', 'Do', 'Fr'];
  const STUNDEN = [1,2,3,4,5,6,7,8,9,10];
  const ACCENT = 'var(--ld-primary)';

  // Welle Z1: Zeiten aus lib/zeitraster (je Lehrkraft); fehlende Stunde → [-1, -1]
  const nowMin = new Date().getHours() * 60 + new Date().getMinutes();

  // Welle K3: Datum der Wochentage (laufende Woche), Klassenbuch-Haken aus derselben Quelle wie „Jetzt nachtragen“
  const heuteIsoSp = heuteIso();
  const montagSp = (() => { const d = new Date(heuteIsoSp + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() - ((d.getUTCDay() + 6) % 7)); return d.toISOString().slice(0, 10); })();
  const tagDatum = (wt: number) => { const d = new Date(montagSp + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + wt - 1); return d.toISOString().slice(0, 10); };
  // Ein Haken nur, wenn sicher: vergangene Stunde dieser Woche an einem Schultag, Liste der offenen Stunden vollständig
  const kbStatus = (e: StundenplanEintrag, wt: number, std: number): boolean | null => {
    if (!kbOffen || kbOffen.eintraege.length < kbOffen.gesamt || !e.klasse_id) return null;
    const d = tagDatum(wt);
    if (d > heuteIsoSp || !schultage[d]) return null;
    const z = zeiten[std - 1];
    if (!z || (d === heuteIsoSp && z[1] > nowMin)) return null;
    if ((e as any).created_at && String((e as any).created_at).slice(0, 10) > d) return null;
    return !kbOffen.eintraege.some(o => o.datum === d && o.stunde_nr === std && Number(o.klasse_id) === Number(e.klasse_id));
  };
  // PC: leere Stunden nach der letzten belegten Stunde der Woche ausblenden (über ⋯ einblenden)
  const letzteBelegte = eintraege.reduce((m, e) => Math.max(m, e.stunde), 0);
  const sichtbareStunden = leereZeigen || letzteBelegte === 0 ? STUNDEN : STUNDEN.filter(s => s <= letzteBelegte);
  useEffect(() => {
    menuSetzen?.([
      { label: 'Zeiten ändern', icon: 'schedule', onClick: oeffneUnterrichtszeiten },
      ...(isMobile
        ? [{ label: bearbeiten ? 'Bearbeiten beenden' : 'Stundenplan bearbeiten', icon: bearbeiten ? 'check' : 'edit', onClick: () => setBearbeiten(b => !b) }]
        : [{ label: leereZeigen ? 'Leere Stunden ausblenden' : 'Leere Stunden einblenden', icon: leereZeigen ? 'visibility_off' : 'visibility', onClick: () => setLeereZeigen(v => !v) }]),
    ]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, bearbeiten, leereZeigen]);

  // PC-Zelle: belegt = opake Karte; leer = „+“ nur beim Überfahren
  function ZellInhalt({ e, wt, std }: { e: StundenplanEintrag | null; wt: number; std: number }) {
    const istHeute = wt === heuteWt;
    const [start, end] = zeiten[std - 1] ?? [-1, -1];
    const istAktuell = istHeute && nowMin >= start && nowMin < end;
    if (!e) return (
      <button type="button" onClick={() => zelleOeffnen(wt, std)} className="ld-sp2-leer" aria-label={`${TAGE[wt - 1]}, ${std}. Stunde eintragen`}>
        <MIcon name="add" size={18} />
      </button>
    );
    const kb = kbStatus(e, wt, std);
    return (
      <button type="button" onClick={() => zelleOeffnen(wt, std)} className={`ld-sp2-zelle${istAktuell ? ' ist-jetzt' : ''}`}>
        <b>{e.fach}</b>
        <small>{[e.klasse_name ? `Klasse ${e.klasse_name}` : null, e.raum ? `Raum ${e.raum}` : null].filter(Boolean).join(', ')}</small>
        {istAktuell && <span className="ld-sp2-jetzt">jetzt</span>}
        {!istAktuell && kb && <MIcon name="check_circle" size={16} className="ld-sp2-kb" label="Klassenbuch eingetragen" />}
      </button>
    );
  }

  if (laden) return <LoadingBlock text="Stundenplan wird geladen …" />;

  // Handy: nur Stunden mit Unterricht, Lücken als Linie, „Schluss um …“ nach der letzten
  const tagesStunden = STUNDEN.filter(std => eintragFuer(aktiverTag, std) !== null);
  const freiText = (von: number, bis: number) => von === bis ? `${von}. Stunde frei` : bis === von + 1 ? `${von}. und ${bis}. Stunde frei` : `${von}. bis ${bis}. Stunde frei`;
  const hinweis = rasterStandard && <ZeitrasterHinweis />;

  return (
    <div className="ld-page-enter">
      {isMobile ? (
        <div>
          <div className="ld-sp2-tage" role="tablist" aria-label="Wochentag">
            {TAGE.map((tag, i) => {
              const wt = i + 1;
              return (
                <button key={wt} type="button" role="tab" aria-selected={aktiverTag === wt} onClick={() => setAktiverTag(wt)}
                  className={`ld-sp2-tag${aktiverTag === wt ? ' ist-aktiv' : ''}${wt === heuteWt ? ' ist-heute' : ''}`}>
                  <small>{tag}</small><b>{Number(tagDatum(wt).slice(8, 10))}</b>
                </button>
              );
            })}
          </div>

          {bearbeiten ? (
            <>
              <div className="ld-sp2-bearbeiten"><MIcon name="edit" size={17} />Stundenplan bearbeiten: Stunde antippen<button type="button" className="ld-kl-link" onClick={() => setBearbeiten(false)}>Fertig</button></div>
              <div className="ld-kl-karte">
                {STUNDEN.map((std, idx) => {
                  const e = eintragFuer(aktiverTag, std);
                  const [start] = zeiten[idx] ?? [-1, -1];
                  return (
                    <button key={std} type="button" onClick={() => zelleOeffnen(aktiverTag, std)} className="ld-kl-zeile" style={{ minHeight: 52 }}>
                      <span className="ld-sp2-nr"><b>{std}.</b><small>{start >= 0 ? fmtZeit(start) : ''}</small></span>
                      <span className="ld-kl-zeile__text">
                        <span className="ld-kl-zeile__name" style={{ display: 'block', color: e ? undefined : 'var(--ld-text-tertiary)', fontWeight: e ? 600 : 500 }}>{e ? e.fach : 'Frei'}</span>
                        {e?.klasse_name && <span className="ld-kl-zeile__unter" style={{ display: 'block' }}>Klasse {e.klasse_name}</span>}
                      </span>
                      <MIcon name={e ? 'edit' : 'add'} size={18} className="ld-kl-pfeil" />
                    </button>
                  );
                })}
              </div>
            </>
          ) : tagesStunden.length === 0 ? (
            <div className="ld-kl-karte ld-kt-leer">Kein Unterricht an diesem Tag.</div>
          ) : (
            <div className="ld-sp2-liste">
              {tagesStunden.map((std, i) => {
                const e = eintragFuer(aktiverTag, std)!;
                const z = zeiten[std - 1];
                const istAktuell = aktiverTag === heuteWt && !!z && nowMin >= z[0] && nowMin < z[1];
                const vorher = i > 0 ? tagesStunden[i - 1] : null;
                const kb = kbStatus(e, aktiverTag, std);
                return (
                  <React.Fragment key={std}>
                    {vorher != null && std > vorher + 1 && <div className="ld-sp2-linie"><span>{freiText(vorher + 1, std - 1)}</span></div>}
                    <button type="button" onClick={() => zelleOeffnen(aktiverTag, std)} className={`ld-kl-karte ld-sp2-karte${istAktuell ? ' ist-jetzt' : ''}`}>
                      <span className="ld-sp2-nr"><b>{std}.</b><small>{z ? fmtZeit(z[0]) : ''}</small></span>
                      <span className="ld-sp2-text">
                        <b>{e.fach}</b>
                        <small>{[e.klasse_name ? `Klasse ${e.klasse_name}` : null, z ? `${fmtZeit(z[0])} bis ${fmtZeit(z[1])}` : null, e.raum ? `Raum ${e.raum}` : null].filter(Boolean).join(', ')}</small>
                      </span>
                      {istAktuell ? <span className="ld-sp2-jetzt">jetzt</span>
                        : kb ? <span className="ld-sp2-kbtext"><MIcon name="check_circle" size={16} />Klassenbuch</span> : null}
                    </button>
                  </React.Fragment>
                );
              })}
              {(() => { const z = zeiten[tagesStunden[tagesStunden.length - 1] - 1]; return z ? <div className="ld-sp2-linie"><span>Schluss um {fmtZeit(z[1])}</span></div> : null; })()}
            </div>
          )}
          {hinweis && <div style={{ marginTop: 14 }}>{hinweis}</div>}
        </div>
      ) : (
        /* ── PC: Wochenraster ── */
        <>
          <div className="ld-kl-karte ld-sp2-raster">
            <div className="ld-sp2-gitter">
              <div className="ld-sp2-kopf" />
              {TAGE.map((tag, i) => {
                const wt = i + 1;
                return (
                  <div key={wt} className={`ld-sp2-kopf${wt === heuteWt ? ' ist-heute' : ''}`}>
                    {tag} <span>{datumTTMM(tagDatum(wt))}</span>{wt === heuteWt && <em>Heute</em>}
                  </div>
                );
              })}
              {sichtbareStunden.map(std => (
                <React.Fragment key={std}>
                  <div className="ld-sp2-zeit">
                    <b>{std}.</b>
                    <small>{zeiten[std - 1] ? `${fmtZeit(zeiten[std - 1]![0])} bis ${fmtZeit(zeiten[std - 1]![1])}` : ''}</small>
                  </div>
                  {TAGE.map((_, i) => {
                    const wt = i + 1;
                    return (
                      <div key={wt} className={`ld-sp2-feld${wt === heuteWt ? ' ist-heute' : ''}`}>
                        <ZellInhalt e={eintragFuer(wt, std)} wt={wt} std={std} />
                      </div>
                    );
                  })}
                </React.Fragment>
              ))}
            </div>
          </div>
          {hinweis && <div style={{ marginTop: 14 }}>{hinweis}</div>}
        </>
      )}

      {/* ── Eintrag-Modal ── */}
      <LdSheet open={!!offeneZelle} onClose={() => setOffeneZelle(null)} maxWidth={480}
        kopf={{ titel: `${TAGE[(offeneZelle?.wochentag ?? 1) - 1]}, ${offeneZelle?.stunde}. Stunde`, kontext: offeneZelle?.eintragId ? 'Eintrag bearbeiten' : null }}>
        <div>

            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 13, fontWeight: 700, color: 'var(--ld-text-primary)', display: 'block', marginBottom: 6 }}>Fach *</label>
              <input
                list="sp-faecher-list"
                value={editFach}
                onChange={e => setEditFach(e.target.value)}
                placeholder="z.B. Mathematik"
                style={{ width: '100%', padding: '11px 13px', borderRadius: 'var(--ld-radius-md)' as any, border: 'none', background: 'var(--ld-bg-input)' as any, fontSize: 15, outline: 'none', boxSizing: 'border-box' as const }}
              />
              <datalist id="sp-faecher-list">
                {faecher.map(f => <option key={f} value={f} />)}
              </datalist>
            </div>

            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 13, fontWeight: 700, color: 'var(--ld-text-primary)', display: 'block', marginBottom: 6 }}>Klasse</label>
              <LdAuswahl value={editKlasseId === '' ? '' : String(editKlasseId)} onChange={e => setEditKlasseId(e.target.value === '' ? '' : Number(e.target.value))}>
                <option value="">— Keine Klasse —</option>
                {uniqueKlassen.map(k => <option key={k.klasse_id} value={String(k.klasse_id)}>{k.klasse_name}</option>)}
              </LdAuswahl>
            </div>

            {offeneZelle?.eintragId && (
              <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '10px 12px', borderRadius: 12, background: 'var(--ld-accent-soft)', color: 'var(--ld-text-primary)', fontSize: 13, lineHeight: 1.45, marginBottom: 14 }}>
                <MIcon name="info" size={16} style={{ color: 'var(--ld-primary)', marginTop: 1 }} />
                Gilt ab jetzt. Bestehende Klassenbuch-Einträge bleiben unverändert.
              </div>
            )}

            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 13, fontWeight: 700, color: 'var(--ld-text-primary)', display: 'block', marginBottom: 6 }}>Raum (optional)</label>
              <input
                value={editRaum}
                onChange={e => setEditRaum(e.target.value)}
                placeholder="z.B. 204"
                style={{ width: '100%', padding: '11px 13px', borderRadius: 'var(--ld-radius-md)' as any, border: 'none', background: 'var(--ld-bg-input)' as any, fontSize: 15, outline: 'none', boxSizing: 'border-box' as const }}
              />
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={speichern} disabled={editLaden || !editFach.trim()} style={{
                flex: 1, padding: '13px 0', borderRadius: 'var(--ld-radius-md)' as any, border: 'none',
                background: !editFach.trim() ? 'var(--ld-bg-input)' : ACCENT,
                color: !editFach.trim() ? 'var(--ld-text-secondary)' : 'white',
                fontWeight: 700, fontSize: 15, cursor: !editFach.trim() ? 'default' : 'pointer',
              }}>{editLaden ? 'Speichern …' : 'Speichern'}</button>
              {offeneZelle?.eintragId && (
                <button onClick={loeschen} disabled={editLaden} style={{
                  padding: '13px 16px', borderRadius: 'var(--ld-radius-md)' as any, border: 'none',
                  background: 'var(--ld-danger-soft)', color: 'var(--ld-danger-text)', fontWeight: 700, fontSize: 14, cursor: 'pointer',
                }}>Löschen</button>
              )}
            </div>
          </div>
      </LdSheet>
    </div>
  );
}

// ── Schulrecht-Assistent ───────────────────────────────────────────────────
interface SchulrechtDok { id: number; dateiname: string; dateityp: string; hochgeladen_am: string; }

function SchulrechtAnsicht({ nutzer }: { nutzer: NutzerProfil | null }) {
  const isAdmin = nutzer?.is_admin === true;
  const [frage, setFrage]               = useState('');
  const [antwort, setAntwort]           = useState('');
  const [quellen, setQuellen]           = useState<string[]>([]);
  const [fragenLaden, setFragenLaden]   = useState(false);
  const [fehler, setFehler]             = useState('');
  const [dokumente, setDokumente]       = useState<SchulrechtDok[]>([]);
  const [uploadLaden, setUploadLaden]   = useState(false);
  const [uploadFehler, setUploadFehler] = useState('');
  const [uploadErfolg, setUploadErfolg] = useState('');
  const dateiRef = useRef<HTMLInputElement>(null);
  // Mikrofon
  const [srRecording, setSrRecording]   = useState(false);
  const srRecorderRef = useRef<MediaRecorder | null>(null);
  const srChunksRef   = useRef<Blob[]>([]);
  const isMobile = useIsMobile();
  const [dokOffen, setDokOffen] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/api/schulrecht/dokumente`, { headers: apiHeaders() })
      .then(leseFallback<any[]>([], '/api/schulrecht/dokumente'))
      .then(setDokumente)
      .catch(() => {});
  }, []);

  async function stelleFrage() {
    if (!frage.trim()) return;
    setFragenLaden(true); setAntwort(''); setQuellen([]); setFehler('');
    try {
      // apiFetch übernimmt Kontingent-Meldung + 80%-Warnung (Welle D2)
      const data = await apiPost<any>('/api/schulrecht/frage', { frage: frage.trim() });
      setAntwort(data.antwort ?? '');
      setQuellen(data.quellen ?? []);
    } catch (e: any) {
      setFehler(e.message ?? 'Anfrage fehlgeschlagen.');
    } finally { setFragenLaden(false); }
  }

  async function uploadDokument(file: File) {
    setUploadLaden(true); setUploadFehler(''); setUploadErfolg('');
    try {
      const form = new FormData();
      form.append('datei', file);
      const res = await fetch(`${API_BASE}/api/schulrecht/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${holeToken() ?? ''}` },
        body: form,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.fehler ?? 'Upload fehlgeschlagen.');
      const zeichenText = data.gescannt
        ? 'Gescanntes PDF, kein Text erkennbar'
        : `${data.zeichen?.toLocaleString('de-DE') ?? '?'} Zeichen extrahiert`;
      setUploadErfolg(`${file.name} hochgeladen (${zeichenText})`);
      if (data.hinweis) setUploadFehler(data.hinweis);
      setDokumente(prev => [{ id: data.id, dateiname: data.dateiname, dateityp: data.dateityp, hochgeladen_am: data.hochgeladen_am }, ...prev]);
    } catch (e: any) {
      setUploadFehler(e.message ?? 'Upload fehlgeschlagen.');
    } finally { setUploadLaden(false); if (dateiRef.current) dateiRef.current.value = ''; }
  }

  async function loescheDokument(id: number) {
    if (!(await confirm('Dokument wirklich löschen?', { danger: true, confirmLabel: 'Löschen' }))) return;
    try {
      await apiDelete(`/api/schulrecht/dokumente/${id}`);
      setDokumente(prev => prev.filter(d => d.id !== id));
    } catch (e) { zeigeApiFehler(e, 'Löschen fehlgeschlagen'); }
  }

  return (
    <div className="ld-page-enter">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <span style={{ width: 44, height: 44, borderRadius: 14, flexShrink: 0, background: '#EDEAFA', color: '#6B5FD4', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><MIcon name="balance" size={24} /></span>
        <div>
          <h2 style={{ margin: 0, fontSize: 28, fontWeight: 700, color: 'var(--ld-text-primary)' }}>Schulrecht Hessen</h2>
          <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)', marginTop: 2 }}>KI-Assistent — basierend auf amtlichen Dokumenten</div>
        </div>
      </div>

      {/* ── Admin: Dokumente verwalten (mobil einklappbar, web kompakt) ── */}
      {isAdmin && (
        <div style={{ background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)', padding: '14px 18px', marginBottom: 20, boxShadow: 'var(--ld-shadow-elev-low)', border: '1.5px solid var(--ld-accent-soft)' }}>
          <button onClick={() => isMobile && setDokOffen(o => !o)} aria-expanded={!isMobile || dokOffen}
            style={{ width: '100%', background: 'none', border: 'none', cursor: isMobile ? 'pointer' : 'default', display: 'flex', alignItems: 'center', gap: 8, padding: 0, textAlign: 'left' }}>
            <MIcon name="folder" size={15} color="var(--ld-primary)" />
            <span style={{ fontWeight: 700, fontSize: 14, color: 'var(--ld-primary)' }}>{isMobile ? `${dokumente.length} hinterlegt` : 'Dokumente verwalten'}</span>
            <span style={{ fontSize: 11, fontWeight: 400, color: 'var(--ld-text-tertiary)' }}>· nur Admin</span>
            {isMobile && <MIcon name="expand_more" size={20} color="var(--ld-text-secondary)" style={{ marginLeft: 'auto', transform: dokOffen ? 'rotate(180deg)' : 'none', transition: '.15s' }} />}
          </button>

          {(!isMobile || dokOffen) && (
            <div style={{ marginTop: 14 }}>
              {/* Upload (dezent) */}
              <input ref={dateiRef} type="file" accept=".pdf,.docx" style={{ display: 'none' }}
                onChange={e => { const f = e.target.files?.[0]; if (f) uploadDokument(f); }} />
              <button onClick={() => dateiRef.current?.click()} disabled={uploadLaden}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 'var(--ld-radius-pill)', border: '1.5px dashed var(--ld-field-border)', background: 'transparent', color: uploadLaden ? 'var(--ld-text-tertiary)' : 'var(--ld-accent)', fontSize: 13, fontWeight: 600, cursor: uploadLaden ? 'default' : 'pointer', marginBottom: 10 }}>
                {uploadLaden ? <><span className="ld-mail-spin" style={{ display: 'inline-flex' }}><MIcon name="progress_activity" size={15} /></span> Wird verarbeitet …</> : <><MIcon name="upload_file" size={15} /> PDF oder DOCX hochladen</>}
              </button>
              {uploadFehler && <div style={{ background: '#FEE2E2', color: '#991B1B', borderRadius: 'var(--ld-radius-sm)', padding: '8px 12px', fontSize: 13, marginBottom: 8 }}>{uploadFehler}</div>}
              {uploadErfolg && <div style={{ background: '#D1FAE5', color: '#065F46', borderRadius: 'var(--ld-radius-sm)', padding: '8px 12px', fontSize: 13, marginBottom: 8 }}>{uploadErfolg}</div>}

              {/* Dokument-Chips (file-text-Icon + Hover-Löschen) */}
              {dokumente.length > 0 ? (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {dokumente.map(d => (
                    <span key={d.id} className="ld-sr-doc-chip">
                      <MIcon name="description" size={15} color="#6B5FD4" />
                      <span style={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.dateiname}</span>
                      <button onClick={() => loescheDokument(d.id)} aria-label={`${d.dateiname} löschen`} title="Löschen" className="ld-sr-doc-del"><MIcon name="close" size={14} /></button>
                    </span>
                  ))}
                </div>
              ) : (
                <div style={{ fontSize: 13, color: 'var(--ld-text-tertiary)', textAlign: 'center', paddingTop: 4 }}>Noch keine Dokumente hochgeladen</div>
              )}
            </div>
          )}
        </div>
      )}

      {/* ── Chat-Interface ── */}
      <div style={{ background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)' as any, overflow: 'hidden', boxShadow: 'var(--ld-shadow-md)' }}>
        {/* Nachrichten-Bereich */}
        <div className="ld-chat-container">
          {/* Platzhalter — wenn noch keine Interaktion */}
          {!frage && !antwort && !fragenLaden && !fehler && (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, gap: 'var(--ld-space-md)', color: 'var(--ld-text-tertiary)', paddingTop: 'var(--ld-space-xl)' }}>
              <span style={{ opacity: 0.55, color: 'var(--ld-primary)' }}><MIcon name="balance" size={40} /></span>
              <div style={{ textAlign: 'center', fontSize: 'var(--ld-font-size-sm)' as any, lineHeight: 'var(--ld-line-height-normal)' as any }}>
                Stellen Sie eine Frage zum Schulrecht Hessen
                {dokumente.length === 0 && <div style={{ marginTop: 6, color: 'var(--ld-warning-text)', fontSize: 'var(--ld-font-size-xs)' as any, display: 'inline-flex', alignItems: 'center', gap: 4 }}><MIcon name="warning" size={13} />Noch keine Dokumente vorhanden.</div>}
              </div>
            </div>
          )}

          {/* User-Bubble — sobald Interaktion begonnen hat */}
          {(antwort || fragenLaden || fehler) && frage && (
            <div className="ld-chat-user-row">
              <div className="ld-chat-bubble-user" style={{ background: 'linear-gradient(135deg,#6B5FD4,#4A3FB0)', color: '#fff' }}>{frage}</div>
            </div>
          )}

          {/* KI antwortet / lädt */}
          {fragenLaden && (
            <div className="ld-chat-typing">
              <div className="ld-chat-ai-icon"><MIcon name="balance" size={18} /></div>
              <div className="ld-chat-typing-dots">
                <div className="ld-chat-typing-dot" />
                <div className="ld-chat-typing-dot" />
                <div className="ld-chat-typing-dot" />
              </div>
            </div>
          )}

          {/* KI-Antwort */}
          {antwort && !fragenLaden && (
            <div className="ld-chat-ai-row">
              <div className="ld-chat-ai-icon"><MIcon name="balance" size={18} /></div>
              <div className="ld-chat-bubble-ai">
                <div style={{ fontSize: 'var(--ld-font-size-sm)' as any, lineHeight: 'var(--ld-line-height-relaxed)' as any, whiteSpace: 'pre-wrap' }}>{antwort}</div>
                {quellen.length > 0 && (
                  <div style={{ marginTop: 'var(--ld-space-md)', display: 'flex', flexWrap: 'wrap', gap: 'var(--ld-space-xs)' }}>
                    {quellen.map((q, i) => (
                      <span key={i} className="ld-chat-source-ref" style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#EDEAFA', color: '#5A4FC4' }}><MIcon name="description" size={13} />{q}</span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Fehler */}
          {fehler && !fragenLaden && (
            <div className="ld-chat-ai-row">
              <div className="ld-chat-ai-icon"><MIcon name="error" size={18} /></div>
              <div className="ld-chat-bubble-ai" style={{ borderLeft: '3px solid var(--ld-danger)' }}>
                <span style={{ color: 'var(--ld-danger-text)', fontSize: 'var(--ld-font-size-sm)' as any }}>{fehler}</span>
              </div>
            </div>
          )}
        </div>

        {/* Eingabe-Bereich */}
        <div style={{ padding: 'var(--ld-space-md)' as any, borderTop: '1px solid var(--ld-border)' }}>
          <div className="ld-chat-input-wrapper">
            <textarea
              value={frage}
              onChange={e => setFrage(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); stelleFrage(); } }}
              placeholder="Stellen Sie eine Frage zum Schulrecht Hessen…"
              rows={2}
              disabled={fragenLaden}
              style={{
                flex: 1, border: 'none', outline: 'none', background: 'transparent',
                fontSize: 'var(--ld-font-size-base)' as any, fontFamily: 'inherit',
                lineHeight: 'var(--ld-line-height-normal)' as any,
                resize: 'none' as const, color: 'var(--ld-text-primary)' as any,
                minHeight: 44,
              }}
            />
            <button
              className="ld-chat-mic-btn"
              title={srRecording ? 'Aufnahme stoppen' : 'Frage diktieren'}
              style={{ background: srRecording ? 'var(--ld-danger-soft, #FEE2E2)' : undefined, color: srRecording ? 'var(--ld-danger, #DC2626)' : undefined, animation: srRecording ? 'ld-pulse-recording 1.5s ease-in-out infinite' : 'none' }}
              onClick={async () => {
                if (srRecording) {
                  srRecorderRef.current?.stop();
                  setSrRecording(false);
                  return;
                }
                let stream: MediaStream;
                try { stream = await mikrofonAnfragen(); }
                catch (err) { zeigeMikrofonFehler(err, { stattdessenTippen: () => fokussiere('.ld-chat-input-wrapper textarea') }); return; }
                const kandidaten = ['audio/webm;codecs=opus','audio/webm','audio/ogg;codecs=opus','audio/mp4'];
                const mime = kandidaten.find(m => MediaRecorder.isTypeSupported(m)) ?? '';
                const ext  = mime.includes('ogg') ? 'ogg' : mime.includes('mp4') ? 'mp4' : 'webm';
                let recorder: MediaRecorder;
                try { recorder = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream); }
                catch { stream.getTracks().forEach(t => t.stop()); toast('Aufnahme nicht möglich', 'error'); return; }
                srChunksRef.current = [];
                recorder.ondataavailable = e => { if (e.data.size > 0) srChunksRef.current.push(e.data); };
                recorder.onstop = async () => {
                  stream.getTracks().forEach(t => t.stop());
                  const blob = new Blob(srChunksRef.current, { type: recorder.mimeType || mime });
                  if (blob.size === 0) { toast('Aufnahme leer', 'error'); return; }
                  const form = new FormData();
                  form.append('audio', blob, `sr.${ext}`);
                  try {
                    const r = await fetch(`${API_BASE}/api/transkribiere`, { method: 'POST', headers: { Authorization: `Bearer ${holeToken() ?? ''}` }, body: form });
                    if (!r.ok) throw new Error('Transkription fehlgeschlagen');
                    const { text } = await r.json();
                    if (text?.trim()) setFrage(prev => (prev ? prev + ' ' : '') + text.trim());
                  } catch { toast('Transkription fehlgeschlagen', 'error'); }
                };
                srRecorderRef.current = recorder;
                setSrRecording(true);
                recorder.start();
              }}
            >{srRecording ? <MIcon name="stop" size={18} /> : <MIcon name="mic" size={18} />}</button>
            <button onClick={stelleFrage} disabled={fragenLaden || !frage.trim()} style={{
              width: 40, height: 40, minWidth: 40, borderRadius: 'var(--ld-radius-full)' as any,
              border: 'none', flexShrink: 0,
              background: (!frage.trim() || fragenLaden) ? 'var(--ld-bg-muted)' : 'linear-gradient(135deg,#6B5FD4,#4A3FB0)',
              color: (!frage.trim() || fragenLaden) ? 'var(--ld-text-tertiary)' : 'white',
              cursor: !frage.trim() || fragenLaden ? 'default' : 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'var(--ld-transition-fast)' as any,
            }}><MIcon name="arrow_upward" size={20} /></button>
          </div>
        </div>
      </div>

      <div className="ld-chat-disclaimer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
        <MIcon name="info" size={14} />
        Die KI kann Fehler machen. Bei rechtlichen Fragen immer die Originalquellen prüfen.
      </div>
    </div>
  );
}

// ── Schultermine / Kalender ────────────────────────────────────────────────
const KAT_FARBEN: Record<string, string> = {
  konferenz:    '#4ECDC4',
  eltern:       '#45B7D1',
  klassenfahrt: '#56CCB5',
  zeugnis:      '#F7C59F',
  ferien:       '#74B9FF',
  ausflug:      '#FB923C',
  klassenarbeit:'#DC2626',
  sonstiges:    '#A29BFE',
};
const KAT_LABELS: Record<string, string> = {
  konferenz:    'Konferenz',
  eltern:       'Elterngespräch',
  klassenfahrt: 'Klassenfahrt',
  zeugnis:      'Zeugnistag',
  ferien:       'Ferien',
  ausflug:      'Ausflug',
  klassenarbeit:'Klassenarbeit',
  sonstiges:    'Sonstiges',
};

interface Schultermin {
  id: number;
  datum: string;
  datum_ende?: string | null;
  titel: string;
  beschreibung?: string | null;
  kategorie: string;
  klasse_id?: number | null;
  klasse_name?: string | null;
  ausflug_kosten?: number | null;
  ausflug_zahlung_bis?: string | null;
  ka_fach?: string | null;
  ka_thema?: string | null;
  // Welle B2: bestätigter Eltern-Termin (Kind) und ob das Gespräch dazu dokumentiert ist
  eltern_schueler_id?: number | null;
  gespraech_dokumentiert?: 0 | 1 | null;
}

function KalenderAnsicht() {
  const heute = new Date().toISOString().split('T')[0];
  const [termine, setTermine] = useState<Schultermin[]>([]);
  const [meineKlassen, setMeineKlassen] = useState<KlasseFachEintrag[]>([]);
  const [laden, setLaden] = useState(true);

  const now = new Date();
  const [viewYear, setViewYear]   = useState(now.getFullYear());
  const [viewMonth, setViewMonth] = useState(now.getMonth()); // 0-11

  const [selectedDay, setSelectedDay]     = useState<string | null>(heute);
  const isMobile = useIsMobile();
  // Welle K3: Handy Standard „Liste“, PC Standard „Monat“ (Liste · Woche · Monat)
  const [view, setView] = useState<'liste' | 'woche' | 'monat'>(() => (window.innerWidth < 1024 ? 'liste' : 'monat'));
  // Welle K3: schulfreie Tage (schraffiert), fehlende Zustimmungen aktiver Ausflüge (EINE Abfrage), Stundenplan für die Tageskarte
  const [schulfrei, setSchulfrei] = useState<{ datum: string; bezeichnung: string }[]>([]);
  const [ausflugOffen, setAusflugOffen] = useState<Record<number, number>>({});
  const [stundenplan, setStundenplan] = useState<StundenplanEintrag[]>([]);
  const { zeiten: zeitenSp } = useZeitraster();
  useEffect(() => {
    apiFetch<{ datum: string; bezeichnung: string }[]>('/api/schulfreie-tage').then(setSchulfrei).catch(() => {});
    apiFetch<{ aktive_ausfluege: { termin_id: number; stats: { offen_zustimmung: number } }[] }>('/api/ausfluege/aktiv')
      .then(r => setAusflugOffen(Object.fromEntries((r.aktive_ausfluege ?? []).map(a => [a.termin_id, a.stats?.offen_zustimmung ?? 0])))).catch(() => {});
    apiFetch<StundenplanEintrag[]>('/api/stundenplan').then(sp => setStundenplan(Array.isArray(sp) ? sp : [])).catch(() => {});
  }, []);
  const [editModal,   setEditModal]       = useState<Schultermin | 'neu' | null>(null);
  const [editDatum,       setEditDatum]       = useState('');
  const [editDatumEnde,   setEditDatumEnde]   = useState('');
  const [endeOffen,       setEndeOffen]       = useState(false);
  const [editTitel,       setEditTitel]       = useState('');
  const [editKat,         setEditKat]         = useState('sonstiges');
  const [editKlasseId,    setEditKlasseId]    = useState<number | ''>('');
  const [editBeschreibung,setEditBeschreibung]= useState('');
  const [editLaden,       setEditLaden]       = useState(false);
  // Ausflug-spezifisch (M8e)
  const [ausflugKosten,     setAusflugKosten]     = useState('');
  const [ausflugZahlungBis, setAusflugZahlungBis] = useState('');
  const [alleSchueler,      setAlleSchueler]      = useState<{ id: number; vorname: string; nachname: string; klasse_id: number }[]>([]);
  const [ausflugAktiv,      setAusflugAktiv]      = useState<Set<number>>(new Set());
  // Klassenarbeit-spezifisch (D3)
  const [kaFach,  setKaFach]  = useState('');
  const [kaThema, setKaThema] = useState('');

  useEffect(() => {
    Promise.all([
      fetch(`${API_BASE}/api/schultermine`,  { headers: apiHeaders() }).then(leseFallback<any[]>([], '/api/schultermine')),
      fetch(`${API_BASE}/api/meine-klassen`, { headers: apiHeaders() }).then(leseFallback<any[]>([], '/api/meine-klassen')),
    ]).then(([t, k]) => { setTermine(t); setMeineKlassen(k); setLaden(false); })
      .catch(() => setLaden(false));

    // Hessen Ferien einmalig seeden
    const seedKey = 'ld-ferien-seeded-v1';
    if (!localStorage.getItem(seedKey)) {
      fetch(`${API_BASE}/api/schultermine/seed-ferien`, { method: 'POST', headers: apiHeaders() })
        .then(leseFallback<any>(null, '/api/schultermine/seed-ferien'))
        .then(data => {
          localStorage.setItem(seedKey, '1');
          if (data?.hinzugefuegt > 0) {
            fetch(`${API_BASE}/api/schultermine`, { headers: apiHeaders() })
              .then(leseFallback<any[]>([], '/api/schultermine')).then(setTermine).catch(() => {});
          }
        }).catch(() => {});
    }
  }, []);

  // Welle U5: Sprung "diesen Termin bearbeiten" (Heute, Klassenarbeit-Karte, Ausflug-Detail).
  // Ziel beim Einhängen abholen, nach dem Laden den Monat des Termins zeigen und den
  // bestehenden Dialog öffnen. Nach dem Schließen ggf. zurück zur Herkunft.
  const [terminZiel, setTerminZiel] = useState<{ terminId: number; zurueck: (() => void) | null } | null>(null);
  const rueckkehrRef = useRef<(() => void) | null>(null);
  const terminZielErledigt = useRef(false);
  useEffect(() => {
    const z = nimmTerminZiel();
    if (z) { setTerminZiel(z); rueckkehrRef.current = z.zurueck; }
  }, []);
  useEffect(() => {
    if (!terminZiel || terminZielErledigt.current || laden) return;
    terminZielErledigt.current = true;
    const t = termine.find(x => x.id === terminZiel.terminId);
    if (!t) { rueckkehrRef.current = null; toast('Termin nicht gefunden.', 'info'); return; }
    const d = new Date((t.datum ?? '').slice(0, 10) + 'T12:00:00');
    setViewYear(d.getFullYear()); setViewMonth(d.getMonth()); setSelectedDay((t.datum ?? '').slice(0, 10));
    openEdit(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [laden, termine, terminZiel]);
  const editWarOffen = useRef(false);
  useEffect(() => {
    if (editWarOffen.current && editModal === null && rueckkehrRef.current) {
      const zurueck = rueckkehrRef.current; rueckkehrRef.current = null; zurueck();
    }
    editWarOffen.current = editModal !== null;
  }, [editModal]);

  // Alle Schüler einmalig laden (für Ausflug-Teilnehmer-Auswahl)
  useEffect(() => {
    fetch(`${API_BASE}/api/schueler`, { headers: apiHeaders() })
      .then(leseFallback<any[]>([], '/api/schueler'))
      .then((data: any[]) => setAlleSchueler(data.map(s => ({ id: s.id, vorname: s.vorname, nachname: s.nachname, klasse_id: s.klasse_id }))))
      .catch(() => {});
  }, []);

  // Teilnehmer-Liste der gewählten Klasse (bei Ausflug)
  const ausflugSchueler = editKlasseId !== ''
    ? alleSchueler.filter(s => s.klasse_id === Number(editKlasseId)).sort((a, b) => a.nachname.localeCompare(b.nachname))
    : [];

  // Fächer der gewählten Klasse, die DIESE Lehrkraft unterrichtet (bei Klassenarbeit)
  const kaFaecher = editKlasseId !== ''
    ? Array.from(new Set(meineKlassen.filter(k => k.klasse_id === Number(editKlasseId)).map(k => k.fach).filter(Boolean)))
    : [];

  // Bei Klassenwechsel im Ausflug-Modus: alle Schüler default aktiv
  useEffect(() => {
    if (editKat === 'ausflug' && editKlasseId !== '') {
      setAusflugAktiv(new Set(alleSchueler.filter(s => s.klasse_id === Number(editKlasseId)).map(s => s.id)));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editKlasseId, editKat, alleSchueler]);

  function getTermineForDay(day: string): Schultermin[] {
    return termine.filter(t =>
      t.datum_ende
        ? ((t.datum ?? '').substring(0, 10) <= day && (t.datum_ende ?? '').substring(0, 10) >= day)
        : (t.datum ?? '').substring(0, 10) === day
    );
  }

  function calDays(): (string | null)[] {
    const firstDay = new Date(viewYear, viewMonth, 1);
    let offset = firstDay.getDay() - 1;
    if (offset < 0) offset = 6;
    const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
    const days: (string | null)[] = Array(offset).fill(null);
    for (let d = 1; d <= daysInMonth; d++) {
      days.push(`${viewYear}-${String(viewMonth + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`);
    }
    while (days.length % 7 !== 0) days.push(null);
    return days;
  }

  function prevMonth() { if (viewMonth === 0) { setViewMonth(11); setViewYear(y => y - 1); } else setViewMonth(m => m - 1); }
  function nextMonth() { if (viewMonth === 11) { setViewMonth(0); setViewYear(y => y + 1); } else setViewMonth(m => m + 1); }

  // ── View-Helfer (rein präsentational, keine neue Datenquelle) ──────────────
  const ymd = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  function shiftDay(base: string, n: number): string { const d = new Date(base + 'T12:00:00'); d.setDate(d.getDate() + n); return ymd(d); }
  function weekDaysOf(base: string): string[] {
    const d = new Date(base + 'T12:00:00'); let off = d.getDay() - 1; if (off < 0) off = 6;
    const mon = new Date(d); mon.setDate(d.getDate() - off);
    return Array.from({ length: 7 }, (_, i) => { const x = new Date(mon); x.setDate(mon.getDate() + i); return ymd(x); });
  }

  function openNeu(datum: string) {
    setEditDatum(datum); setEditDatumEnde(''); setEndeOffen(false); setEditTitel('');
    setEditKat('sonstiges'); setEditKlasseId(''); setEditBeschreibung('');
    setAusflugKosten(''); setAusflugZahlungBis(''); setAusflugAktiv(new Set());
    setKaFach(''); setKaThema('');
    setEditModal('neu');
  }
  function openEdit(t: Schultermin) {
    // Welle B3: Termine mit Uhrzeit (z. B. bestätigte Eltern-Termine) als Datum + Uhrzeit bearbeiten
    const mitZeit = (v: string | null | undefined) => (v && v.length > 10 ? v.slice(0, 16) : v ?? '');
    setEditDatum(mitZeit(t.datum)); setEditDatumEnde(mitZeit(t.datum_ende)); setEndeOffen(false);
    setEditTitel(t.titel); setEditKat(t.kategorie);
    setEditKlasseId(t.klasse_id ?? ''); setEditBeschreibung(t.beschreibung ?? '');
    setAusflugKosten(t.ausflug_kosten != null ? String(t.ausflug_kosten) : '');
    setAusflugZahlungBis(t.ausflug_zahlung_bis ?? '');
    setKaFach(t.ka_fach ?? ''); setKaThema(t.ka_thema ?? '');
    setEditModal(t);
  }

  async function saveTermin() {
    if (!editTitel.trim() || !editDatum) return;
    const isNeu = editModal === 'neu';
    const istAusflug = editKat === 'ausflug';
    const istKA      = editKat === 'klassenarbeit';
    // Ausflug-Validierung (nur bei Neuanlage relevant für Teilnehmer)
    if (istAusflug) {
      if (editKlasseId === '') { toast('Bitte eine Klasse für den Ausflug wählen.', 'error'); return; }
      if (isNeu && ausflugAktiv.size === 0) { toast('Bitte mindestens einen Teilnehmer auswählen.', 'error'); return; }
    }
    // Klassenarbeit-Validierung
    if (istKA) {
      if (editKlasseId === '') { toast('Bitte eine Klasse für die Klassenarbeit wählen.', 'error'); return; }
      if (!kaFach.trim()) { toast('Bitte ein Fach für die Klassenarbeit wählen.', 'error'); return; }
    }
    setEditLaden(true);
    const body: any = {
      // Welle B3: Uhrzeit wie gespeichert (JJJJ-MM-TTTHH:MM:SS)
      datum: editDatum.length === 16 ? `${editDatum}:00` : editDatum,
      datum_ende: editDatumEnde ? (editDatumEnde.length === 16 ? `${editDatumEnde}:00` : editDatumEnde) : null, titel: editTitel.trim(),
      beschreibung: editBeschreibung.trim() || null, kategorie: editKat,
      klasse_id: editKlasseId !== '' ? editKlasseId : null,
    };
    if (istAusflug) {
      body.ausflug_kosten = ausflugKosten.trim() ? Number(ausflugKosten.replace(',', '.')) : null;
      body.ausflug_zahlung_bis = ausflugZahlungBis || null;
      if (isNeu) body.teilnehmer_schueler_ids = Array.from(ausflugAktiv);
    }
    if (istKA) {
      body.ka_fach = kaFach.trim() || null;
      body.ka_thema = kaThema.trim() || null;
    }
    try {
      const saved = isNeu
        ? await apiPost<Schultermin>('/api/schultermine', body)
        : await apiPut<Schultermin>(`/api/schultermine/${(editModal as Schultermin).id}`, body);
      setTermine(prev => isNeu ? [...prev, saved] : prev.map(t => t.id === saved.id ? saved : t));
      setEditModal(null);
    } catch (err) {
      zeigeApiFehler(err, 'Speichern fehlgeschlagen');
    } finally { setEditLaden(false); }
  }

  async function deleteTermin(id: number) {
    try {
      await apiDelete(`/api/schultermine/${id}`);
      setTermine(prev => prev.filter(t => t.id !== id));
      rueckkehrRef.current = null; // gelöschter Termin: im Kalender bleiben
      setEditModal(null);
    } catch (err) { zeigeApiFehler(err, 'Löschen fehlgeschlagen'); }
  }

  const WOCHENTAGE_KURZ = ['Mo','Di','Mi','Do','Fr','Sa','So'];
  const MONATE = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  const days = calDays();
  const uniqueKlassen = eindeutigeKlassen(meineKlassen);
  const anchorDay = selectedDay ?? heute;
  const weekDays = weekDaysOf(anchorDay);

  // Welle K3: Liste (Handy Standard) · Woche · Monat; Liste und Monat blättern monatsweise, die Woche wochenweise
  function navPrev() { if (view === 'woche') setSelectedDay(s => shiftDay(s ?? heute, -7)); else prevMonth(); }
  function navNext() { if (view === 'woche') setSelectedDay(s => shiftDay(s ?? heute, 7)); else nextMonth(); }
  function zuHeute() { const d = new Date(heute + 'T12:00:00'); setViewYear(d.getFullYear()); setViewMonth(d.getMonth()); setSelectedDay(heute); }
  const navLabel = view === 'woche'
    ? (() => { const a = new Date(weekDays[0] + 'T12:00:00'), b = new Date(weekDays[6] + 'T12:00:00'); return `${a.getDate()}. bis ${b.getDate()}. ${MONATE[b.getMonth()]}`; })()
    : `${MONATE[viewMonth]} ${viewYear}`;

  // Uhrzeit nur, wenn der Termin eine hat (JJJJ-MM-TTTHH:MM)
  const uhr = (v?: string | null) => (v && v.length > 10 ? v.slice(11, 16) : null);
  const tagVon = (v?: string | null) => (v ?? '').slice(0, 10);
  // Ferien und schulfreie Tage: schraffiert mit Namen statt als Termin
  const freiAm = (day: string): string | null => {
    const f = termine.find(t => t.kategorie === 'ferien' && tagVon(t.datum) <= day && tagVon(t.datum_ende || t.datum) >= day);
    if (f) return f.titel;
    return schulfrei.find(s => s.datum === day)?.bezeichnung ?? null;
  };
  const termineAm = (day: string) => getTermineForDay(day).filter(t => t.kategorie !== 'ferien')
    .sort((a, b) => (uhr(a.datum) ?? '00:00').localeCompare(uhr(b.datum) ?? '00:00'));
  const kindName = (id?: number | null) => { const s = id ? alleSchueler.find(x => x.id === id) : null; return s ? `${s.vorname} ${s.nachname}` : null; };
  const oeffneTermin = (t: Schultermin) => (t.kategorie === 'ausflug' ? openAusflugDetail(t.id) : openEdit(t));

  // Ein Termin als Zeile: Titel, Uhrzeit, Kategorie als Punkt mit Namen, Klasse/Kind, fehlende Zustimmungen
  function terminZeile(t: Schultermin, mitZeitLinks = false) {
    const von = uhr(t.datum), bis = uhr(t.datum_ende);
    const mehrtaegig = !!t.datum_ende && tagVon(t.datum_ende) !== tagVon(t.datum);
    const zeit = von ? (bis && !mehrtaegig ? `${von} bis ${bis}` : von) : mehrtaegig ? `bis ${datumTTMM(tagVon(t.datum_ende))}` : 'ganztägig';
    const kind = kindName(t.eltern_schueler_id);
    const fehlen = t.kategorie === 'ausflug' ? (ausflugOffen[t.id] ?? 0) : 0;
    return (
      <button key={t.id} type="button" className="ld-kal-zeile" onClick={() => oeffneTermin(t)}>
        {mitZeitLinks && <span className="ld-kal-zeile__uhr">{von ?? 'ganztägig'}</span>}
        <span className="ld-kal-zeile__text">
          <b>{t.titel}{t.gespraech_dokumentiert === 1 && <span className="ld-kal-doku"><MIcon name="check" size={13} />dokumentiert</span>}</b>
          <small>
            {!mitZeitLinks && <span>{zeit}</span>}
            {mitZeitLinks && bis && !mehrtaegig && <span>bis {bis}</span>}
            {t.klasse_name && !kind && <span>{t.klasse_name}</span>}
            <span className="ld-kal-kat"><i style={{ background: KAT_FARBEN[t.kategorie] ?? 'var(--ld-text-tertiary)' }} />{KAT_LABELS[t.kategorie] ?? t.kategorie}</span>
            {kind && <span className="ld-ta-chip">{kind}{t.klasse_name ? `, ${t.klasse_name}` : ''}</span>}
          </small>
          {fehlen > 0 && <span className="ld-kal-fehlen">{fehlen} {fehlen === 1 ? 'Zustimmung fehlt' : 'Zustimmungen fehlen'}</span>}
        </span>
      </button>
    );
  }
  const datumsBlock = (day: string) => {
    const d = new Date(day + 'T12:00:00');
    return (
      <span className={`ld-mt-datum${day === heute ? ' ist-heute' : ''}`}>
        <small>{day === heute ? 'Heute' : WOCHENTAGE_KURZ[(d.getDay() + 6) % 7]}</small><b>{d.getDate()}</b>
      </span>
    );
  };

  // Liste: Tage des Monats mit Terminen (im laufenden Monat ab heute); mehrtägige nur am ersten sichtbaren Tag
  const listenTage = (() => {
    const monatsTage = days.filter((x): x is string => !!x);
    const ab = heute.slice(0, 7) === `${viewYear}-${String(viewMonth + 1).padStart(2, '0')}` ? heute : monatsTage[0];
    const gezeigt = new Set<number>();
    const aus: { day: string; termine: Schultermin[] }[] = [];
    for (const day of monatsTage.filter(x => x >= ab)) {
      const liste = getTermineForDay(day).filter(t => !gezeigt.has(t.id))
        .sort((a, b) => (uhr(a.datum) ?? '00:00').localeCompare(uhr(b.datum) ?? '00:00'));
      liste.forEach(t => gezeigt.add(t.id));
      if (liste.length) aus.push({ day, termine: liste });
    }
    return aus;
  })();

  // Tageskarte (PC) und „Als Nächstes“
  const tagTermine = termineAm(anchorDay);
  const tagFrei = freiAm(anchorDay);
  const wtAnker = ((new Date(anchorDay + 'T12:00:00').getDay() + 6) % 7) + 1;
  const tagUnterricht = wtAnker <= 5 && !tagFrei ? stundenplan.filter(s => s.wochentag === wtAnker).sort((a, b) => a.stunde - b.stunde) : [];
  const naechste = termine.filter(t => t.kategorie !== 'ferien' && tagVon(t.datum) >= heute && !(tagVon(t.datum) === anchorDay))
    .sort((a, b) => (a.datum ?? '').localeCompare(b.datum ?? '')).slice(0, 2);

  if (laden) return <LoadingBlock text="Kalender wird geladen …" />;

  const umschalter = (
    <div className="ld-kl-umschalter" role="group" aria-label="Ansicht">
      {(isMobile ? (['liste', 'monat'] as const) : (['liste', 'woche', 'monat'] as const)).map(v => (
        <button key={v} type="button" aria-pressed={view === v} onClick={() => setView(v)}>{v === 'liste' ? 'Liste' : v === 'woche' ? 'Woche' : 'Monat'}</button>
      ))}
    </div>
  );
  const blaettern = (
    <div className="ld-mt-monat" style={{ margin: 0 }}>
      <button type="button" onClick={navPrev} aria-label="Zurück" className="ld-kt-pfeil"><MIcon name="chevron_left" size={20} /></button>
      <span className="ld-mt-monat__text">{navLabel}</span>
      <button type="button" onClick={navNext} aria-label="Weiter" className="ld-kt-pfeil"><MIcon name="chevron_right" size={20} /></button>
    </div>
  );

  const listeAnsicht = listenTage.length === 0 ? (
    <div className="ld-kl-karte ld-kt-leer">
      {heute.slice(0, 7) === `${viewYear}-${String(viewMonth + 1).padStart(2, '0')}` ? `Keine Termine mehr im ${MONATE[viewMonth]}.` : `Keine Termine im ${MONATE[viewMonth]}.`}
      <div><button type="button" className="ld-kl-link" style={{ marginTop: 8 }} onClick={nextMonth}>Weiter zum {MONATE[(viewMonth + 1) % 12]}<MIcon name="chevron_right" size={17} /></button></div>
    </div>
  ) : (
    <div className="ld-kl-karte">
      {listenTage.map(({ day, termine: ts }, i) => (
        <div key={day} className={`ld-kal-tag${i > 0 ? ' ld-kl-trenn' : ''}`}>
          {datumsBlock(day)}
          <div className="ld-kal-tag__termine">{ts.map(t => terminZeile(t))}</div>
        </div>
      ))}
    </div>
  );

  const tageskarte = (
    <div className="ld-kl-karte ld-kal-karte">
      <div className="ld-kal-karte__kopf">
        <b>{new Date(anchorDay + 'T12:00:00').toLocaleDateString('de-DE', { weekday: 'long' })}, {datumTTMM(anchorDay)}</b>
        {anchorDay === heute && <span className="ld-kt-heute">Heute</span>}
      </div>
      <div className="ld-kal-karte__sub">
        {tagFrei ? tagFrei : `${tagTermine.length} ${tagTermine.length === 1 ? 'Termin' : 'Termine'}${tagUnterricht.length ? `, ${tagUnterricht.length} ${tagUnterricht.length === 1 ? 'Stunde' : 'Stunden'} Unterricht` : ''}`}
      </div>
      {tagTermine.length > 0 && (
        <>
          <div className="ld-kal-karte__abschnitt">Termine</div>
          {tagTermine.map(t => terminZeile(t, true))}
        </>
      )}
      {tagUnterricht.length > 0 && (
        <>
          <div className="ld-kal-karte__abschnitt">Dein Unterricht laut Stundenplan</div>
          {tagUnterricht.map(s => (
            <div key={s.id} className="ld-kal-stunde">
              <span className="ld-kw-nr">{s.stunde}.</span>
              <span>{s.fach}{s.klasse_name ? `, ${s.klasse_name}` : ''}</span>
              <small>{zeitenSp[s.stunde - 1] ? fmtZeit(zeitenSp[s.stunde - 1]![0]) : ''}</small>
            </div>
          ))}
        </>
      )}
      <button type="button" className="ld-kl-link" style={{ marginTop: 12 }} onClick={() => openNeu(anchorDay)}><MIcon name="add" size={17} />Termin an diesem Tag</button>
    </div>
  );

  return (
    <div className="ld-page-enter">
      {/* Werkzeugzeile: Handy Monat + Liste|Monat + Hauptknopf; PC Monat, Heute, Liste · Woche · Monat, „+ Termin“ */}
      {isMobile ? (
        <>
          <div className="ld-kal-werkzeug">{blaettern}{umschalter}</div>
          <button type="button" className="ld-kl-haupt" style={{ width: '100%', margin: '10px 0 14px' }} onClick={() => openNeu(selectedDay ?? heute)}><MIcon name="add" size={19} />Termin</button>
        </>
      ) : (
        <div className="ld-kal-werkzeug">
          {blaettern}
          <button type="button" className="ld-kl-zweit" onClick={zuHeute}>Heute</button>
          <span style={{ flex: 1 }} />
          {umschalter}
          <button type="button" className="ld-kl-haupt" onClick={() => openNeu(selectedDay ?? heute)}><MIcon name="add" size={19} />Termin</button>
        </div>
      )}

      {view === 'liste' && (isMobile ? listeAnsicht : (
        <div className="ld-kal-pc"><div>{listeAnsicht}</div><div>{tageskarte}</div></div>
      ))}

      {view === 'monat' && (
        <div className={isMobile ? undefined : 'ld-kal-pc'}>
          <div className="ld-kl-karte ld-kal-raster">
            <div className="ld-kal-gitter">
              {WOCHENTAGE_KURZ.map(t => <div key={t} className="ld-kal-gitter__kopf">{t}</div>)}
              {days.map((day, i) => {
                if (!day) return <div key={i} className="ld-kal-feld ist-leer" />;
                const ts = termineAm(day);
                const frei = freiAm(day);
                const isToday = day === heute, isSel = day === selectedDay;
                return (
                  <div key={day} role="button" tabIndex={0} aria-pressed={isSel} aria-label={`${datumTTMM(day)}${frei ? `, ${frei}` : ''}, ${ts.length} Termine`}
                    onClick={() => setSelectedDay(day)} onKeyDown={e => { if (e.key === 'Enter') setSelectedDay(day); }}
                    className={`ld-kal-feld${isToday ? ' ist-heute' : ''}${isSel ? ' ist-gewaehlt' : ''}${frei ? ' ist-frei' : ''}${i % 7 >= 5 ? ' ist-we' : ''}`}>
                    <span className="ld-kal-feld__nr">{parseInt(day.slice(8), 10)}</span>
                    {frei && <span className="ld-kal-feld__frei">{frei}</span>}
                    {isMobile ? (
                      ts.length > 0 && <span className="ld-kal-punkte">{ts.slice(0, 3).map(t => <i key={t.id} style={{ background: KAT_FARBEN[t.kategorie] ?? 'var(--ld-text-tertiary)' }} />)}</span>
                    ) : (
                      <>
                        {ts.slice(0, 3).map(t => (
                          <button key={t.id} type="button" className="ld-kal-ereignis" onClick={e => { e.stopPropagation(); setSelectedDay(day); oeffneTermin(t); }}>
                            <i style={{ background: KAT_FARBEN[t.kategorie] ?? 'var(--ld-text-tertiary)' }} />
                            {uhr(t.datum) && <small>{uhr(t.datum)}</small>}{t.titel}
                          </button>
                        ))}
                        {ts.length > 3 && <span className="ld-kal-mehr">und {ts.length - 3} weitere</span>}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          {isMobile ? (
            <div style={{ marginTop: 14 }}>
              <h2 className="ld-kl-abschnitt">{new Date(anchorDay + 'T12:00:00').toLocaleDateString('de-DE', { weekday: 'long' })}, {datumTTMM(anchorDay)}{tagFrei ? <span className="ld-kl-abschnitt__zahl">{tagFrei}</span> : null}</h2>
              {tagTermine.length === 0
                ? <div className="ld-kl-karte ld-kt-leer">Keine Termine an diesem Tag.</div>
                : <div className="ld-kl-karte">{tagTermine.map(t => terminZeile(t))}</div>}
            </div>
          ) : (
            <div>
              {tageskarte}
              {naechste.length > 0 && (
                <div className="ld-kl-karte ld-kal-karte" style={{ marginTop: 14 }}>
                  <div className="ld-kal-karte__abschnitt" style={{ marginTop: 0 }}>Als Nächstes</div>
                  {naechste.map(t => (
                    <div key={t.id} className="ld-kal-tag ld-kal-tag--klein">{datumsBlock(tagVon(t.datum))}<div className="ld-kal-tag__termine">{terminZeile(t)}</div></div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {view === 'woche' && (
        <div className="ld-kal-pc">
          <div className="ld-kl-karte">
            {weekDays.map((day, i) => {
              const ts = termineAm(day);
              const frei = freiAm(day);
              return (
                <div key={day} className={`ld-kal-tag${i > 0 ? ' ld-kl-trenn' : ''}${frei ? ' ist-frei' : ''}`} onClick={() => setSelectedDay(day)}>
                  {datumsBlock(day)}
                  <div className="ld-kal-tag__termine">
                    {frei && <span className="ld-kal-feld__frei">{frei}</span>}
                    {ts.length === 0 && !frei ? <span className="ld-kal-ohne">Keine Termine</span> : ts.map(t => terminZeile(t))}
                  </div>
                </div>
              );
            })}
          </div>
          <div>{tageskarte}</div>
        </div>
      )}

      {/* Termin bearbeiten / anlegen — Welle K4: gemeinsamer Fenster-Rahmen, Uhrzeit optional (leer = ganztägig) */}
      {(() => {
        const teil = (v: string) => ({ d: v.slice(0, 10), z: v.length > 10 ? v.slice(11, 16) : '' });
        const zusammen = (d: string, z: string) => (d && z ? `${d}T${z}` : d);
        const start = teil(editDatum), ende = teil(editDatumEnde);
        const pflichtKlasse = editKat === 'ausflug' || editKat === 'klassenarbeit';
        const fertig = !!editTitel.trim() && !!editDatum;
        const t = editModal && editModal !== 'neu' ? (editModal as Schultermin) : null;
        return (
          <LdSheet open={editModal !== null} onClose={() => setEditModal(null)} maxWidth={560}
            kopf={{ titel: t ? 'Termin bearbeiten' : 'Neuer Termin', kontext: t ? datumLang(t.datum) : null }}
            fuss={<LdFensterFuss onAbbrechen={() => setEditModal(null)} haupt="Speichern" onHaupt={saveTermin} aus={!fertig} laden={editLaden}
              links={t && t.kategorie !== 'ferien' ? <button type="button" className="ld-kl-link" style={{ color: 'var(--ld-danger-text)' }} onClick={() => deleteTermin(t.id)}>Löschen</button> : undefined} />}>
            {/* Welle B2: Brücke vom Termin weiter — Gespräch zum Eltern-Termin, Noten zur Klassenarbeit */}
            {t && (() => {
              const weiter = (fn: () => void) => { rueckkehrRef.current = null; setEditModal(null); fn(); };
              if (t.eltern_schueler_id) return (
                <div className="ld-kal-bruecke">
                  <MIcon name={t.gespraech_dokumentiert ? 'task_alt' : 'forum'} size={20} />
                  <span>{t.gespraech_dokumentiert ? 'Gespräch dokumentiert' : 'Gespräch zu diesem Termin noch nicht dokumentiert'}</span>
                  <button type="button" onClick={() => weiter(() => oeffneGespraechAusTermin(t.eltern_schueler_id!, t.id))}>
                    {t.gespraech_dokumentiert ? 'Ansehen' : 'Gespräch dokumentieren'}</button>
                </div>
              );
              if (t.kategorie === 'klassenarbeit' && t.klasse_id) return (
                <div className="ld-kal-bruecke">
                  <MIcon name="grading" size={20} />
                  <span>Noten dieser Klassenarbeit für die ganze Klasse</span>
                  <button type="button" onClick={() => weiter(() => oeffneKlassenarbeitListe({ terminId: t.id }))}>Noten eintragen</button>
                </div>
              );
              return null;
            })()}

            <LdFeld label="Titel" htmlFor="termin-titel">
              <LdEingabe id="termin-titel" value={editTitel} onChange={e => setEditTitel(e.target.value)} placeholder="z. B. Elternsprechtag" />
            </LdFeld>

            <LdFeldReihe>
              <LdFeld label="Datum">
                <LdDatum aria-label="Datum" required value={start.d} onChange={e => setEditDatum(zusammen(e.target.value, start.z))} />
              </LdFeld>
              <LdFeld label="Uhrzeit" optional>
                <LdUhrzeit aria-label="Uhrzeit" value={start.z} onChange={z => setEditDatum(zusammen(start.d, z))} />
              </LdFeld>
            </LdFeldReihe>
            {endeOffen || editDatumEnde ? (
              <LdFeldReihe>
                <LdFeld label="Enddatum" optional>
                  <LdDatum aria-label="Enddatum" min={start.d || undefined} value={ende.d} onChange={e => setEditDatumEnde(zusammen(e.target.value, ende.z))} />
                </LdFeld>
                <LdFeld label="Ende um" optional>
                  <LdUhrzeit aria-label="Ende um" placeholder="—" value={ende.z} onChange={z => setEditDatumEnde(zusammen(ende.d || start.d, z))} />
                </LdFeld>
              </LdFeldReihe>
            ) : (
              <button type="button" className="ld-kl-link" style={{ alignSelf: 'flex-start', marginTop: -6 }} onClick={() => setEndeOffen(true)}>
                <MIcon name="add" size={18} />Enddatum für mehrere Tage
              </button>
            )}

            <LdFeld label="Kategorie">
              <LdChips aria-label="Kategorie" wert={editKat} onChange={setEditKat}
                optionen={Object.entries(KAT_LABELS).filter(([k]) => k !== 'ferien' || editKat === 'ferien').map(([k, label]) => ({ wert: k, label, punkt: KAT_FARBEN[k] }))} />
            </LdFeld>

            <LdFeld label="Klasse" optional={!pflichtKlasse}>
              {uniqueKlassen.length <= 8 ? (
                <LdChips aria-label="Klasse" wert={editKlasseId === '' ? 'keine' : String(editKlasseId)} onChange={v => setEditKlasseId(v === 'keine' ? '' : Number(v))}
                  optionen={[{ wert: 'keine', label: 'Keine' }, ...uniqueKlassen.map(k => ({ wert: String(k.klasse_id), label: k.klasse_name }))]} />
              ) : (
                <LdAuswahl aria-label="Klasse" value={editKlasseId === '' ? '' : String(editKlasseId)} onChange={e => setEditKlasseId(e.target.value === '' ? '' : Number(e.target.value))}>
                  <option value="">Keine</option>
                  {uniqueKlassen.map(k => <option key={k.klasse_id} value={String(k.klasse_id)}>{k.klasse_name}</option>)}
                </LdAuswahl>
              )}
            </LdFeld>

            {/* Ausflug-spezifische Felder (M8e) */}
            {editKat === 'ausflug' && (
              <>
                <LdFeldReihe>
                  <LdFeld label="Kosten pro Kind" optional htmlFor="termin-kosten">
                    <LdEingabe id="termin-kosten" value={ausflugKosten} onChange={e => setAusflugKosten(e.target.value)} inputMode="decimal" placeholder="z. B. 14,50"
                      rechts={<span className="ld-fe-icon" aria-hidden="true" style={{ fontSize: 15 }}>€</span>} />
                  </LdFeld>
                  <LdFeld label="Zahlung bis" optional>
                    <LdDatum aria-label="Zahlung bis" value={ausflugZahlungBis} onChange={e => setAusflugZahlungBis(e.target.value)} />
                  </LdFeld>
                </LdFeldReihe>

                {/* Teilnehmer-Auswahl (nur bei Neuanlage) */}
                {editModal === 'neu' && (
                  <LdFeld label={`Teilnehmer${ausflugSchueler.length > 0 ? ` (${ausflugAktiv.size} von ${ausflugSchueler.length})` : ''}`}
                    rechts={ausflugSchueler.length > 0 ? (
                      <span style={{ display: 'inline-flex', gap: 12 }}>
                        <button type="button" className="ld-kl-link" onClick={() => setAusflugAktiv(new Set(ausflugSchueler.map(s => s.id)))}>Alle</button>
                        <button type="button" className="ld-kl-link" style={{ color: 'var(--ld-text-secondary)' }} onClick={() => setAusflugAktiv(new Set())}>Keine</button>
                      </span>) : undefined}>
                    {editKlasseId === '' ? (
                      <p className="ld-fe-text">Bitte zuerst eine Klasse wählen.</p>
                    ) : ausflugSchueler.length === 0 ? (
                      <p className="ld-fe-text">Keine Schüler in dieser Klasse.</p>
                    ) : (
                      <div style={{ maxHeight: 220, overflowY: 'auto', border: '1px solid var(--ld-border-strong)', borderRadius: 12, background: '#fff' }}>
                        {ausflugSchueler.map((s, i) => {
                          const an = ausflugAktiv.has(s.id);
                          return (
                            <label key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 10, minHeight: 44, padding: '0 14px', cursor: 'pointer', borderTop: i > 0 ? '1px solid var(--ld-border-light)' : 'none' }}>
                              <input type="checkbox" checked={an} onChange={() => setAusflugAktiv(prev => { const n = new Set(prev); if (n.has(s.id)) n.delete(s.id); else n.add(s.id); return n; })}
                                style={{ width: 18, height: 18, accentColor: 'var(--ld-primary)' }} />
                              <span style={{ fontSize: 14.5, color: an ? 'var(--ld-ink)' : 'var(--ld-text-tertiary)' }}>{s.nachname}, {s.vorname}</span>
                            </label>
                          );
                        })}
                      </div>
                    )}
                  </LdFeld>
                )}
              </>
            )}

            {/* Klassenarbeit-spezifische Felder (D3) */}
            {editKat === 'klassenarbeit' && (
              <LdFeldReihe>
                <LdFeld label="Fach">
                  <LdAuswahl aria-label="Fach" value={kaFach} onChange={e => setKaFach(e.target.value)} placeholder={editKlasseId === '' ? 'Erst Klasse wählen' : 'Fach wählen'}>
                    {kaFaecher.map(f => <option key={f} value={f}>{f}</option>)}
                  </LdAuswahl>
                </LdFeld>
                <LdFeld label="Thema" optional htmlFor="termin-thema">
                  <LdEingabe id="termin-thema" value={kaThema} onChange={e => setKaThema(e.target.value)} placeholder="z. B. Bruchrechnung" />
                </LdFeld>
              </LdFeldReihe>
            )}

            <LdFeld label="Beschreibung" optional htmlFor="termin-beschreibung">
              <LdTextfeld id="termin-beschreibung" value={editBeschreibung} onChange={e => setEditBeschreibung(e.target.value)} rows={2} placeholder="Weitere Details" />
            </LdFeld>
          </LdSheet>
        );
      })()}
    </div>
  );
}

// Welle K1: ansicht = Unterreiter aus dem Klassenkopf (KlasseTab); ohne = eigenständig mit eigener Leiste.
// onDetail meldet ein offenes Profil (der Klassenkopf blendet sich dann aus).
function SchuelerAnsicht({ aktiveKlasse, ansicht, onDetail }: { aktiveKlasse?: KlasseFachEintrag | null; ansicht?: 'uebersicht' | 'noten' | 'fehlzeiten'; onDetail?: (offen: boolean) => void } = {}) {
  const { schuelerListe, deleteSchueler, openProfilId, openProfilZiel, setOpenProfilId, initialKlasseFilter, setInitialKlasseFilter } = useSchueler();
  const isMobile = useIsMobile();
  const [subTabLokal, setSubTab] = useState<'uebersicht' | 'noten' | 'fehlzeiten'>('uebersicht');
  const subTab = ansicht ?? subTabLokal;
  const [fzDetail, setFzDetail] = useState(false);   // Welle K1: Profil aus der Fehlzeiten-Ansicht offen
  const [profilBereich, setProfilBereich] = useState(false);   // Welle P1d: Bereich-Seite im Profil offen (Handy)
  // Welle U8: im Klassen-Screen (aktiveKlasse übergeben) folgen Noten/Fehlzeiten der Klasse oben
  const vorgabeKlasseId = aktiveKlasse === undefined ? undefined : (aktiveKlasse?.klasse_id ?? null);
  const [klasse, setKlasse]                       = useState(() => initialKlasseFilter || 'Alle');
  const [ausgewaehlt, setAusgewaehlt]             = useState<Schueler | null>(null);
  // Welle U2: Ziel-Tab eines Profil-Sprungs — gilt nur für genau diesen Schüler
  const [profilZiel, setProfilZiel]               = useState<{ id: number; ziel: ProfilZiel } | null>(null);
  const [setupModal,  setSetupModal]              = useState<SetupTab | null>(null);
  const [skelLoading, setSkelLoading] = useState(true);
  const [karussellSuche, setKarussellSuche] = useState('');
  // Welle B1: Reihenfolge wie die Klassen-Chips (Klassenleitung vorn, natürlich sortiert)
  const klassenReihe = useEindeutigeKlassen().map(k => k.klasse_name);
  const verfuegbareKlassen = ['Alle', ...Array.from(new Set(schuelerListe.map(s => s.klasse))).sort((a, b) => {
    const ia = klassenReihe.indexOf(a), ib = klassenReihe.indexOf(b);
    return ia >= 0 && ib >= 0 ? ia - ib : vergleicheKlassen(a, b);
  })].filter(Boolean);

  // Welle U2: Ein offenes Profil schließt nur bei einem ECHTEN Klassenwechsel
  // (Wert ändert sich gegenüber dem vorigen), nicht beim Einhängen — sonst
  // setzt der Reset einen gerade ausgeführten Profil-Sprung sofort zurück.
  const vorigeAktiveKlasseRef = useRef(aktiveKlasse?.klasse_id);
  useEffect(() => {
    if (aktiveKlasse === undefined) return;
    const vorher = vorigeAktiveKlasseRef.current;
    vorigeAktiveKlasseRef.current = aktiveKlasse?.klasse_id;
    if (vorher == null || vorher === aktiveKlasse?.klasse_id) return; // Einhängen/Erstbelegung
    setAusgewaehlt(null);
    setKarussellSuche('');
  }, [aktiveKlasse?.klasse_id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (schuelerListe.length > 0) { setSkelLoading(false); return; }
    const t = setTimeout(() => setSkelLoading(false), 1500);
    return () => clearTimeout(t);
  }, [schuelerListe]);

  useEffect(() => {
    if (openProfilId === null) return;
    const s = schuelerListe.find(s => s.id === openProfilId);
    // Liste noch nicht geladen → Sprung offen lassen, bis sie da ist
    if (!s && schuelerListe.length === 0) return;
    if (s) {
      setAusgewaehlt(s);
      setProfilZiel(openProfilZiel ? { id: s.id, ziel: openProfilZiel } : null);
    }
    setOpenProfilId(null);
  }, [openProfilId, openProfilZiel, schuelerListe, setOpenProfilId]);

  // Ziel nur beim Schließen eines offenen Profils verwerfen (nicht beim Einhängen)
  const profilWarOffenRef = useRef(false);
  useEffect(() => {
    if (profilWarOffenRef.current && !ausgewaehlt) setProfilZiel(null);
    profilWarOffenRef.current = !!ausgewaehlt;
  }, [ausgewaehlt]);

  useEffect(() => {
    if (initialKlasseFilter) {
      setKlasse(initialKlasseFilter);
      setInitialKlasseFilter('');
    }
  }, [initialKlasseFilter, setInitialKlasseFilter]);

  const vorigeKlasseRef = useRef(klasse);
  useEffect(() => {
    if (vorigeKlasseRef.current === klasse) return; // Einhängen: kein Reset
    vorigeKlasseRef.current = klasse;
    setAusgewaehlt(null);
    setKarussellSuche('');
  }, [klasse]); // eslint-disable-line react-hooks/exhaustive-deps

  // Welle K1: Kopf aus, solange ein Profil offen ist (auch das aus der Fehlzeiten-Ansicht).
  // Im Klassen-Bereich ist der schwebende Mikro-Knopf da — über einem offenen Profil (feste Leiste unten) nicht.
  const detailOffen = !!ausgewaehlt || (subTab === 'fehlzeiten' && fzDetail);
  useEffect(() => { onDetail?.(detailOffen); }, [detailOffen]); // eslint-disable-line react-hooks/exhaustive-deps
  useOhneMikroKnopf(isMobile && ansicht !== undefined && detailOffen);

  // Eigenständig (ohne Klassenkopf): die bisherige Leiste Übersicht · Noten · Fehlzeiten
  const leiste = ansicht === undefined && (
    <div style={{ display: 'flex', gap: 6, marginBottom: 20, background: 'transparent', borderRadius: 'var(--ld-radius-full)', padding: 4 }}>
      {(['uebersicht','noten','fehlzeiten'] as const).map(t => (
        <button key={t} onClick={() => setSubTab(t)} style={{
          flex: 1, padding: '8px 4px', borderRadius: 'var(--ld-radius-full)', border: 'none', cursor: 'pointer',
          background: subTab === t ? 'var(--ld-brand-gradient)' : 'transparent',
          color: subTab === t ? 'white' : 'var(--ld-text-secondary)',
          boxShadow: subTab === t ? 'var(--ld-shadow-elev-hero)' : 'none',
          fontWeight: subTab === t ? 600 : 500, fontSize: 13,
          transition: 'var(--ld-transition-fast)',
          WebkitTapHighlightColor: 'transparent' as any,
        }}>
          {t === 'uebersicht' ? 'Übersicht' : t === 'noten' ? 'Noten' : 'Fehlzeiten'}
        </button>
      ))}
    </div>
  );

  const sortierteSchueler = schuelerListe
    .filter(s => aktiveKlasse != null
      ? Number(s.klasse_id) === Number(aktiveKlasse.klasse_id)
      : (klasse === 'Alle' || s.klasse === klasse))
    .filter(s => !karussellSuche || s.name.toLowerCase().includes(karussellSuche.toLowerCase()))
    .sort((a, b) => a.name.localeCompare(b.name, 'de'));
  const aktiverIndex = sortierteSchueler.findIndex(s => s.id === ausgewaehlt?.id);

  if (ausgewaehlt) {
    const aktuell = schuelerListe.find(s => s.id === ausgewaehlt.id) ?? ausgewaehlt;
    return (
      <div className="ld-detail-vollbreite">
        {/* Welle P1d: in einer Bereich-Seite (Handy) führt nur „‹ Name“ zurück — vor/zurück erst wieder auf dem Profil-Start */}
        {!profilBereich && <KarussellHeader
          onZurueck={() => { setAusgewaehlt(null); setKarussellSuche(''); }}
          onVorher={() => aktiverIndex > 0 && setAusgewaehlt(sortierteSchueler[aktiverIndex - 1])}
          onNaechster={() => aktiverIndex < sortierteSchueler.length - 1 && setAusgewaehlt(sortierteSchueler[aktiverIndex + 1])}
          suchterm={karussellSuche}
          setSuchterm={setKarussellSuche}
          vorherDeaktiviert={aktiverIndex <= 0}
          naechsterDeaktiviert={aktiverIndex < 0 || aktiverIndex >= sortierteSchueler.length - 1}
          zurueckLabel={aktuell.klasse ? `Klasse ${aktuell.klasse}` : 'Zur Klasse'}
          position={aktiverIndex >= 0 ? `${aktiverIndex + 1} von ${sortierteSchueler.length}` : undefined}
          suchPlatzhalter={aktuell.klasse ? `Schüler/in in ${aktuell.klasse} suchen` : 'Schüler/in suchen'}
        />}
        <div key={aktuell.id} className="ld-karussell-inhalt">
          <SchuelerProfil schueler={aktuell} startZiel={profilZiel?.id === aktuell.id ? profilZiel.ziel : undefined} onBack={() => { setAusgewaehlt(null); setKarussellSuche(''); }} onBereich={setProfilBereich} />
        </div>
      </div>
    );
  }

  if (subTab === 'noten')      return <div>{leiste}<NotenAnsicht vorgabeKlasseId={vorgabeKlasseId} /></div>;
  if (subTab === 'fehlzeiten') return <div>{leiste}<FehlzeitenScreen vorgabeKlasseId={vorgabeKlasseId} onDetail={setFzDetail} /></div>;

  // Welle K1: Kinder der Klasse (eingebettet) bzw. des Filters (eigenständig) — ruhige Liste
  const kinder = schuelerListe.filter(s => aktiveKlasse != null
    ? Number(s.klasse_id) === Number(aktiveKlasse.klasse_id)
    : (klasse === 'Alle' || s.klasse === klasse));
  const listenKlasseId = aktiveKlasse != null ? Number(aktiveKlasse.klasse_id)
    : klasse !== 'Alle' ? (kinder[0]?.klasse_id ?? null) : null;
  const listenKlasseName = aktiveKlasse?.klasse_name ?? (klasse !== 'Alle' ? klasse : null);
  async function loeschen(s: Schueler) {
    // Welle Z3: Folge und Alternative nennen; bei Gefahr ist „Abbrechen“ vorausgewählt (ConfirmHost)
    if (!(await confirm(
      `Noten, Fehlzeiten und Notizen von ${s.name} werden gelöscht. Das lässt sich nicht rückgängig machen.

Wenn ${s.name.split(' ')[0]} nur die Klasse verlässt, nutze im Profil „Schüler verlässt die Klasse“. Dann bleibt alles im Archiv erhalten.`,
      { title: `${s.name} löschen?`, danger: true, confirmLabel: 'Endgültig löschen' }))) return;
    await deleteSchueler(s.id);
    toast('Schüler/in gelöscht');
  }
  // Am Handy wie bisher: nach links wischen = Löschen, nach rechts = Profil
  const huelle = isMobile ? (s: Schueler, zeile: React.ReactNode) => (
    <SwipeRow leftLabel="Löschen" leftColor="#DC2626" rightLabel="Profil" rightColor="#6B5FD4"
      onSwipeLeft={() => { haptic(40); void loeschen(s); }}
      onSwipeRight={() => { haptic(20); setAusgewaehlt(s); }}>{zeile}</SwipeRow>
  ) : undefined;

  return (
    <div className="ld-page-enter">
    <div className="ld-schuelerliste-v1" style={{ position: 'relative', minHeight: '100%', background: 'transparent' }}>
      {leiste}
      {/* Eigenständig: Titel und „+ Schüler/in“ — im Klassen-Bereich steht das im Klassenkopf (⋯-Menü) */}
      {ansicht === undefined && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h1 style={{ margin: 0, fontSize: 28, fontWeight: 700, color: 'var(--ld-text-primary)' }}>Schüler</h1>
          <button onClick={() => setSetupModal('manuell')} className="ld-kl-zweit">
            <MIcon name="person_add" size={18} />Schüler/in
          </button>
        </div>
      )}

      {/* Skeleton während Daten laden */}
      {skelLoading && (
        <div>
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: '1px solid var(--ld-border-light)' }}>
              <div className="ld-skeleton ld-skeleton-circle" />
              <div style={{ flex: 1 }}>
                <div className="ld-skeleton ld-skeleton-line ld-skeleton-line--title" />
                <div className="ld-skeleton ld-skeleton-line ld-skeleton-line--short" />
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Noch keine Schüler: Klasse einrichten (Foto/Datei oder manuell) */}
      {!skelLoading && schuelerListe.length === 0 && (
        <div className="ld-kl-karte" style={{ padding: '24px 20px', marginBottom: 20, textAlign: 'center' }}>
          <div style={{ color: 'var(--ld-text-tertiary)', marginBottom: 10 }}><MIcon name="group" size={36} /></div>
          <h2 style={{ margin: '0 0 6px', fontSize: 18, fontWeight: 700, color: 'var(--ld-text-primary)' }}>Noch keine Schüler angelegt</h2>
          <p style={{ margin: '0 0 18px', fontSize: 14, color: 'var(--ld-text-secondary)', lineHeight: 1.6 }}>Richte die Klasse ein: aus einem Foto oder einer Datei oder Name für Name.</p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => setSetupModal('upload')} className="ld-kl-haupt"><MIcon name="upload_file" size={18} />Foto oder Datei</button>
            <button onClick={() => setSetupModal('manuell')} className="ld-kl-zweit"><MIcon name="edit" size={18} />Manuell</button>
          </div>
        </div>
      )}

      {/* Eigenständig: Klassen-Filter */}
      {!skelLoading && schuelerListe.length > 0 && aktiveKlasse === undefined && verfuegbareKlassen.length > 2 && (
        <div className="ld-kl-umschalter" style={{ marginBottom: 12, flexWrap: 'wrap' }}>
          {verfuegbareKlassen.map(k => (
            <button key={k} type="button" aria-pressed={klasse === k} onClick={() => setKlasse(k)}>{k === 'Alle' ? 'Alle Klassen' : k}</button>
          ))}
        </div>
      )}

      {!skelLoading && schuelerListe.length > 0 && (
        <SchuelerListe kinder={kinder} klasseId={listenKlasseId} klassenName={listenKlasseName} onOeffnen={setAusgewaehlt} huelle={huelle} />
      )}

      {setupModal !== null && (
        <KlasseEinrichtenModal defaultTab={setupModal} onClose={() => setSetupModal(null)} />
      )}
    </div>
    </div>
  );
}

// ── Notizen-Ansicht ────────────────────────────────────────────────────────
function analysiereText(text: string, schuelerListe: Schueler[]): { schueler: Schueler | null; aktion: string; farbe: string } {
  const lower = text.toLowerCase();
  const gefunden = schuelerListe.find(s => {
    const [vor, nach] = s.name.toLowerCase().split(' ');
    return lower.includes(vor) || lower.includes(nach);
  });
  let aktion = 'Notiz gespeichert';
  let farbe = '#D1ECF1';
  if (/fehl|nicht da|krank|abwesend|nicht erschienen/.test(lower)) {
    aktion = 'Fehlzeit eingetragen'; farbe = '#F8D7DA';
  } else if (/abgelenkt|handy|stört|ermahnt|fixiert/.test(lower)) {
    aktion = 'Verhaltensnotiz: Abgelenkt'; farbe = '#FFF3CD';
  } else if (/aktiv|beteiligt|hervorragend|positiv|vorbildlich/.test(lower)) {
    aktion = 'Verhaltensnotiz: Aktiv'; farbe = '#D4EDDA';
  } else if (/hausaufgaben|ha |mitgebracht/.test(lower)) {
    aktion = 'HA nicht dabei eingetragen'; farbe = '#FFF3CD';
  }
  return { schueler: gefunden ?? null, aktion, farbe };
}

const SCHNELL_AKTIONEN: { label: string; icon: string; color: string; bg: string; aktion: string }[] = [
  { label: 'Aktiv',     icon: 'check_circle', color: '#2F8B4E', bg: '#E0F2E8', aktion: 'Verhaltensnotiz: Aktiv'     },
  { label: 'Abgelenkt', icon: 'mood',         color: '#8A5E0E', bg: '#FBEECB', aktion: 'Verhaltensnotiz: Abgelenkt' },
  { label: 'HA dabei',  icon: 'menu_book',    color: '#3A6BA8', bg: '#E2ECF8', aktion: 'HA dabei vermerkt'          },
  { label: 'Fehlt',     icon: 'close',        color: '#DC2626', bg: '#FCE4E2', aktion: 'Fehlzeit eingetragen'       },
];

// ── Neue-Notiz-Modal ───────────────────────────────────────────────────────
interface NeueNotizModalProps {
  onSave: (eintrag: KIEintrag) => void;
  onClose: () => void;
  /** Stream pre-acquired in FAB gesture context (fixes iOS getUserMedia restriction) */
  streamPromise?: Promise<MediaStream> | null;
}

// ── JWT-Auto-Refresh-Interceptor ──────────────────────────────────────────
// Einmalig registrieren — kein Re-Register bei HMR nötig da Modul-Level
let _refreshPromise: Promise<boolean> | null = null;
async function tryRefreshToken(): Promise<boolean> {
  if (_refreshPromise) return _refreshPromise;
  // Welle S8: eine Stelle (lib/sitzung) — das neue Token landet am selben Ort wie das alte
  _refreshPromise = erneuereToken().finally(() => { _refreshPromise = null; });
  return _refreshPromise;
}
declare global { interface Window { _origFetch: typeof fetch; } }

const AUTH_FREE_PATHS = [
  '/api/login',
  '/api/register',
  '/api/gmail/callback',
  '/api/outlook/callback',
  '/api/status',
  '/api/push/vapid',
];

function needsAuth(url: string): boolean {
  if (!url.includes('/api/')) return false;
  return !AUTH_FREE_PATHS.some(p => url.includes(p));
}

function injectAuth(init: RequestInit | undefined, token: string): RequestInit {
  const next: RequestInit = { ...(init ?? {}) };
  const existing = (typeof next.headers === 'object' && !Array.isArray(next.headers))
    ? next.headers as Record<string, string>
    : {};
  const hasAuth = Object.keys(existing).some(k => k.toLowerCase() === 'authorization');
  if (hasAuth) return next;
  next.headers = { ...existing, Authorization: `Bearer ${token}` };
  return next;
}

if (!window._origFetch) {
  window._origFetch = window.fetch;
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const urlStr = typeof input === 'string'
      ? input
      : input instanceof URL
        ? input.toString()
        : (input as Request).url;

    let effectiveInit = init;
    if (needsAuth(urlStr)) {
      const token = holeToken();
      if (token) effectiveInit = injectAuth(init, token);
    }

    const resp = await window._origFetch(input, effectiveInit);

    if (resp.status === 401) {
      let bodyClone: any;
      try { bodyClone = await resp.clone().json(); } catch { bodyClone = {}; }
      if (bodyClone?.fehler === 'Token ungültig oder abgelaufen.') {
        const refreshed = await tryRefreshToken();
        if (refreshed) {
          const newToken = holeToken();
          const newInit: RequestInit = { ...(effectiveInit ?? {}) };
          newInit.headers = {
            ...(typeof newInit.headers === 'object' && !Array.isArray(newInit.headers) ? newInit.headers as Record<string, string> : {}),
            Authorization: `Bearer ${newToken}`,
          };
          return window._origFetch(input, newInit);
        } else {
          // Welle S8: Sitzung zu Ende (auch nach 30 Minuten ohne Benutzung) — aufräumen, Anmeldung zeigen
          void abmeldenUndAufraeumen();
        }
      }
    }
    if (resp.status === 403) {
      let bodyClone: any;
      try { bodyClone = await resp.clone().json(); } catch { bodyClone = {}; }
      if (bodyClone?.fehler?.includes('KI-Verarbeitung nicht freigegeben')) {
        toast('KI-Verarbeitung ist aus. Du kannst sie in den Einstellungen unter KI-Verarbeitung einschalten.', 'error');
      }
    }
    return resp;
  };
}

type SprechPhase = 'idle' | 'aufnahme' | 'transkribiert' | 'analysiert' | 'fehler';

// Welle U4b: Farben kommen aus notizen-lib (eine Quelle für Feed, Screen und Profil)
function farbeAusKategorie(k: string): string {
  return k === 'Sonstiges' ? 'var(--ld-bg-app)' : (NOTIZ_KATEGORIEN[k]?.bg ?? 'var(--ld-bg-app)');
}

function NeueNotizModal({ onSave, onClose, streamPromise }: NeueNotizModalProps) {
  const { schuelerListe, patchSchueler } = useSchueler();
  const { setIsRecording } = useFab();
  useEscapeKey(onClose);
  const [modus, setModus]           = useState<NotizenModus>('sprechen');
  const [tippText, setTippText]     = useState('');
  const [schnellAusgewaehlt, setSchnellAusgewaehlt] = useState<Set<number>>(new Set([0]));
  const [erfolge, setErfolge]       = useState<KIEintrag[]>([]);
  const [meineKlassen, setMeineKlassen] = useState<KlasseFachEintrag[]>([]);
  const [selectedKlasseFach, setSelectedKlasseFach] = useState<KlasseFachEintrag | null>(null);
  const [fuerKlassenbuch,    setFuerKlassenbuch]    = useState(false);
  const [kbStunde,           setKbStunde]           = useState(1);
  const [mitarbeitEntries,   setMitarbeitEntries]   = useState<MitarbeitExtracted[]>([]);
  const [mitarbeitSpeichern, setMitarbeitSpeichern] = useState(false);

  React.useEffect(() => {
    fetch(`${API_BASE}/api/meine-klassen`, { headers: apiHeaders() })
      .then(leseFallback<KlasseFachEintrag[]>([], '/api/meine-klassen'))
      .then((data: KlasseFachEintrag[]) => setMeineKlassen(data))
      .catch(() => {});
  }, []);

  // Pre-acquired stream from FAB gesture (iOS Safari: getUserMedia must be called in gesture context)
  const preAcquiredStreamRef = React.useRef<Promise<MediaStream> | null>(streamPromise ?? null);

  // Auto-Start NUR wenn die FAB-Diktat-Geste bereits einen MediaStream angefordert hat
  // (iOS-Geste bleibt erhalten). Beim normalen Öffnen via „Neue Notiz" gibt es keinen
  // vorab-Stream → Diktat bleibt AUS und das Mikrofon wird NICHT ungefragt angefragt;
  // die Aufnahme startet erst auf expliziten Knopfdruck (Sprechen-Button).
  const autoStartRef = React.useRef(false);
  useEffect(() => {
    if (autoStartRef.current) return;
    if (!preAcquiredStreamRef.current) return;
    autoStartRef.current = true;
    void handleSprechenKlick();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sprechen-State
  const [phase,         setPhase]         = useState<SprechPhase>('idle');
  const [statusText,    setStatusText]    = useState('');
  const [apiFehler,     setApiFehler]     = useState('');
  const recorderRef  = React.useRef<MediaRecorder | null>(null);
  const chunksRef    = React.useRef<Blob[]>([]);

  // Tippen-State
  const [tippLaden,  setTippLaden]  = useState(false);
  const [tippFehler, setTippFehler] = useState('');

  const MODI = [
    { key: 'sprechen' as NotizenModus, label: 'Sprechen', icon: <MIcon name="mic" size={14} /> },
    { key: 'tippen'   as NotizenModus, label: 'Tippen',   icon: <MIcon name="edit" size={14} /> },
    { key: 'schnell'  as NotizenModus, label: 'Schnell',  icon: <MIcon name="chevron_right" size={14} /> },
  ];

  function speichereUndZeige(schueler: string, aktion: string, farbe: string, raw?: string, kategorie?: string, valenz?: 'positiv' | 'negativ' | null) {
    const eintrag: KIEintrag = {
      id: Date.now() + Math.random(), modus, schueler, aktion, farbe, raw,
      zeit: new Date().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }),
    };
    onSave(eintrag);
    setErfolge(prev => [...prev, eintrag]);

    // Welle U4b: Notiz nur noch in der Datenbank (Profil + Notizen-Screen lesen von dort)
    const gefunden = schuelerListe.find(s => s.name.trim().toLowerCase() === schueler.trim().toLowerCase());
    if (gefunden) {
      const heute = new Date().toISOString().split('T')[0];

      // Notiz in SQLite speichern
      apiPost('/api/notizen', {
        schueler_id:     gefunden.id,
        datum:           heute,
        kategorie:       kategorie ?? 'Sonstiges',
        aktion:          aktion,
        zusammenfassung: raw ?? aktion,
        valenz:          valenz ?? null,
        quelle:          'schnelldiktat',   // Welle U4a
      }).then(() => signalNotizenGeaendert())
        .catch(err => zeigeApiFehler(err, 'Notiz konnte nicht gespeichert werden'));

      // Fehlzeit-Kategorie → Fehlzeiten in schuelerListe eintragen (1 Std / 1 Tag, unentschuldigt)
      if (kategorie?.toLowerCase() === 'fehlzeit') {
        patchSchueler(gefunden.id, s => ({
          ...s,
          fehlzeiten: {
            stunden_gesamt:         s.fehlzeiten.stunden_gesamt         + 1,
            stunden_unentschuldigt: s.fehlzeiten.stunden_unentschuldigt + 1,
            tage_gesamt:            s.fehlzeiten.tage_gesamt            + 1,
            tage_unentschuldigt:    s.fehlzeiten.tage_unentschuldigt    + 1,
          },
        }));
        apiPost('/api/fehlzeiten', {
          schueler_id:  gefunden.id,
          datum:        heute,
          stunden:      1,
          tage:         1,
          entschuldigt: false,
        }).catch(err => zeigeApiFehler(err, 'Fehlzeit konnte nicht gespeichert werden'));
      }
      // Positiv/Negativ-Zähler direkt in schuelerListe aktualisieren → Profil sieht Updates
      if (valenz === 'positiv' || valenz === 'negativ') {
        patchSchueler(gefunden.id, s => ({
          ...s,
          positiv: s.positiv + (valenz === 'positiv' ? 1 : 0),
          negativ: s.negativ + (valenz === 'negativ' ? 1 : 0),
        }));


      }
    }
  }

  // ── Analyse via Backend ──────────────────────────────────────────────────
  // Promise-basierter Sleep – verhindert parallele Timer
  const sleep = (ms: number) => new Promise<void>(resolve => setTimeout(resolve, ms));

  async function analysiereViaBackend(text: string, namen: string[], fach?: string, klasse?: string) {
    const result = await apiPost<any>('/api/analysiere', { text, schuelerNamen: namen, fach, klasse });

    // Support both new { eintraege, mitarbeit } format and legacy plain array
    const data: BackendEintrag[] = Array.isArray(result) ? result : (result.eintraege ?? []);
    const mitarbeitRaw: MitarbeitExtracted[] = Array.isArray(result) ? [] : (result.mitarbeit ?? []);

    if (data.length === 0) {
      // Kein Array → Fehlermeldung, Modal bleibt offen
      setApiFehler('Keine Ergebnisse vom Backend erhalten.');
      setPhase('fehler');
      return;
    }

    // 3. Einträge sequenziell anzeigen – kein forEach, kein paralleler Timer
    let gespeichert = 0;
    for (const e of data) {
      if (!e.schueler) continue; // Einträge ohne Schüler überspringen
      speichereUndZeige(
        e.schueler,
        e.aktion,
        farbeAusKategorie(e.kategorie),
        e.zusammenfassung ?? text,
        e.kategorie,
        e.valenz ?? null,
      );
      gespeichert++;
      await sleep(1200); // 1,2 s pro Eintrag sichtbar
    }

    // 4. Kein Schüler erkannt → Fehlermeldung, Modal bleibt offen
    if (gespeichert === 0) {
      setApiFehler('Kein Schüler erkannt');
      setPhase('fehler');
      return;
    }

    // 5. Mitarbeit-Einträge aus Diktat setzen (werden im Erfolgs-Screen angezeigt)
    if (mitarbeitRaw.length > 0) {
      setMitarbeitEntries(mitarbeitRaw);
    }

    // 6. Klassenbuch-Eintrag wenn Toggle aktiv
    if (fuerKlassenbuch && selectedKlasseFach) {
      const heute = new Date().toISOString().split('T')[0];
      // Thema: erste erkannte Aktion oder der Text selbst (max. 80 Zeichen)
      const ersteAktion = data.find(e => e.aktion)?.aktion ?? text.slice(0, 80);
      apiPost('/api/klassenbuch', {
        klasse_id: selectedKlasseFach.klasse_id,
        datum:     heute,
        stunde:    kbStunde,
        fach:      selectedKlasseFach.fach,
        thema:     ersteAktion,
        fehlende_schueler:      [],
        entschuldigte_schueler: [],
      }).catch(err => zeigeApiFehler(err, 'Klassenbuch-Eintrag fehlgeschlagen'));
    }

    // 7. Modal erst nach dem letzten Eintrag schließen (nur wenn keine Mitarbeit-Bestätigung nötig)
    if (mitarbeitRaw.length === 0) {
      await sleep(1200);
      onClose();
    }
  }

  async function mitarbeitAlleUebernehmen() {
    if (!selectedKlasseFach || mitarbeitEntries.length === 0) return;
    setMitarbeitSpeichern(true);
    const heute = new Date().toISOString().split('T')[0];
    try {
      for (const m of mitarbeitEntries) {
        const gefunden = schuelerListe.find(s => s.name.trim().toLowerCase() === m.schueler_name.trim().toLowerCase());
        if (!gefunden) continue;
        await apiPost('/api/mitarbeit', {
          schueler_id: gefunden.id,
          klasse_id:   selectedKlasseFach.klasse_id,
          fach:        selectedKlasseFach.fach,
          datum:       heute,
          note:        m.note,
          kontext:     m.kontext,
          quelle:      'diktat',
        });
      }
      toast(`${mitarbeitEntries.length} Mitarbeits-Einträge gespeichert`);
      setMitarbeitEntries([]);
      onClose();
    } catch (err) {
      zeigeApiFehler(err, 'Fehler beim Speichern');
    } finally {
      setMitarbeitSpeichern(false);
    }
  }

  // ── Sprechen: Start / Stop via MediaRecorder → Whisper ──────────────────
  async function handleSprechenKlick() {
    if (phase === 'aufnahme') {
      recorderRef.current?.stop();
      return;
    }

    setApiFehler('');
    setPhase('idle');

    let stream: MediaStream;
    try {
      // Use pre-acquired stream if available (from FAB gesture context on iOS)
      const pending = preAcquiredStreamRef.current;
      preAcquiredStreamRef.current = null;
      stream = pending ? await pending : await mikrofonAnfragen();
    } catch (err) {
      setApiFehler(zeigeMikrofonFehler(err, { stattdessenTippen: () => { setApiFehler(''); setPhase('idle'); setModus('tippen'); } }));
      setPhase('fehler');
      return;
    }

    const kandidaten = ['audio/webm;codecs=opus', 'audio/webm', 'audio/ogg;codecs=opus', 'audio/mp4', 'audio/wav'];
    const mime = kandidaten.find(m => MediaRecorder.isTypeSupported(m)) ?? '';
    const ext  = mime.includes('ogg') ? 'ogg' : mime.includes('mp4') ? 'mp4' : mime.includes('wav') ? 'wav' : 'webm';

    let recorder: MediaRecorder;
    try {
      recorder = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream);
    } catch (err) {
      setApiFehler('MediaRecorder konnte nicht gestartet werden: ' + (err instanceof Error ? err.message : String(err)));
      setPhase('fehler');
      stream.getTracks().forEach(t => t.stop());
      return;
    }
    recorderRef.current = recorder;
    chunksRef.current   = [];

    recorder.ondataavailable = e => { if (e.data.size > 0) chunksRef.current.push(e.data); };

    recorder.onstop = async () => {
      stream.getTracks().forEach(t => t.stop());
      setIsRecording(false);
      const blob = new Blob(chunksRef.current, { type: recorder.mimeType || mime });

      if (blob.size === 0) {
        setApiFehler('Aufnahme leer – kein Audio empfangen. Bitte erneut versuchen.');
        setPhase('fehler');
        return;
      }

      try {
        setPhase('transkribiert');
        setStatusText('Transkription läuft …');

        const formData = new FormData();
        formData.append('audio', blob, `aufnahme.${ext}`);

        const jwtToken = holeToken();
        const whisperAntwort = await fetch(`${API_BASE}/api/transkribiere`, {
          method: 'POST',
          headers: jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {},
          body: formData,
        });
        if (!whisperAntwort.ok) {
          const err = await whisperAntwort.json().catch(() => ({}));
          throw new Error(err.fehler ?? `Server-Fehler ${whisperAntwort.status}`);
        }

        const { text } = await whisperAntwort.json();
        if (!text?.trim()) throw new Error('Whisper hat keinen Text erkannt. Bitte deutlicher sprechen.');

        const gefilterteSchueler = selectedKlasseFach
          ? schuelerListe.filter(s => s.klasse === selectedKlasseFach.klasse_name)
          : schuelerListe;
        const schuelerNamen = gefilterteSchueler.map(s => s.name);
        await analysiereViaBackend(text, schuelerNamen, selectedKlasseFach?.fach, selectedKlasseFach?.klasse_name);

      } catch (err: unknown) {
        const msg = err instanceof Error ? err.message : 'Unbekannter Fehler';
        setApiFehler(msg);
        setPhase('fehler');
      }
    };

    recorder.start();
    setPhase('aufnahme');
    setIsRecording(true);
    setStatusText('Aufnahme läuft – erneut klicken zum Stoppen');
  }

  // ── Tippen: Text analysieren ─────────────────────────────────────────────
  async function handleTippen() {
    if (!tippText.trim()) return;
    setTippLaden(true);
    setTippFehler('');

    try {
      const gefilterteSchueler = selectedKlasseFach
        ? schuelerListe.filter(s => s.klasse === selectedKlasseFach.klasse_name)
        : schuelerListe;
      const schuelerNamen = gefilterteSchueler.map(s => s.name);
      await analysiereViaBackend(tippText, schuelerNamen, selectedKlasseFach?.fach, selectedKlasseFach?.klasse_name);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Unbekannter Fehler';
      // Fallback: lokale Analyse wenn Backend nicht erreichbar
      if (msg.includes('fetch') || msg.includes('Failed')) {
        const { schueler, aktion, farbe } = analysiereText(tippText, schuelerListe);
        speichereUndZeige(
          schueler?.name ?? 'Kein Schüler erkannt',
          schueler ? aktion : 'Text gespeichert',
          schueler ? farbe : 'var(--ld-bg-app)',
          tippText,
        );
      } else {
        setTippFehler(msg);
      }
    } finally {
      setTippLaden(false);
    }
  }

  function handleSchnell(aktionIdx: number) {
    const sa = SCHNELL_AKTIONEN[aktionIdx];
    schnellAusgewaehlt.forEach(sIdx => {
      speichereUndZeige(schuelerListe[sIdx].name, sa.aktion, sa.bg);
    });
  }

  return (
    <>
      <style>{`
        @keyframes waveBar {
          0%   { height: 6px;  }
          100% { height: 22px; }
        }
        @keyframes micPulse {
          0%   { box-shadow: 0 0 0 0 rgba(255,107,107,0.6), 0 8px 28px rgba(255,107,107,0.4); transform: scale(1); }
          50%  { box-shadow: 0 0 0 20px rgba(255,107,107,0), 0 8px 28px rgba(255,107,107,0.4); transform: scale(1.04); }
          100% { box-shadow: 0 0 0 0 rgba(255,107,107,0.6), 0 8px 28px rgba(255,107,107,0.4); transform: scale(1); }
        }
        @keyframes modalIn {
          from { opacity: 0; transform: translateY(24px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0)    scale(1);    }
        }
        @keyframes successPop {
          0%   { transform: scale(0.7); opacity: 0; }
          60%  { transform: scale(1.1); }
          100% { transform: scale(1);   opacity: 1; }
        }
      `}</style>

          {/* ── Modal-Header (weißes ld-Form-Muster: Icon-Chip + Titel + Close) ── */}
          <div className="ld-fe-kopf">
            <span className="ld-fe-kopf__icon" aria-hidden="true" style={{ display: 'inline-flex' }}><MIcon name="edit_note" size={20} /></span>
            <div className="ld-fe-kopf__text"><h3 className="ld-fe-kopf__titel">Neue Notiz</h3></div>
            <button type="button" className="ld-fe-zu" aria-label="Schließen" onClick={onClose}><MIcon name="close" size={20} /></button>
          </div>

          {/* ── Erfolgs-Screen ── */}
          {erfolge.length > 0 && (
            <div style={{ padding: '28px 28px 24px', textAlign: 'center' }}>
              <div style={{
                width: 56, height: 56, borderRadius: '50%',
                background: '#D4EDDA', display: 'flex', alignItems: 'center',
                justifyContent: 'center', margin: '0 auto 14px',
                fontSize: 26, animation: 'successPop .35s cubic-bezier(.34,1.56,.64,1) forwards',
              }}><MIcon name="check" size={16} /></div>
              <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--ld-text-primary)', marginBottom: 12 }}>
                {erfolge.length === 1 ? 'Gespeichert!' : `${erfolge.length} Einträge gespeichert!`}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {erfolge.map(e => (
                  <div key={e.id} style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    background: e.farbe, borderRadius: 'var(--ld-radius-md)', padding: '8px 14px',
                    justifyContent: 'center',
                  }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--ld-text-primary)' }}>{e.schueler}</span>
                    <span style={{
                      fontSize: 11, padding: '2px 8px', borderRadius: 6,
                      background: 'rgba(0,0,0,0.08)', color: 'var(--ld-text-primary)', fontWeight: 500,
                    }}>{e.aktion}</span>
                  </div>
                ))}
              </div>

              {/* ── Mitarbeit-Block ── */}
              {mitarbeitEntries.length > 0 && (
                <div style={{ marginTop: 16, textAlign: 'left', background: '#F0FDF4', borderRadius: 14, padding: '14px 16px', border: '1px solid #BBF7D0' }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#15803D', letterSpacing: 0.4, marginBottom: 10 }}>
                    Mitarbeit erkannt
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
                    {mitarbeitEntries.map((m, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'white', borderRadius: 10, padding: '8px 12px', border: '1px solid #D1FAE5' }}>
                        <span style={{ fontSize: 15, fontWeight: 800, color: m.note <= 2 ? '#15803D' : m.note >= 4 ? '#DC2626' : '#8A5E0E', minWidth: 18 }}>{m.note}</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ld-text-primary)' }}>{m.schueler_name}</div>
                          {m.kontext && <div style={{ fontSize: 11, color: 'var(--ld-text-secondary)', marginTop: 1 }}>{m.kontext}</div>}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button
                      onClick={mitarbeitAlleUebernehmen}
                      disabled={mitarbeitSpeichern || !selectedKlasseFach}
                      style={{ flex: 1, padding: '10px 14px', background: 'var(--ld-success)', color: 'white', border: 'none', borderRadius: 10, fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: (mitarbeitSpeichern || !selectedKlasseFach) ? 0.6 : 1 }}
                    >
                      {mitarbeitSpeichern ? 'Speichert …' : 'Alle übernehmen'}
                    </button>
                    <button
                      onClick={() => { setMitarbeitEntries([]); onClose(); }}
                      style={{ padding: '10px 14px', background: 'var(--ld-bg-muted)', border: 'none', borderRadius: 10, fontSize: 13, fontWeight: 600, cursor: 'pointer', color: 'var(--ld-text-primary)' }}
                    >
                      Überspringen
                    </button>
                  </div>
                  {!selectedKlasseFach && (
                    <div style={{ fontSize: 11, color: '#DC2626', marginTop: 6 }}>Bitte Klasse/Fach oben auswählen</div>
                  )}
                </div>
              )}

              {mitarbeitEntries.length === 0 && (
                <Button variant="primary" onClick={onClose} style={{ marginTop: 14 }}>Schließen</Button>
              )}
            </div>
          )}

          {/* ── Eingabe-Bereich ── */}
          {erfolge.length === 0 && (
            <div style={{ padding: '18px 22px 24px' }}>

              {/* Fach-Auswahl */}
              {meineKlassen.length > 0 && (
                <LdAuswahl value={selectedKlasseFach ? String(selectedKlasseFach.id) : ''} onChange={e => {
                    const found = meineKlassen.find(k => String(k.id) === e.target.value);
                    setSelectedKlasseFach(found ?? null);
                  }}>
                  <option value=''>Alle Klassen & Fächer</option>
                  {meineKlassen.map(k => (
                    <option key={k.id} value={String(k.id)}>
                      Kl. {k.klasse_name} · {k.fach}
                    </option>
                  ))}
                </LdAuswahl>
              )}

              {/* Klassenbuch-Toggle */}
              <div style={{
                display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16,
                padding: '8px 12px', borderRadius: 'var(--ld-radius-md)',
                background: fuerKlassenbuch ? '#EBF5FF' : '#F8F8FA',
                border: `1px solid ${fuerKlassenbuch ? BLUE + '40' : '#E5E5EA'}`,
                cursor: 'pointer',
              }} onClick={() => setFuerKlassenbuch(v => !v)}>
                <input type="checkbox" checked={fuerKlassenbuch} onChange={() => setFuerKlassenbuch(v => !v)}
                  style={{ accentColor: BLUE, width: 15, height: 15, cursor: 'pointer' }} onClick={e => e.stopPropagation()} />
                <span style={{ fontSize: 13, fontWeight: 600, color: fuerKlassenbuch ? BLUE : '#3C3C43', flex: 1, display: 'flex', alignItems: 'center', gap: 6 }}>
                  <MIcon name="menu_book" size={15} /> Auch ins Klassenbuch eintragen
                </span>
                {fuerKlassenbuch && (
                  <span onClick={e => e.stopPropagation()}>
                    <LdAuswahl aria-label="Stunde" value={kbStunde} onChange={e => setKbStunde(Number(e.target.value))}>
                      {[1,2,3,4,5,6,7,8,9,10].map(n => <option key={n} value={n}>{n}. Std.</option>)}
                    </LdAuswahl>
                  </span>
                )}
              </div>

              {/* Modus-Tabs */}
              <div style={{
                display: 'flex', gap: 6, marginBottom: 22,
                background: 'var(--ld-primary-light)', borderRadius: 14, padding: 5,
              }}>
                {MODI.map(m => (
                  <button key={m.key} onClick={() => setModus(m.key)} style={{
                    flex: 1, padding: '10px 0', borderRadius: 10, border: 'none', cursor: 'pointer',
                    background: modus === m.key ? 'white' : 'transparent',
                    color: modus === m.key ? 'var(--ld-primary)' : 'var(--ld-text-tertiary)',
                    fontSize: 13, fontWeight: modus === m.key ? 700 : 500,
                    boxShadow: modus === m.key ? '0 2px 8px rgba(107, 95, 212,0.15)' : 'none',
                    transition: 'all 0.2s ease',
                  }}>
                    {m.icon} {m.label}
                  </button>
                ))}
              </div>

              {/* ── SPRECHEN ── */}
              {modus === 'sprechen' && (
                <div style={{ textAlign: 'center', padding: '8px 0 4px' }}>
                  <p style={{ color: 'var(--ld-text-secondary)', fontSize: 13, marginBottom: 24, lineHeight: 1.6 }}>
                    Drücken Sie auf das Mikrofon und sprechen Sie Ihre Beobachtung.<br />
                    Whisper transkribiert · Claude kategorisiert automatisch.
                  </p>

                  {/* Mikrofon-Button */}
                  <button
                    onClick={handleSprechenKlick}
                    disabled={phase === 'transkribiert' || phase === 'analysiert'}
                    style={{
                      width: 96, height: 96, borderRadius: '50%', border: 'none',
                      cursor: (phase === 'transkribiert' || phase === 'analysiert') ? 'default' : 'pointer',
                      background: phase === 'aufnahme'
                        ? 'var(--ld-danger)'
                        : 'var(--ld-primary)',
                      fontSize: 38, display: 'flex', alignItems: 'center',
                      justifyContent: 'center', margin: '0 auto 20px',
                      animation: phase === 'aufnahme' ? 'micPulse 1.2s ease-in-out infinite' : 'none',
                      boxShadow: phase === 'aufnahme'
                        ? '0 0 0 0 rgba(255,107,107,0.5), 0 8px 28px rgba(255,107,107,0.4)'
                        : '0 8px 28px rgba(107, 95, 212,0.45)',
                      transition: 'background 0.3s, box-shadow 0.3s',
                      opacity: (phase === 'transkribiert' || phase === 'analysiert') ? 0.6 : 1,
                    }}
                  >
                    <MIcon name={phase === 'aufnahme' ? 'stop' : phase === 'transkribiert' ? 'hourglass_top' : 'mic'} size={30} />
                  </button>

                  {/* Status-Anzeige */}
                  {phase === 'idle' && (
                    <div style={{ color: '#C7C7CC', fontSize: 13 }}>
                      Tippen Sie auf das Mikrofon zum Starten
                    </div>
                  )}

                  {phase === 'aufnahme' && (
                    <div>
                      <div style={{ color: '#FF6B6B', fontSize: 14, fontWeight: 600, marginBottom: 12 }}>
                        Aufnahme läuft — nochmals klicken zum Stoppen
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: 5, height: 36 }}>
                        {[0.9, 1.1, 0.7, 1.3, 0.8, 1.2, 0.6, 1.0, 0.8].map((delay, i) => (
                          <div key={i} style={{
                            width: 5, borderRadius: 3, background: 'var(--ld-primary)', height: 8,
                            animation: `waveBar ${delay}s ease-in-out ${i * 0.06}s infinite alternate`,
                          }} />
                        ))}
                      </div>
                    </div>
                  )}

                  {(phase === 'transkribiert') && (
                    <div style={{ color: BLUE, fontSize: 13, fontWeight: 600 }}>
                      <span style={{
                        display: 'inline-block', width: 14, height: 14,
                        border: `2px solid ${BLUE}`, borderTopColor: 'transparent',
                        borderRadius: '50%', animation: 'spin .6s linear infinite',
                        marginRight: 6, verticalAlign: 'middle',
                      }} />
                      {statusText}
                    </div>
                  )}

                  {phase === 'fehler' && apiFehler && (
                    <div style={{
                      background: '#FEF2F2', border: '1px solid #FECACA',
                      borderRadius: 'var(--ld-radius-md)', padding: '10px 14px',
                      fontSize: 13, color: '#DC2626', marginTop: 8, textAlign: 'left',
                    }}>
                      {apiFehler}
                      <div style={{ marginTop: 8 }}>
                        <button onClick={() => setPhase('idle')} style={{
                          background: 'none', border: 'none', color: BLUE,
                          cursor: 'pointer', fontSize: 12, fontWeight: 600, padding: 0,
                        }}>Erneut versuchen</button>
                      </div>
                    </div>
                  )}

                  {/* Backend-Status-Hinweis */}
                  {phase === 'idle' && (
                    <div style={{
                      marginTop: 16, padding: '8px 12px',
                      background: 'var(--ld-primary-light)', borderRadius: 'var(--ld-radius-sm)',
                      fontSize: 11, color: 'var(--ld-primary)',
                    }}>
                      Backend auf <strong>{API_BASE}</strong> muss laufen
                    </div>
                  )}
                </div>
              )}

              {/* ── TIPPEN ── */}
              {modus === 'tippen' && (
                <div>
                  <p style={{ color: 'var(--ld-text-secondary)', fontSize: 13, marginBottom: 12, lineHeight: 1.6 }}>
                    Beschreiben Sie Ihre Beobachtung. Die KI erkennt den Schüler und kategorisiert den Eintrag.
                  </p>
                  <textarea
                    autoFocus
                    value={tippText}
                    onChange={e => setTippText(e.target.value)}
                    placeholder="z. B. »Tom Bergmann war heute sehr abgelenkt und hat die Hausaufgaben nicht dabei.«"
                    rows={4}
                    style={{
                      width: '100%', padding: '12px 14px', borderRadius: 'var(--ld-radius-md)',
                      border: '1.5px solid var(--ld-outline-soft)', fontSize: 14, outline: 'none',
                      background: 'var(--ld-bg-input)', color: 'var(--ld-text-primary)', resize: 'vertical',
                      lineHeight: 1.6, boxSizing: 'border-box', fontFamily: 'inherit',
                      transition: 'border-color .15s',
                    }}
                    onFocus={e  => (e.target.style.borderColor = BLUE)}
                    onBlur={e   => (e.target.style.borderColor = '#E5E5EA')}
                    onKeyDown={e => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) handleTippen(); }}
                  />
                  {tippFehler && (
                    <div style={{
                      background: '#FEF2F2', border: '1px solid #FECACA',
                      borderRadius: 'var(--ld-radius-md)', padding: '8px 12px', marginTop: 8,
                      fontSize: 12, color: '#DC2626',
                    }}>{tippFehler}</div>
                  )}
                  <div style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', marginTop: 12,
                  }}>
                    <span style={{ fontSize: 12, color: '#C7C7CC' }}>⌘ ↵ zum Speichern</span>
                    <button onClick={handleTippen} disabled={!tippText.trim() || tippLaden} style={{
                      background: tippText.trim() && !tippLaden ? BLUE : '#E5E5EA',
                      color: tippText.trim() && !tippLaden ? 'white' : '#8E8E93',
                      border: 'none', borderRadius: 'var(--ld-radius-md)', padding: '10px 22px',
                      fontSize: 14, fontWeight: 600,
                      cursor: tippText.trim() && !tippLaden ? 'pointer' : 'default',
                      transition: 'all .15s',
                      display: 'flex', alignItems: 'center', gap: 7,
                    }}>
                      {tippLaden && <span style={{
                        width: 13, height: 13, border: '2px solid white',
                        borderTopColor: 'transparent', borderRadius: '50%',
                        display: 'inline-block', animation: 'spin .6s linear infinite',
                      }} />}
                      {tippLaden ? 'Analysiert …' : 'KI analysieren →'}
                    </button>
                  </div>
                </div>
              )}

              {/* ── SCHNELL-BUTTONS ── */}
              {modus === 'schnell' && (
                <div>
                  <p style={{ color: 'var(--ld-text-secondary)', fontSize: 13, marginBottom: 14, lineHeight: 1.6 }}>
                    Schüler auswählen und Schnell-Aktion antippen.
                  </p>

                  {/* Schüler-Picker – Mehrfachauswahl */}
                  <div style={{ marginBottom: 18 }}>
                    <label style={{
                      fontSize: 11, fontWeight: 600, color: 'var(--ld-text-secondary)', letterSpacing: .6,
                      display: 'block', marginBottom: 7,
                    }}>
                      Schüler auswählen ({schnellAusgewaehlt.size} gewählt)
                    </label>
                    <div style={{
                      maxHeight: 180, overflowY: 'auto', borderRadius: 'var(--ld-radius-md)',
                      border: '1.5px solid var(--ld-outline-soft)', background: 'white',
                    }}>
                      {schuelerListe.map((s, i) => {
                        const checked = schnellAusgewaehlt.has(i);
                        return (
                          <label key={s.id} style={{
                            display: 'flex', alignItems: 'center', gap: 10,
                            padding: '8px 12px', cursor: 'pointer',
                            background: checked ? BLUE + '10' : 'transparent',
                            borderBottom: i < schuelerListe.length - 1 ? '1px solid var(--ld-border-light)' : 'none',
                          }}>
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={() => {
                                setSchnellAusgewaehlt(prev => {
                                  const next = new Set(prev);
                                  next.has(i) ? next.delete(i) : next.add(i);
                                  return next;
                                });
                              }}
                              style={{ accentColor: BLUE, width: 16, height: 16 }}
                            />
                            <div style={{
                              width: 28, height: 28, borderRadius: '50%',
                              background: BLUE + '20', display: 'flex', alignItems: 'center',
                              justifyContent: 'center', fontSize: 10, fontWeight: 700, color: BLUE,
                              flexShrink: 0,
                            }}>
                              {s.avatar}
                            </div>
                            <span style={{ fontSize: 13, color: 'var(--ld-text-primary)' }}>{s.name}</span>
                          </label>
                        );
                      })}
                    </div>
                  </div>

                  {/* 4 Aktions-Buttons */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                    {SCHNELL_AKTIONEN.map((sa, i) => (
                      <button key={sa.label} onClick={() => handleSchnell(i)} style={{
                        padding: '15px 10px', borderRadius: 'var(--ld-radius-md)',
                        border: `1.5px solid ${sa.color}40`,
                        background: sa.bg, color: sa.color, cursor: 'pointer',
                        fontSize: 14, fontWeight: 600,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                        transition: 'opacity .12s',
                      }}
                        onMouseEnter={e => (e.currentTarget.style.opacity = '0.75')}
                        onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
                      >
                        <MIcon name={sa.icon} size={20} />
                        {sa.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
    </>
  );
}

// ── Unterricht (Klassenbuch + Notizen kombiniert) ──────────────────────────
// Welle U8: vorgabeKlasseId = Klasse oben im Klassen-Screen (eingebettet); ohne = eigenständig
// Welle K1: art/aktiv = Unterreiter aus dem Klassenkopf (keine eigene Leiste); aktiv steuert, wer den
// schwebenden Mikro-Knopf belegt (nur die sichtbare Ansicht).
function UnterrichtAnsicht({ vorgabeKlasseId, art, aktiv = true }: { vorgabeKlasseId?: number | null; art?: 'klassenbuch' | 'notizen'; aktiv?: boolean } = {}) {
  const [subTabLokal, setSubTab] = useState<'klassenbuch' | 'notizen'>('klassenbuch');
  const subTab = art ?? subTabLokal;

  return (
    <div className="ld-page-enter">
      {art === undefined && <div style={{ display: 'flex', background: 'transparent', borderRadius: 'var(--ld-radius-full)', padding: 4, gap: 4, marginBottom: 20, width: 'fit-content' }}>
        {([
          { key: 'klassenbuch' as const, label: 'Klassenbuch' },
          { key: 'notizen'     as const, label: 'Schüler-Notizen' },
        ]).map(({ key, label }) => (
          <button key={key} onClick={() => setSubTab(key)} style={{
            padding: '7px 18px', borderRadius: 'var(--ld-radius-full)', border: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: subTab === key ? 700 : 500,
            background: subTab === key ? 'var(--ld-primary)' : 'transparent',
            color: subTab === key ? 'white' : 'var(--ld-text-secondary)',
            boxShadow: subTab === key ? 'var(--ld-shadow-sm)' : 'none',
            transition: 'all .15s', whiteSpace: 'nowrap',
          }}>{label}</button>
        ))}
      </div>}
      <div style={{ display: subTab === 'klassenbuch' ? 'block' : 'none' }}>
        <KlassenbuchScreen active={aktiv && subTab === 'klassenbuch'} vorgabeKlasseId={vorgabeKlasseId} />
      </div>
      <div style={{ display: subTab === 'notizen' ? 'block' : 'none' }}>
        <NotizenAnsicht onTabActivate={art === undefined ? () => setSubTab('notizen') : undefined} active={aktiv && subTab === 'notizen'} vorgabeKlasseId={vorgabeKlasseId} />
      </div>
    </div>
  );
}

// ── Notizen-Hauptansicht ───────────────────────────────────────────────────
function NotizenAnsicht({ onTabActivate, active = true, vorgabeKlasseId }: { onTabActivate?: () => void; active?: boolean; vorgabeKlasseId?: number | null } = {}) {
  const [modalOffen, setModalOffen] = useState(false);

  // FAB-Handler: öffnet Notiz-Diktat-Modal
  const { setFabHandler } = useFab();
  const notizStreamRef = React.useRef<Promise<MediaStream> | null>(null);
  useEffect(() => {
    if (!active) return;
    setFabHandler(() => {
      // Pre-acquire stream in gesture context (iOS Safari: getUserMedia only works here)
      notizStreamRef.current = mikrofonAnfragen();
      onTabActivate?.();
      setModalOffen(true);
    });
    return () => { setFabHandler(null); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, onTabActivate]);

  // Welle U4b: Liste, Filter, Bearbeiten etc. im NotizenBereich; Diktieren bleibt hier.
  return (
    <>
      {/* Welle K2: kein zusätzliches Mikro — der schwebende Knopf startet hier das Notiz-Diktat, am PC „Erzählen“ */}
      <NotizenBereich vorgabeKlasseId={vorgabeKlasseId} />
      {/* ── Modal ── vaul-Sheet von unten, Inhaltshöhe + scrollbar (kein fullscreen → nicht zentriert/abgeschnitten) */}
      <LdSheet open={modalOffen} onClose={() => { setModalOffen(false); notizStreamRef.current = null; }} maxWidth={560} ariaLabel="Neue Notiz">
        {modalOffen && (
          <NeueNotizModal
            streamPromise={notizStreamRef.current}
            onSave={() => { /* Speichern + Neuladen erledigt NeueNotizModal (signalNotizenGeaendert) */ }}
            onClose={() => { setModalOffen(false); notizStreamRef.current = null; }}
          />
        )}
      </LdSheet>
    </>
  );
}

// ── Mail-Typen & Helpers ─────────────────────────────────────────────────────


// ── Noten-Ansicht ──────────────────────────────────────────────────────────

function NoteEingabeModal({
  schueler, klasse_id, fach, halbjahr, schuljahr,
  onSave, onClose,
}: {
  schueler: { id: number; name: string };
  klasse_id: number;
  fach: string;
  halbjahr: 'HJ1' | 'HJ2';
  schuljahr: string;
  onSave: (n: DbNote) => void;
  onClose: () => void;
}) {
  const heute = new Date().toISOString().split('T')[0];
  const [art,       setArt]       = useState<'KA' | 'Test' | 'Sonstiges'>('KA');
  const [note,      setNote]      = useState(3);
  const [gewicht,   setGewicht]   = useState(1.0);
  const [datum,     setDatum]     = useState(heute);
  const [kommentar, setKommentar] = useState('');
  const [laden,     setLaden]     = useState(false);
  const [fehler,    setFehler]    = useState('');

  async function speichern() {
    setLaden(true); setFehler('');
    try {
      const neu = await apiPost<DbNote>('/api/noten', {
        schueler_id: schueler.id, klasse_id, fach, art, note,
        gewichtung: gewicht, datum, halbjahr, schuljahr,
        kommentar: kommentar || null,
      });
      toast('Note gespeichert');
      onSave(neu);
    } catch (e) { setFehler(e instanceof Error ? e.message : 'Verbindung zum Server fehlgeschlagen.'); }
    finally { setLaden(false); }
  }

  const c = notenFarbeKMK(note);
  return (
    <LdSheet open onClose={onClose} maxWidth={480} kopf={{ titel: 'Note eintragen', kontext: `${schueler.name}, ${fach}, ${halbjahr}` }}>
        <div style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: 14 }}>
          {/* Art */}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ld-text-secondary)', display: 'block', marginBottom: 6 }}>Art der Leistung</label>
            <div style={{ display: 'flex', gap: 6 }}>
              {(['KA', 'Test', 'Sonstiges'] as const).map(a => (
                <button key={a} onClick={() => setArt(a)} style={{
                  flex: 1, padding: '8px 4px', borderRadius: 'var(--ld-radius-sm)', border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 700,
                  background: art === a ? ART_FARBE[a] : 'var(--ld-bg-input)',
                  color: art === a ? 'white' : 'var(--ld-text-secondary)',
                }}>{ART_LABEL[a].split(' ')[0]}</button>
              ))}
            </div>
          </div>
          {/* Note */}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ld-text-secondary)', display: 'block', marginBottom: 6 }}>Note</label>
            <div style={{ display: 'flex', gap: 8 }}>
              {[1,2,3,4,5,6].map(n => (
                <button key={n} onClick={() => setNote(n)} style={{
                  flex: 1, height: 44, borderRadius: 'var(--ld-radius-md)', border: 'none', cursor: 'pointer', fontSize: 17, fontWeight: 800,
                  background: note === n ? notenFarbeKMK(n) : 'var(--ld-bg-input)',
                  color: note === n ? 'white' : '#8E8E93',
                  boxShadow: note === n ? `0 2px 8px ${notenFarbeKMK(n)}50` : 'none',
                  transition: 'all .1s',
                }}>{n}</button>
              ))}
            </div>
          </div>
          {/* Datum */}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ld-text-secondary)', display: 'block', marginBottom: 6 }}>Datum</label>
            <LdDatum value={datum} onChange={e => setDatum(e.target.value)} />
          </div>
          {/* Gewichtung */}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ld-text-secondary)', display: 'block', marginBottom: 6 }}>
              Gewichtung (1 = einfach, 2 = doppelt)
            </label>
            <div style={{ display: 'flex', gap: 6 }}>
              {[0.5, 1, 1.5, 2].map(g => (
                <button key={g} onClick={() => setGewicht(g)} style={{
                  flex: 1, padding: '7px 4px', borderRadius: 'var(--ld-radius-sm)', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 700,
                  background: gewicht === g ? 'var(--ld-accent)' : 'var(--ld-bg-input)' as any,
                  color: gewicht === g ? 'white' : 'var(--ld-text-secondary)' as any,
                }}>×{g}</button>
              ))}
            </div>
            {/* Welle N2: vor dem Speichern sagen, wie die Note zählt */}
            <div role="status" style={{ fontSize: 12, color: 'var(--ld-text-secondary)', marginTop: 6 }}>{zaehltText(art, gewicht)}</div>
          </div>
          {/* Kommentar */}
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ld-text-secondary)', display: 'block', marginBottom: 6 }}>Kommentar (optional)</label>
            <input value={kommentar} onChange={e => setKommentar(e.target.value)} placeholder="z.B. Klausur war sehr gut"
              style={{ width: '100%', padding: '9px 12px', border: 'none', borderRadius: 'var(--ld-radius-md)' as any, fontSize: 14, outline: 'none', boxSizing: 'border-box' as const, background: 'var(--ld-bg-input)' as any }} />
          </div>
          {fehler && <div style={{ fontSize: 13, color: 'var(--ld-danger-text)' as any, padding: '8px 12px', background: 'var(--ld-danger-soft)' as any, borderRadius: 'var(--ld-radius-sm)' as any }}>{fehler}</div>}
          <button onClick={speichern} disabled={laden} style={{
            padding: '12px', borderRadius: 'var(--ld-radius-md)', border: 'none', cursor: laden ? 'default' : 'pointer',
            background: c, color: 'white', fontSize: 15, fontWeight: 700,
            boxShadow: `0 2px 10px ${c}50`,
          }}>
            {laden ? 'Speichern …' : `Note ${note} speichern`}
          </button>
        </div>
    </LdSheet>
  );
}

// Welle U8: vorgabeKlasseId gesetzt = eingebettet im Klassen-Screen — die Klasse oben gilt,
// innen bleibt nur die Fach-Auswahl dieser Klasse. Ohne (eigenständig) wie bisher.
function NotenAnsicht({ vorgabeKlasseId }: { vorgabeKlasseId?: number | null } = {}) {
  const eingebettet = vorgabeKlasseId !== undefined;
  const vorgabeRef = useRef(vorgabeKlasseId);
  vorgabeRef.current = vorgabeKlasseId;
  const { schuelerListe } = useSchueler();
  const isMobile = useIsMobile();

  const [meineKlassen,   setMeineKlassen]   = useState<KlasseFachEintrag[]>([]);
  const [aktiveKlasse,   setAktiveKlasse]   = useState<KlasseFachEintrag | null>(null);
  const [halbjahr,       setHalbjahr]       = useState<'HJ1' | 'HJ2'>(() => {
    const m = new Date().getMonth() + 1; // 1–12
    return (m >= 8 || m <= 1) ? 'HJ1' : 'HJ2';
  });
  const [noten,          setNoten]          = useState<DbNote[]>([]);
  const [endnoten,       setEndnoten]       = useState<HjEndnote[]>([]);
  const [laden,          setLaden]          = useState(false);
  const [eingabeModal,   setEingabeModal]   = useState<{ id: number; name: string } | null>(null);
  const [expandiert,     setExpandiert]     = useState<Set<number>>(new Set());
  // Welle U6a: Notenchips öffnen das gemeinsame NoteSheet (Bearbeiten + Löschen)
  const [noteEdit, setNoteEdit] = useState<{ note: DbNote; schueler: { id: number; name: string; klasse_id: number | null } } | null>(null);
  const letzteNoteEdit = React.useRef<typeof noteEdit>(null);
  useEffect(() => { if (noteEdit) letzteNoteEdit.current = noteEdit; }, [noteEdit]);
  const [hj1HatDaten,    setHj1HatDaten]    = useState(false);
  const [ankerModal,     setAnkerModal]     = useState<{ id: number; name: string } | null>(null);
  const [ankerNote,      setAnkerNote]      = useState('3');
  const [ankerHj,        setAnkerHj]        = useState<1 | 2>(2);
  // Welle N2: Vorjahresnote ist nur noch Information; Schuljahr wird gewählt (JJJJ/JJJJ), nicht getippt
  const ankerSchuljahre = fruehereSchuljahre();
  const [ankerSchuljahr, setAnkerSchuljahr] = useState(() => ankerSchuljahre[0]);
  const [ankerSpeichern, setAnkerSpeichern] = useState(false);
  const [hj1Modal, setHj1Modal] = useState<{ id: number; name: string } | null>(null);
  const [einstellungenOffen, setEinstellungenOffen] = useState(false);
  // Welle N1/N2: Teilwerte, Halbjahresnote, Gewichtung und Regeltext kommen vom Server
  // (/api/noten/berechnet) — dieselbe Rechnung wie Profil, Notenblatt und Übergang.
  type NoteBerechnet = {
    schueler_id: number;
    wert: number | null;
    status: 'final' | 'vorlaeufig' | 'offen';
    tendenz: number | null;
    berechnet: number | null;
    schriftlich: number | null;
    muendlich: number | null;
    muendlich_offen: boolean;
    anker: number | null;
    anker_referenz: { halbjahr: number; schuljahr: string } | null;
    hj1_endnote_fehlt: boolean;
    verrechnet: boolean;
    endnote: number | null;
    vorjahr: { schuljahr: string; halbjahr: number; zeugnisnote: number } | null;
    grundlage: { ka_geschrieben: number; ka_geplant: number; wochen_beobachtet: number; wochen_gesamt: number; einzelnoten: number; einzelnoten_gewicht: number };
    // Welle K1: Klassenarbeiten des Kindes (geschrieben, geplant, laut Einstellungen noch ohne Termin)
    klassenarbeiten?: { status: 'geschrieben' | 'geplant' | 'ohne_termin'; art: string; datum?: string; termin_id?: number; nummer?: number }[];
  };
  type Regel = { gewichtung: { schriftlich: number; muendlich: number; ist_voreinstellung?: boolean }; regeltext: string; regel_kurz: string };
  // Welle K1: Halbjahr-Menü (Handy), „Wie wird gerechnet?“ (PC)
  const [hjMenuOffen, setHjMenuOffen] = useState(false);
  const hjKnopf = useRef<HTMLButtonElement>(null);
  const [rechnungOffen, setRechnungOffen] = useState(false);
  const { setOpenProfilId } = useSchueler();
  const [regel, setRegel] = useState<Regel | null>(null);
  const [berechnet, setBerechnet] = useState<Record<number, NoteBerechnet>>({});
  const [berechnetFehler, setBerechnetFehler] = useState(false);
  const [neuRechnen, setNeuRechnen] = useState(0);
  const nachAenderung = () => setNeuRechnen(n => n + 1);
  // Korrekt berechnet: Jan–Jul gehört zum Vorjahres-Schuljahr (z. B. April 2026 → 2025/2026)
  const aktuellesSchuljahr = (() => {
    const m = new Date().getMonth() + 1;
    const y = new Date().getFullYear();
    return m >= 8 ? `${y}/${y + 1}` : `${y - 1}/${y}`;
  })();

  useEffect(() => {
    fetch(`${API_BASE}/api/meine-klassen`, { headers: apiHeaders() })
      .then(leseFallback<KlasseFachEintrag[]>([], '/api/meine-klassen'))
      .then((data: KlasseFachEintrag[]) => {
        setMeineKlassen(data);
        if (data.length > 0) setAktiveKlasse(prev => prev ?? (eingebettet
          ? data.find(k => Number(k.klasse_id) === Number(vorgabeRef.current)) ?? null
          : data[0]));
      }).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Welle U8: eingebettet der Klasse oben folgen (erstes Fach dieser Klasse) und dabei
  // offene Fenster/Formulare schließen — keine Mischung aus alter und neuer Klasse
  useEffect(() => {
    if (!eingebettet || meineKlassen.length === 0) return;
    setAktiveKlasse(prev => Number(prev?.klasse_id) === Number(vorgabeKlasseId) ? prev
      : meineKlassen.find(k => Number(k.klasse_id) === Number(vorgabeKlasseId)) ?? null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eingebettet, vorgabeKlasseId, meineKlassen]);
  const vorigeVorgabe = useRef(vorgabeKlasseId);
  useEffect(() => {
    if (vorigeVorgabe.current === vorgabeKlasseId) return;
    vorigeVorgabe.current = vorgabeKlasseId;
    setEingabeModal(null); setNoteEdit(null); setAnkerModal(null);
    setExpandiert(new Set());
  }, [vorgabeKlasseId]);
  const auswahlKlassen = eingebettet ? meineKlassen.filter(k => Number(k.klasse_id) === Number(vorgabeKlasseId)) : meineKlassen;

  // Beim Klassenwechsel prüfen ob HJ1-Noten existieren (für Toggle-Sichtbarkeit)
  useEffect(() => {
    if (!aktiveKlasse) { setHj1HatDaten(false); return; }
    fetch(
      `${API_BASE}/api/noten/klasse?klasse_id=${aktiveKlasse.klasse_id}&fach=${encodeURIComponent(aktiveKlasse.fach)}&halbjahr=HJ1`,
      { headers: apiHeaders() }
    ).then(leseFallback<DbNote[]>([], '/api/noten/klasse HJ1'))
     .then((d: DbNote[]) => setHj1HatDaten(d.length > 0))
     .catch(() => setHj1HatDaten(false));
  }, [aktiveKlasse?.klasse_id, aktiveKlasse?.fach]); // eslint-disable-line react-hooks/exhaustive-deps

  // Welle B2: nach dem Speichern der Klassenarbeits-Liste neu laden (neue Objekt-Identität)
  useEffect(() => {
    const h = () => setAktiveKlasse(prev => (prev ? { ...prev } : prev));
    window.addEventListener('ld-noten-geaendert', h);
    return () => window.removeEventListener('ld-noten-geaendert', h);
  }, []);

  // Welle U8: nur die jüngste Anfrage zählt (schneller Klassen-/Fachwechsel)
  const notenLadeNr = useRef(0);
  const berechnetLadeNr = useRef(0);
  useEffect(() => {
    if (!aktiveKlasse) return;
    setLaden(true);
    const nr = ++notenLadeNr.current;
    Promise.all([
      fetch(`${API_BASE}/api/noten/klasse?klasse_id=${aktiveKlasse.klasse_id}&fach=${encodeURIComponent(aktiveKlasse.fach)}&halbjahr=${halbjahr}`, { headers: apiHeaders() }).then(leseFallback<any[]>([], '/api/noten/klasse')),
      fetch(`${API_BASE}/api/halbjahres-note?klasse_id=${aktiveKlasse.klasse_id}&fach=${encodeURIComponent(aktiveKlasse.fach)}&halbjahr=${halbjahr}`, { headers: apiHeaders() }).then(leseFallback<any[]>([], '/api/halbjahres-note')),
    ]).then(([n, e]) => {
      if (nr !== notenLadeNr.current) return;
      setNoten(n);
      // Welle N1: nur Endnoten des laufenden Schuljahrs (vorher auch die des Vorjahrs)
      setEndnoten((e as HjEndnote[]).filter(x => String(x.schuljahr ?? '').slice(0, 4) === aktuellesSchuljahr.slice(0, 4)));
    }).catch(() => {}).finally(() => { if (nr === notenLadeNr.current) setLaden(false); });
  }, [aktiveKlasse, halbjahr]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!aktiveKlasse?.klasse_id || !aktiveKlasse?.fach) { setBerechnet({}); return; }
    const nr = ++berechnetLadeNr.current;
    apiFetch<{ schueler: NoteBerechnet[] } & Regel>(`/api/noten/berechnet?klasse_id=${aktiveKlasse.klasse_id}&fach=${encodeURIComponent(aktiveKlasse.fach)}&halbjahr=${halbjahr}&schuljahr=${encodeURIComponent(aktuellesSchuljahr)}`)
      .then(d => {
        if (nr !== berechnetLadeNr.current) return;
        const map: Record<number, NoteBerechnet> = {};
        (d.schueler ?? []).forEach(row => { map[row.schueler_id] = row; });
        setBerechnet(map); setBerechnetFehler(false);
        setRegel({ gewichtung: d.gewichtung, regeltext: d.regeltext, regel_kurz: d.regel_kurz });
      })
      .catch(() => { if (nr === berechnetLadeNr.current) { setBerechnet({}); setBerechnetFehler(true); setRegel(null); } });
  }, [aktiveKlasse?.klasse_id, aktiveKlasse?.fach, halbjahr, aktuellesSchuljahr, neuRechnen]); // eslint-disable-line react-hooks/exhaustive-deps


  const klassenSchueler = aktiveKlasse
    ? schuelerListe.filter(s => Number(s.klasse_id) === Number(aktiveKlasse.klasse_id))
    : [];

  async function ankerNoteEinreichen() {
    if (!ankerModal || !aktiveKlasse) return;
    setAnkerSpeichern(true);
    try {
      await apiPost('/api/vorjahres-noten', {
        schueler_id: ankerModal.id,
        fach: aktiveKlasse.fach,
        schuljahr: ankerSchuljahr,
        halbjahr: ankerHj,
        zeugnisnote: Number(ankerNote),
      });
      toast('Vorjahresnote gespeichert (zählt nicht mit)'); setAnkerModal(null); nachAenderung();
    } catch (e) { zeigeApiFehler(e, 'Fehler beim Speichern'); }
    finally { setAnkerSpeichern(false); }
  }

  const notenFuerSchueler = (sid: number) => noten.filter(n => n.schueler_id === sid);
  const endnoteFuerSchueler = (sid: number): HjEndnote | null => endnoten.find(e => e.schueler_id === sid) ?? null;
  // Welle N1/N2: wie die Halbjahresnote zustande kommt — in Worten, mit Komma; Gewichtung vom Server
  const hatMdl = (b: NoteBerechnet) => b.grundlage.wochen_beobachtet + b.grundlage.einzelnoten_gewicht > 0;
  function erklaerung(b: NoteBerechnet): string {
    const g = b.grundlage;
    const teile = [
      `${g.ka_geschrieben} ${g.ka_geschrieben === 1 ? 'Klassenarbeit oder Test' : 'Klassenarbeiten und Tests'}${b.schriftlich != null ? ` (Schnitt ${noteKomma(b.schriftlich)})` : ''}`,
      `${g.wochen_beobachtet} von ${g.wochen_gesamt} Schulwochen mündlich beobachtet${g.einzelnoten ? `, dazu ${g.einzelnoten} ${g.einzelnoten === 1 ? 'Einzelnote' : 'Einzelnoten'} (wie ${String(g.einzelnoten_gewicht).replace('.', ',')} ${g.einzelnoten_gewicht === 1 ? 'Woche' : 'Wochen'})` : ''}${b.muendlich != null && hatMdl(b) ? ` (Schnitt ${noteKomma(b.muendlich)}${b.muendlich_offen ? ', noch nicht belastbar' : ''})` : ''}`,
    ];
    let text = teile.join(', ') + '.';
    if (b.schriftlich != null && b.muendlich != null && regel) text += ` Schriftlich zählt ${regel.gewichtung.schriftlich} %, mündlich ${regel.gewichtung.muendlich} %.`;
    else if (b.schriftlich == null && b.muendlich != null) text += ' Ohne Klassenarbeit zählt vorerst nur Mündlich.';
    if (b.verrechnet && b.anker != null) text += ` Halb und halb verrechnet mit deiner HJ1-Endnote ${b.anker}.`;
    if (b.vorjahr) text += ` Vorjahr: ${noteKomma(b.vorjahr.zeugnisnote)} (Halbjahr ${b.vorjahr.halbjahr} ${schuljahrKurz(b.vorjahr.schuljahr)}), zählt nicht mit.`;
    if (b.status === 'offen') text += b.tendenz != null ? ` Noch zu wenig Grundlage für eine Note, Tendenz ${noteKomma(b.tendenz)}.` : ' Noch zu wenig Grundlage für eine Note.';
    if (b.status === 'final') text += ` Es gilt deine Endnote ${b.endnote}.`;
    return text;
  }

  function toggleExpand(sid: number) {
    setExpandiert(prev => { const neu = new Set(prev); if (neu.has(sid)) neu.delete(sid); else neu.add(sid); return neu; });
  }

  async function speichereEndnote(schueler_id: number, endnote: number) {
    if (!aktiveKlasse) return;
    try {
      const g = await apiPost<HjEndnote>('/api/halbjahres-note',
        { schueler_id, klasse_id: aktiveKlasse.klasse_id, fach: aktiveKlasse.fach, halbjahr, schuljahr: aktuellesSchuljahr, endnote });
      setEndnoten(prev => [...prev.filter(e => e.schueler_id !== schueler_id), g]);
      nachAenderung();
    } catch (e) { zeigeApiFehler(e, 'Endnote speichern fehlgeschlagen'); }
  }

  // Welle N1: Statistik nur über echte Noten; „noch offen“ wird gezählt, nicht als Note gewertet
  const gesamtNoten = klassenSchueler.map(s => berechnet[s.id]?.wert).filter((n): n is number => n != null);
  const nOffen      = klassenSchueler.filter(s => berechnet[s.id]?.status === 'offen').length;
  const schnittGes  = gesamtNoten.length > 0 ? gesamtNoten.reduce((a, b) => a + b, 0) / gesamtNoten.length : null;
  // Welle Z4: Verteilung 1–6 nach dem ANGEZEIGTEN Wert (eine Nachkommastelle): bis x,5 zur Note x
  // (2,5 → 2), ab x,6 zur nächsten; Endnoten sind ganze Noten, „noch offen“ zählt nicht.
  const verteilung = [1, 2, 3, 4, 5, 6].map(n => gesamtNoten.filter(w => notenStufe(w) === n).length);
  const maxVert = Math.max(1, ...verteilung);
  const hjLabel = halbjahr === 'HJ1' ? '1. Halbjahr' : '2. Halbjahr';
  const hjWaehlbar = aktiveKlasse?.schuljahr === aktuellesSchuljahr && hj1HatDaten;
  const fachEintraege = Array.from(new Map(auswahlKlassen.map(k => [`${k.klasse_id}-${k.fach}`, k])).values());
  // Klassenarbeiten der Lerngruppe (vom Server je Kind geliefert, hier nur zusammengeführt)
  const kaKlasse = (() => {
    const geschrieben = new Map<string, { datum: string; art: string }>();
    const geplant = new Map<string, { datum: string | null }>();
    for (const s of klassenSchueler) for (const k of berechnet[s.id]?.klassenarbeiten ?? []) {
      if (k.status === 'geschrieben' && k.datum) geschrieben.set(`${k.art}|${k.datum}`, { datum: k.datum, art: k.art });
      else if (k.status === 'geplant') geplant.set(`t${k.termin_id ?? k.datum}`, { datum: k.datum ?? null });
      else if (k.status === 'ohne_termin') geplant.set(`n${k.nummer}`, { datum: null });
    }
    const g = Array.from(geschrieben.values()).sort((a, b) => a.datum.localeCompare(b.datum));
    const p = Array.from(geplant.values()).sort((a, b) => (a.datum ?? '9999').localeCompare(b.datum ?? '9999'));
    let nr = 0;
    const chips = [
      ...g.map(x => ({ key: `g${x.art}${x.datum}`, geplant: false, text: x.art === 'KA' ? `KA ${++nr} am ${datumTTMM(x.datum)}` : `Test am ${datumTTMM(x.datum)}` })),
      ...p.map((x, i) => ({ key: `p${i}`, geplant: true, text: x.datum ? `KA ${++nr} am ${datumTTMM(x.datum)}` : `KA ${++nr}, noch ohne Termin` })),
    ];
    return { geschriebenKa: g.filter(x => x.art === 'KA').length, gesamtKa: g.filter(x => x.art === 'KA').length + p.length, chips };
  })();

  function notenblattLaden() {
    if (!aktiveKlasse) return;
    const url = `${API_BASE}/api/export/noten/${aktiveKlasse.klasse_id}?fach=${encodeURIComponent(aktiveKlasse.fach)}&halbjahr=${halbjahr}`;
    fetch(url, { headers: apiHeaders() })
      .then(r => r.ok ? r.blob() : Promise.reject('Fehler'))
      .then(blob => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `Notenblatt_${aktiveKlasse.klasse_name}_${aktiveKlasse.fach}_${halbjahr}.pdf`;
        a.click();
      })
      .catch(() => toast('Export fehlgeschlagen', 'error'));
  }
  const klassenarbeitEintragen = () => aktiveKlasse && oeffneKlassenarbeitListe({ klasseId: aktiveKlasse.klasse_id, fach: aktiveKlasse.fach });

  // Halbjahresnote rechts: Endnote, vorläufig oder „noch offen“ mit Tendenz (Werte vom Server)
  const wertAnzeige = (b: NoteBerechnet | undefined) => b?.wert != null ? (
    <><div className="ld-kn-wert__zahl">{b.status === 'final' ? b.wert : noteKomma(b.wert)}</div><div className="ld-kn-wert__art">{b.status === 'final' ? 'Endnote' : 'vorläufig'}</div></>
  ) : b?.status === 'offen' ? (
    <><span className="ld-kn-offen-chip">noch offen</span>{b.tendenz != null && <div className="ld-kn-wert__art" style={{ marginTop: 3 }}>Tendenz {noteKomma(b.tendenz)}</div>}</>
  ) : <span style={{ color: 'var(--ld-text-tertiary)' }}>–</span>;

  // Aufgeklappte Zeile: der Satz aus dem Regeltext, Noten, Endnote festlegen, „+ Note“, Profil öffnen
  const detail = (s: Schueler, b: NoteBerechnet | undefined) => {
    const sNoten = notenFuerSchueler(s.id);
    const endnote = endnoteFuerSchueler(s.id);
    return (
      <div className="ld-kn-detail">
        {b && <p className="ld-kn-erkl">{erklaerung(b)}</p>}
        {/* Welle N2: HJ 2 ohne eigene HJ1-Endnote — kein stiller Ersatz */}
        {b && halbjahr === 'HJ2' && b.hj1_endnote_fehlt && b.status !== 'final' && (
          <div role="status" className="ld-kn-hinweis">
            <MIcon name="error" size={18} />
            <span style={{ flex: 1, minWidth: 160 }}><b>HJ1-Endnote fehlt.</b> Halbjahr 2 zeigt den Leistungsstand allein.</span>
            <button type="button" className="ld-kl-link" onClick={() => setHj1Modal({ id: s.id, name: s.name })}>Jetzt eintragen</button>
          </div>
        )}
        {sNoten.length > 0 && (
          <div className="ld-kn-noten">
            {sNoten.map(n => {
              const altesJahr = String(n.schuljahr ?? '').slice(0, 4) !== aktuellesSchuljahr.slice(0, 4);
              return (
                <button key={n.id} type="button" className="ld-kn-note" disabled={altesJahr}
                  onClick={() => setNoteEdit({ note: n, schueler: { id: s.id, name: s.name, klasse_id: s.klasse_id ?? aktiveKlasse?.klasse_id ?? null } })}
                  aria-label={`${ART_LABEL[n.art] ?? n.art} ${n.note} vom ${datumTTMMJJJJ(n.datum)} bearbeiten`}>
                  <b>{n.note}</b>{ART_LABEL[n.art] ?? n.art}, {datumTTMM(n.datum)}{n.gewichtung !== 1 ? `, ×${String(n.gewichtung).replace('.', ',')}` : ''}
                </button>
              );
            })}
          </div>
        )}
        <div className="ld-kn-endnote">
          <span className="ld-kn-endnote__label">Endnote festlegen</span>
          {[1, 2, 3, 4, 5, 6].map(n => (
            <button key={n} type="button" className="ld-kn-endnote__knopf" onClick={() => speichereEndnote(s.id, n)} aria-pressed={endnote?.endnote === n} aria-label={`Endnote ${n}`}>{n}</button>
          ))}
          {endnote && <span className="ld-kn-gespeichert"><MIcon name="check" size={15} />gespeichert</span>}
        </div>
        <div className="ld-kn-aktionen">
          <button type="button" className="ld-kl-link" onClick={() => setEingabeModal({ id: s.id, name: s.name })}><MIcon name="add" size={17} />Note</button>
          <button type="button" className="ld-kl-link" onClick={() => setOpenProfilId(s.id, 'noten')}><MIcon name="person" size={17} />Profil öffnen</button>
          <button type="button" className="ld-kl-link" style={{ color: 'var(--ld-text-secondary)', fontWeight: 600 }} onClick={() => setAnkerModal({ id: s.id, name: s.name })}>Vorjahresnote</button>
        </div>
      </div>
    );
  };

  // Fach (eingebettet nur die Fächer der Klasse oben; bei einem Fach keine Auswahl) und Halbjahr
  const fachWahl = (!eingebettet || fachEintraege.length > 1) && (
    <div className="ld-kl-umschalter" role="group" aria-label="Fach" style={{ flexWrap: 'wrap' }}>
      {fachEintraege.map(k => (
        <button key={`${k.klasse_id}-${k.fach}`} type="button" aria-pressed={aktiveKlasse?.klasse_id === k.klasse_id && aktiveKlasse?.fach === k.fach}
          onClick={() => setAktiveKlasse(k)}>{eingebettet ? k.fach : `${k.klasse_name}, ${k.fach}`}</button>
      ))}
    </div>
  );
  const hjWahl = !hjWaehlbar ? <span className="ld-kn-hj ld-kn-hj--fest">{hjLabel}</span> : isMobile ? (
    <>
      <button ref={hjKnopf} type="button" className="ld-kn-hj" aria-haspopup="menu" aria-expanded={hjMenuOffen} onClick={() => setHjMenuOffen(o => !o)}>
        {hjLabel}<MIcon name="expand_more" size={18} />
      </button>
      {hjMenuOffen && (
        <PortalMenu anker={hjKnopf.current} onClose={() => setHjMenuOffen(false)} label="Halbjahr">
          {(['HJ1', 'HJ2'] as const).map(hj => (
            <button key={hj} type="button" role="menuitemradio" aria-checked={halbjahr === hj} className="ld-kk-menu__item" onClick={() => { setHalbjahr(hj); setHjMenuOffen(false); }}>
              {halbjahr === hj ? <MIcon name="check" size={18} /> : <span style={{ width: 18 }} />}{hj === 'HJ1' ? '1. Halbjahr' : '2. Halbjahr'}
            </button>
          ))}
        </PortalMenu>
      )}
    </>
  ) : (
    <div className="ld-kl-umschalter" role="group" aria-label="Halbjahr">
      {(['HJ1', 'HJ2'] as const).map(hj => <button key={hj} type="button" aria-pressed={halbjahr === hj} onClick={() => setHalbjahr(hj)}>{hj === 'HJ1' ? '1. Halbjahr' : '2. Halbjahr'}</button>)}
    </div>
  );
  const gewichtungText = regel ? `Schriftlich ${regel.gewichtung.schriftlich} %, mündlich ${regel.gewichtung.muendlich} %` : null;
  const verteilungsBalken = (hoch: number) => (
    <div className="ld-kn-vert-box">
      <div className={`ld-kn-vert${hoch > 40 ? ' ld-kn-vert--hoch' : ''}`} role="img" aria-label={`Verteilung: ${verteilung.map((n, i) => `${n}-mal ${i + 1}`).join(', ')}`}>
      {verteilung.map((n, i) => (
        <div key={i} className="ld-kn-vert__spalte">
          {hoch > 40 && <span className="ld-kn-vert__n">{n}</span>}
          <span className="ld-kn-vert__balken" style={{ height: Math.max(3, Math.round((n / maxVert) * hoch)) }} />
          <span className="ld-kn-vert__note">{i + 1}</span>
        </div>
      ))}
      </div>
      <small className="ld-kn-vert__hinweis">nach Schnitt, vorläufig; 2,5 zählt als 2</small>
    </div>
  );
  const fehlerHinweis = berechnetFehler && (
    <div role="alert" style={{ padding: '10px 16px', fontSize: 13, color: 'var(--ld-danger-text)', background: 'var(--ld-danger-soft)' }}>
      Die Halbjahresnoten konnten nicht berechnet werden. Bitte die Seite neu laden.
    </div>
  );

  return (
    <div className="ld-page-enter">
      {/* Werkzeugzeile: Fach, Halbjahr — am PC dazu Noten-Einstellungen, Notenblatt und der Hauptknopf */}
      <div className="ld-kn-werkzeug">
        {fachWahl}
        {isMobile ? hjWahl : <>{hjWahl}{laden && <span style={{ fontSize: 13, color: 'var(--ld-text-secondary)' }}>Laden …</span>}</>}
        {!isMobile && aktiveKlasse && (
          <div className="ld-kn-werkzeug__rechts">
            {/* Welle B2: alle Kinder der Lerngruppe auf einmal (letzte Klassenarbeit aus dem Kalender vorbelegt) */}
            <button type="button" className="ld-kl-haupt" onClick={klassenarbeitEintragen}><MIcon name="add" size={19} />Klassenarbeit eintragen</button>
            {/* Welle Z3: Seltenes im ⋯, damit die Werkzeugzeile bei 1280 px in eine Zeile passt */}
            <KkMenu eintraege={[
              { label: 'Noten-Einstellungen', icon: 'tune', onClick: () => setEinstellungenOffen(true) },
              { label: 'Notenblatt drucken', icon: 'print', onClick: notenblattLaden },
              // Welle B4: dasselbe Fenster wie im ⋯ des Klassenkopfs
              { label: 'Konferenzliste', icon: 'groups', onClick: () => oeffneKonferenzliste({ klasseId: Number(aktiveKlasse.klasse_id), klasseName: aktiveKlasse.klasse_name }) },
            ]} />
          </div>
        )}
      </div>

      {klassenSchueler.length === 0 ? (
        <div className="ld-kl-karte ld-kl-leer" style={{ padding: '48px 20px' }}>
          <div style={{ marginBottom: 10, color: 'var(--ld-text-tertiary)' }}><MIcon name="grading" size={36} /></div>
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 6, color: 'var(--ld-text-primary)' }}>Keine Klasse ausgewählt</div>
          <div>Wähle oben eine Klasse und ein Fach aus deinen Unterrichtsfächern.</div>
        </div>
      ) : isMobile ? (
        <>
          {gewichtungText && (
            <div className="ld-kn-regel">
              <MIcon name="tune" size={17} />{gewichtungText}
              <button type="button" className="ld-kl-link" onClick={() => setEinstellungenOffen(true)}>Ändern</button>
            </div>
          )}
          {aktiveKlasse && <button type="button" className="ld-kl-haupt" style={{ width: '100%' }} onClick={klassenarbeitEintragen}><MIcon name="add" size={19} />Klassenarbeit eintragen</button>}
          <div className="ld-kl-karte ld-kn-summe">
            <div className="ld-kn-summe__schnitt">
              <div className="ld-kn-summe__zahl">{schnittGes != null ? noteKomma(schnittGes) : '–'}</div>
              <div className="ld-kn-summe__label">Ø vorläufig</div>
            </div>
            {verteilungsBalken(30)}
            <div className="ld-kn-summe__offen"><b>{nOffen}</b>noch offen</div>
          </div>
          <div className="ld-kl-karte">
            {fehlerHinweis}
            {klassenSchueler.map((s, i) => {
              const b = berechnet[s.id];
              const offen = expandiert.has(s.id);
              const mdlWert = b && hatMdl(b) ? b.muendlich : null;
              const unter = [b?.schriftlich != null ? `Schriftlich ${noteKomma(b.schriftlich)}` : 'Noch keine Klassenarbeit', mdlWert != null ? `mündlich ${noteKomma(mdlWert)}` : null].filter(Boolean).join(', ');
              return (
                <div key={s.id} className={i > 0 ? 'ld-kl-trenn' : undefined}>
                  <button type="button" className={`ld-kn-zeile${offen ? ' ld-kn-zeile--offen' : ''}`} aria-expanded={offen} onClick={() => toggleExpand(s.id)}>
                    <span className="ld-kl-avatar" aria-hidden="true">{s.avatar}</span>
                    <span className="ld-kl-zeile__text">
                      <span className="ld-kl-zeile__name" style={{ display: 'block' }}>{s.name}</span>
                      <span className="ld-kl-zeile__unter" style={{ display: 'block' }}>{b ? unter : ' '}</span>
                    </span>
                    <span className="ld-kn-wert">{wertAnzeige(b)}</span>
                  </button>
                  {offen && detail(s, b)}
                </div>
              );
            })}
          </div>
          <p className="ld-kn-fuss">
            {/* Welle N2: Regeltext vom Server, mit der echten Gewichtung der Lerngruppe */}
            {regel ? `Halbjahresnote: ${regel.regeltext} ` : ''}Dieselbe Zahl steht im Schülerprofil und im Notenblatt.
          </p>
          {aktiveKlasse && <button type="button" className="ld-kl-link" onClick={notenblattLaden}><MIcon name="print" size={17} />Notenblatt als PDF</button>}
        </>
      ) : (
        <div className="ld-kn-pc">
          <div className="ld-kl-karte">
            {fehlerHinweis}
            <div className="ld-kn-tab__kopf"><span>Schüler·in</span><span>Klassenarbeiten</span><span>Mündlich</span><span>Halbjahresnote</span><span /></div>
            {klassenSchueler.map((s, i) => {
              const b = berechnet[s.id];
              const offen = expandiert.has(s.id);
              const g = b?.grundlage;
              const kaGesamt = Math.max(g?.ka_geschrieben ?? 0, b?.klassenarbeiten?.length ?? 0);
              const mdlWert = b && hatMdl(b) ? b.muendlich : null;
              return (
                <div key={s.id} className={i > 0 ? 'ld-kl-trenn' : undefined}>
                  <button type="button" className={`ld-kn-tab__zeile${offen ? ' ld-kn-tab__zeile--offen' : ''}`} aria-expanded={offen} onClick={() => toggleExpand(s.id)}>
                    <span className="ld-kn-tab__name"><span className="ld-kl-avatar" aria-hidden="true">{s.avatar}</span><span>{s.name}</span></span>
                    <span className="ld-kn-tab__wert"><b>{b?.schriftlich != null ? noteKomma(b.schriftlich) : 'keine'}</b>{g && <small>{g.ka_geschrieben} von {kaGesamt}</small>}</span>
                    <span className="ld-kn-tab__wert"><b>{mdlWert != null ? noteKomma(mdlWert) : 'keine'}</b>{g && <small>{g.wochen_beobachtet} von {g.wochen_gesamt} Wochen</small>}</span>
                    <span className="ld-kn-wert">{wertAnzeige(b)}</span>
                    <MIcon name={offen ? 'expand_less' : 'expand_more'} size={20} className="ld-kl-pfeil" />
                  </button>
                  {offen && detail(s, b)}
                </div>
              );
            })}
          </div>

          <aside className="ld-kl-karte ld-kn-seite" aria-label="Überblick der Lerngruppe">
            <div className="ld-kn-seite__titel">{aktiveKlasse?.fach}, {hjLabel}</div>
            <div className="ld-kn-seite__sub">{klassenSchueler.length} Kinder, Stand heute</div>
            <div className="ld-kn-seite__schnitt"><b>{schnittGes != null ? noteKomma(schnittGes) : '–'}</b><span>Ø der vorläufigen Noten</span></div>
            {verteilungsBalken(64)}
            {nOffen > 0 && (
              <div className="ld-kn-seite__punkt"><MIcon name="hourglass_top" size={18} />{nOffen} {nOffen === 1 ? 'Kind' : 'Kinder'} noch offen, nicht mitgerechnet</div>
            )}
            <div className="ld-kn-seite__trenn" />
            {gewichtungText && (
              <div className="ld-kn-seite__punkt">
                <MIcon name="tune" size={18} />
                <span style={{ flex: 1 }}><b>{gewichtungText}</b>{regel?.gewichtung.ist_voreinstellung && <span style={{ display: 'block', color: 'var(--ld-text-secondary)' }}>Voreinstellung</span>}</span>
                <button type="button" className="ld-kl-link" style={{ padding: 0 }} onClick={() => setEinstellungenOffen(true)}>Ändern</button>
              </div>
            )}
            <div className="ld-kn-seite__punkt">
              <MIcon name="description" size={18} />
              <span style={{ flex: 1 }}>
                <b>Klassenarbeiten: {kaKlasse.geschriebenKa} von {kaKlasse.gesamtKa}</b>
                {kaKlasse.chips.length > 0 && (
                  <span className="ld-kn-ka-chips">
                    {kaKlasse.chips.map(c => <span key={c.key} className={`ld-kn-ka-chip${c.geplant ? ' ld-kn-ka-chip--geplant' : ''}`}>{c.text}</span>)}
                  </span>
                )}
              </span>
            </div>
            <div className="ld-kn-seite__trenn" />
            <button type="button" className="ld-kl-link" style={{ marginTop: 8 }} aria-expanded={rechnungOffen} onClick={() => setRechnungOffen(o => !o)}>
              <MIcon name="help" size={17} />Wie wird gerechnet?
            </button>
            {rechnungOffen && (
              <p className="ld-kn-fuss" style={{ marginTop: 6 }}>
                {/* Welle N2: Regeltext vom Server, mit der echten Gewichtung der Lerngruppe */}
                {regel ? `Halbjahresnote: ${regel.regeltext} ` : ''}Dieselbe Zahl steht im Schülerprofil und im Notenblatt.
              </p>
            )}
          </aside>
        </div>
      )}

      {eingabeModal && aktiveKlasse && (
        <NoteEingabeModal
          schueler={eingabeModal}
          klasse_id={aktiveKlasse.klasse_id}
          fach={aktiveKlasse.fach}
          halbjahr={halbjahr}
          schuljahr={aktuellesSchuljahr}
          onSave={neu => { setNoten(prev => neu.halbjahr === halbjahr ? [neu, ...prev] : prev); setEingabeModal(null); nachAenderung(); setExpandiert(prev => { const neu2 = new Set(prev); neu2.add(eingabeModal.id); return neu2; }); }}
          onClose={() => setEingabeModal(null)}
        />
      )}

      <LdSheet open={!!ankerModal} onClose={() => setAnkerModal(null)} maxWidth={440}
        kopf={{ titel: 'Vorjahresnote erfassen', kontext: [ankerModal?.name, aktiveKlasse?.fach].filter(Boolean).join(', ') }}>
        <div>
          <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)', marginBottom: 18, lineHeight: 1.5 }}>
            Nur zur Information — die Vorjahresnote zählt nicht in die Halbjahresnote. Halbjahr 2 wird mit deiner HJ1-Endnote dieses Schuljahrs verrechnet.
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ display: 'flex', gap: 10 }}>
              <div style={{ flex: 2 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--ld-text-secondary)', letterSpacing: 0.4, marginBottom: 6, display: 'block' }}>Schuljahr</label>
                <LdAuswahl value={ankerSchuljahr} onChange={e => setAnkerSchuljahr(e.target.value)}>
                  {ankerSchuljahre.map(sj => <option key={sj} value={sj}>{sj}</option>)}
                </LdAuswahl>
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--ld-text-secondary)', letterSpacing: 0.4, marginBottom: 6, display: 'block' }}>Halbjahr</label>
                <LdAuswahl value={ankerHj} onChange={e => setAnkerHj(Number(e.target.value) as 1 | 2)}>
                  <option value={1}>HJ 1</option>
                  <option value={2}>HJ 2</option>
                </LdAuswahl>
              </div>
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--ld-text-secondary)', letterSpacing: 0.4, marginBottom: 6, display: 'block' }}>Zeugnisnote (1–6)</label>
              <div style={{ display: 'flex', gap: 6 }}>
                {([1,2,3,4,5,6] as const).map(n => (
                  <button key={n} onClick={() => setAnkerNote(String(n))} style={{
                    flex: 1, height: 44, borderRadius: 'var(--ld-radius-md)', border: 'none', cursor: 'pointer', fontSize: 17, fontWeight: 800,
                    background: ankerNote === String(n) ? notenFarbeKMK(n) : 'var(--ld-bg-input)',
                    color: ankerNote === String(n) ? 'white' : '#8E8E93',
                  }}>{n}</button>
                ))}
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
            <Button variant="secondary" onClick={() => setAnkerModal(null)} style={{ flex: 1 }}>Abbrechen</Button>
            <Button variant="primary" onClick={ankerNoteEinreichen} loading={ankerSpeichern} disabled={ankerSpeichern} style={{ flex: 2 }}>Speichern</Button>
          </div>
        </div>
      </LdSheet>

      {/* Welle U6a: gemeinsames NoteSheet (wie im Profil) */}
      <NoteSheet
        open={!!noteEdit}
        note={noteEdit?.note ?? null}
        schueler={noteEdit?.schueler ?? { id: 0, name: '', klasse_id: null }}
        faecher={aktiveKlasse ? [aktiveKlasse.fach] : []}
        halbjahr={halbjahr}
        schuljahr={aktuellesSchuljahr}
        onClose={() => setNoteEdit(null)}
        onWiederOeffnen={() => setNoteEdit(letzteNoteEdit.current)}
        onGespeichert={n => { setNoten(prev => prev.map(x => x.id === n.id ? { ...x, ...n } : x)); setNoteEdit(null); nachAenderung(); }}
        onGeloescht={id => { setNoten(prev => prev.filter(x => x.id !== id)); nachAenderung(); }}
      />

      {/* Welle N2: HJ1-Endnote nachtragen („Jetzt eintragen“) und Noten-Einstellungen der Lerngruppe */}
      <Hj1EndnoteSheet open={!!hj1Modal} schueler={hj1Modal} klasseId={aktiveKlasse?.klasse_id ?? null} fach={aktiveKlasse?.fach ?? ''}
        schuljahr={aktuellesSchuljahr} onClose={() => setHj1Modal(null)} onGespeichert={() => { setHj1Modal(null); nachAenderung(); }} />
      {aktiveKlasse && (
        <NotenEinstellungenSheet open={einstellungenOffen} klasseId={aktiveKlasse.klasse_id} klasseName={aktiveKlasse.klasse_name} fach={aktiveKlasse.fach}
          onClose={() => setEinstellungenOffen(false)} onGespeichert={() => { setEinstellungenOffen(false); nachAenderung(); }} />
      )}
    </div>
  );
}

// ── Onboarding Flow ────────────────────────────────────────────────────────
const BUNDESLAENDER = ['Hessen', 'Bayern', 'NRW', 'Baden-Württemberg', 'Berlin', 'Hamburg', 'Sachsen', 'Andere'];

function genId() { return Math.random().toString(36).slice(2, 10); }

function OnboardingFlow({
  onFertig,
  vorhandeneKonfig,
}: {
  onFertig: (k: AppKonfig) => void;
  vorhandeneKonfig?: AppKonfig;        // gesetzt → "Neue Klasse"-Modus (Schritt 0 überspringen)
}) {
  const neueKlasseMode = !!vorhandeneKonfig;

  const [schritt, setSchritt] = useState(neueKlasseMode ? 1 : 0);
  const [lehrer] = useState<LehrerProfil>(
    vorhandeneKonfig?.lehrer ?? { name: '', kuerzel: '', schule: '', bundesland: 'Hessen', schulform: 'Gymnasium' }
  );
  const [klasse, setKlasse] = useState<Omit<KlasseKonfig, 'id' | 'schueler'>>({
    bezeichnung: '', schuljahr: '2025/2026', rolle: 'Klassenlehrer',
  });
  const [fach, setFach] = useState('');
  const [klasseFachLaden, setKlasseFachLaden] = useState(false);
  const [importModalOffen, setImportModalOffen] = useState(false);
  const [importStartTab, setImportStartTab] = useState<SetupTab>('upload');
  const [schueler, setSchueler] = useState<SchuelerEintrag[]>([
    { id: genId(), vorname: '', nachname: '', geburtsdatum: '', elternName: '', elternTel: '', elternMail: '' },
  ]);
  const [klassen, setKlassen] = useState<KlasseKonfig[]>(vorhandeneKonfig?.klassen ?? []);

  // Im "Neue Klasse"-Modus: nur 3 Schritte statt 4 anzeigen
  const schrittTitel = neueKlasseMode
    ? ['Klasse anlegen', 'Schüler', 'Fertig!']
    : ['Willkommen', 'Klasse anlegen', 'Schüler', 'Termine', 'Fertig!'];
  const fortschrittIdx = neueKlasseMode ? schritt - 1 : schritt;

  // Termin-Einstellungen für Schritt 4
  const [terminEinst, setTerminEinst] = useState<TerminEinstellungen>({ ...DEFAULT_TERMIN_EINST });
  const [terminSpeichern, setTerminSpeichern] = useState(false);

  function klasseAbschliessen(): KlasseKonfig {
    return {
      id: genId(),
      ...klasse,
      schueler: schueler.filter(s => s.vorname.trim() || s.nachname.trim()),
    };
  }

  async function weiter() {
    if (schritt === 1) {
      // Klasse+Fach in der DB anlegen
      setKlasseFachLaden(true);
      try {
        await apiPost('/api/klasse-fach', {
          klasse_name: klasse.bezeichnung,
          schuljahr:   klasse.schuljahr,
          fach:        fach.trim() || 'Deutsch',
          rolle:       klasse.rolle === 'Klassenlehrer' ? 'klassenleiter' : 'fachlehrer',
        });
      } catch (e) {
        // Onboarding läuft weiter – kann später in Einstellungen eingerichtet werden
        zeigeApiFehler(e, 'Klasse konnte nicht angelegt werden');
      } finally {
        setKlasseFachLaden(false);
      }
    }
    if (schritt === 2) {
      setKlassen(prev => [...prev, klasseAbschliessen()]);
    }
    if (schritt === 3 && !neueKlasseMode) {
      // Termin-Einstellungen speichern (best-effort)
      setTerminSpeichern(true);
      try {
        await apiPut('/api/termin-einstellungen', terminEinst);
      } catch (e) { zeigeApiFehler(e, 'Termin-Einstellungen speichern fehlgeschlagen'); } finally { setTerminSpeichern(false); }
    }
    setSchritt(s => s + 1);
  }

  function weitereKlasse() {
    const aktKlassen = [...klassen, klasseAbschliessen()];
    setKlassen(aktKlassen);
    setKlasse({ bezeichnung: '', schuljahr: '2025/2026', rolle: 'Klassenlehrer' });
    setFach('');
    setSchueler([{ id: genId(), vorname: '', nachname: '', geburtsdatum: '', elternName: '', elternTel: '', elternMail: '' }]);
    setSchritt(1);
  }

  function fertig() {
    const maxFertigSchritt = neueKlasseMode ? 3 : 4;
    const alleKlassen = schritt >= maxFertigSchritt ? klassen : [...klassen, klasseAbschliessen()];
    const ersteId = vorhandeneKonfig?.aktiveKlasseId || alleKlassen[0]?.id || '';
    const k: AppKonfig = {
      onboardingAbgeschlossen: true,
      demoModus: false,
      lehrer,
      klassen: alleKlassen,
      aktiveKlasseId: ersteId,
    };
    onFertig(k);
  }

  const inputStyle: React.CSSProperties = {
    width: '100%', padding: '12px 14px', borderRadius: 'var(--ld-radius-md)' as any,
    border: 'none', background: 'var(--ld-bg-input)' as any, fontSize: 15, outline: 'none',
    fontFamily: 'inherit', boxSizing: 'border-box',
  };
  const labelStyle: React.CSSProperties = {
    fontSize: 12, fontWeight: 600, color: 'var(--ld-text-secondary)' as any, letterSpacing: 0.5, marginBottom: 6, display: 'block',
  };
  const btnPrimary: React.CSSProperties = {
    padding: '14px 28px', background: 'var(--ld-accent-gradient)' as any, color: 'white',
    border: 'none', borderRadius: 'var(--ld-radius-md)' as any, fontSize: 16, fontWeight: 600,
    cursor: 'pointer', width: '100%', boxShadow: 'var(--ld-shadow-accent)' as any,
  };

  if (importModalOffen) {
    return <KlasseEinrichtenModal
      defaultTab={importStartTab}
      onClose={() => { setImportModalOffen(false); weiter(); }}
    />;
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'var(--ld-bg-page)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000, fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    }}>
      <div style={{
        background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)' as any, padding: '40px 44px',
        width: '100%', maxWidth: 'min(520px, calc(100vw - 32px))', boxShadow: 'var(--ld-shadow-lg)' as any,
        animation: 'fadeSlideIn .35s ease',
      }}>
        <style>{`
          @keyframes fadeSlideIn {
            from { opacity: 0; transform: translateY(18px); }
            to   { opacity: 1; transform: translateY(0); }
          }
        `}</style>

        {/* Fortschrittsbalken */}
        {neueKlasseMode && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 24 }}>
            <div style={{ fontSize: 13, color: 'var(--ld-text-secondary)' }}>
              {lehrer.name} · {lehrer.schule}
            </div>
          </div>
        )}
        <div style={{ display: 'flex', gap: 6, marginBottom: 32 }}>
          {schrittTitel.map((t, i) => (
            <div key={i} style={{ flex: 1, textAlign: 'center' }}>
              <div style={{
                height: 4, borderRadius: 4,
                background: i <= fortschrittIdx ? 'var(--ld-accent)' : 'var(--ld-bg-input)',
                marginBottom: 5,
              }} />
              <div style={{ fontSize: 10, color: i === fortschrittIdx ? 'var(--ld-accent)' : 'var(--ld-text-secondary)', fontWeight: i === fortschrittIdx ? 700 : 400 }}>
                {t}
              </div>
            </div>
          ))}
        </div>

        {/* ── Schritt 0: Willkommen ── */}
        {schritt === 0 && (
          <div style={{ animation: 'fadeSlideIn .3s ease', textAlign: 'center' }}>
            <div style={{ marginBottom: 14, color: 'var(--ld-primary)' }}><MIcon name="waving_hand" size={52} /></div>
            <h2 style={{ margin: '0 0 10px', fontSize: 24, fontWeight: 800, color: 'var(--ld-text-primary)' }}>
              Willkommen bei LehrerDesk{getAktuellerNutzer()?.vorname ? `, ${getAktuellerNutzer()?.vorname}!` : '!'}
            </h2>
            <p style={{ margin: '0 0 6px', color: '#4B5563', fontSize: 15, lineHeight: 1.6 }}>
              Lassen Sie uns Ihre Klasse einrichten.
            </p>
            <p style={{ margin: '0 0 28px', color: 'var(--ld-text-secondary)', fontSize: 13 }}>
              {getAktuellerNutzer()?.schule ?? ''}
            </p>
            {getAktuellerNutzer() && (
              <div style={{ background: 'var(--ld-bg-input)', borderRadius: 'var(--ld-radius-xl)', padding: '14px 18px', marginBottom: 28, textAlign: 'left' }}>
                {[
                  { label: 'Name',      value: `${getAktuellerNutzer()?.vorname} ${getAktuellerNutzer()?.nachname}` },
                  { label: 'Schule',    value: getAktuellerNutzer()?.schule },
                  { label: 'Bundesland', value: getAktuellerNutzer()?.bundesland },
                ].map(({ label, value }) => (
                  <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', fontSize: 14, borderBottom: '1px solid var(--ld-bg-page)' }}>
                    <span style={{ color: 'var(--ld-text-secondary)', fontWeight: 600 }}>{label}</span>
                    <span style={{ color: 'var(--ld-text-primary)', fontWeight: 500 }}>{value}</span>
                  </div>
                ))}
              </div>
            )}
            <button style={btnPrimary} onClick={() => weiter()}>
              Los geht's! →
            </button>
          </div>
        )}

        {/* ── Schritt 1: Klasse anlegen ── */}
        {schritt === 1 && (
          <div style={{ animation: 'fadeSlideIn .3s ease' }}>
            <h2 style={{ margin: '0 0 6px', fontSize: 22, fontWeight: 800, color: 'var(--ld-text-primary)' }}>
              {neueKlasseMode ? 'Neue Klasse anlegen' : klassen.length === 0 ? 'Erste Klasse anlegen' : 'Weitere Klasse anlegen'}
            </h2>
            <p style={{ margin: '0 0 16px', color: 'var(--ld-text-secondary)', fontSize: 14 }}>
              {!neueKlasseMode && klassen.length > 0 && (
                <><strong>{klassen.map(k => k.bezeichnung).join(', ')}</strong> bereits angelegt.<br /></>
              )}
              {neueKlasseMode
                ? `${lehrer.schulform} · ${lehrer.schule} · ${lehrer.bundesland}`
                : `Wie heißt Ihre ${klassen.length === 0 ? 'erste' : 'neue'} Klasse?`}
            </p>

            {/* Im neue-Klasse-Modus: Schulinfo als Chip anzeigen (read-only) */}
            {neueKlasseMode && (
              <div style={{
                display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 20,
              }}>
                {[lehrer.name, lehrer.schule, lehrer.schulform, lehrer.bundesland].map(v => (
                  <span key={v} style={{
                    padding: '4px 10px', background: BLUE + '12',
                    borderRadius: 'var(--ld-radius-sm)', fontSize: 12, color: BLUE, fontWeight: 600,
                  }}>{v}</span>
                ))}
              </div>
            )}

            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Klassenbezeichnung</label>
              <input style={inputStyle} placeholder="z. B. 10b"
                value={klasse.bezeichnung} onChange={e => setKlasse(k => ({ ...k, bezeichnung: e.target.value }))} />
            </div>
            <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Fach</label>
                <input style={inputStyle} placeholder="z. B. Deutsch, GL, Mathe"
                  value={fach} onChange={e => setFach(e.target.value)} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Schuljahr</label>
                <input style={inputStyle} placeholder="z. B. 2025/2026"
                  value={klasse.schuljahr} onChange={e => setKlasse(k => ({ ...k, schuljahr: e.target.value }))} />
              </div>
            </div>
            <div style={{ marginBottom: 28 }}>
              <label style={labelStyle}>Ihre Rolle</label>
              <div style={{ display: 'flex', gap: 8 }}>
                {(['Klassenlehrer', 'Fachlehrer'] as Lehrerrolle[]).map(r => (
                  <button key={r} onClick={() => setKlasse(k => ({ ...k, rolle: r }))} style={{
                    flex: 1, padding: '11px 0', borderRadius: 'var(--ld-radius-md)', cursor: 'pointer',
                    border: klasse.rolle === r ? `2px solid var(--ld-accent)` : 'none',
                    background: klasse.rolle === r ? 'var(--ld-accent-soft)' : 'var(--ld-bg-input)',
                    color: klasse.rolle === r ? 'var(--ld-accent)' : 'var(--ld-text-primary)',
                    fontWeight: klasse.rolle === r ? 700 : 400, fontSize: 14,
                  }}>{r}</button>
                ))}
              </div>
            </div>
            <button
              style={{ ...btnPrimary, opacity: klasseFachLaden ? 0.7 : 1 }}
              disabled={!klasse.bezeichnung.trim() || klasseFachLaden}
              onClick={() => weiter()}
            >
              {klasseFachLaden ? 'Speichern …' : 'Weiter → Schüler hinzufügen'}
            </button>
          </div>
        )}

        {/* ── Schritt 2: Schüler hinzufügen ── */}
        {schritt === 2 && (
          <div style={{ animation: 'fadeSlideIn .3s ease' }}>
            <h2 style={{ margin: '0 0 6px', fontSize: 22, fontWeight: 800, color: 'var(--ld-text-primary)' }}>
              Schüler hinzufügen
            </h2>
            <p style={{ margin: '0 0 6px', color: 'var(--ld-text-secondary)', fontSize: 14 }}>
              Klasse <strong>{klasse.bezeichnung}</strong>{fach ? ` · ${fach}` : ''}
            </p>
            <p style={{ margin: '0 0 22px', color: 'var(--ld-text-secondary)', fontSize: 13 }}>
              Wie möchten Sie Ihre Schülerinnen und Schüler hinzufügen?
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
              {([
                { tab: 'upload'  as SetupTab, emoji: 'photo_camera', titel: 'Foto oder Datei', sub: 'Foto aufnehmen oder PDF/CSV importieren' },
                { tab: 'manuell' as SetupTab, emoji: 'edit', titel: 'Manuell eingeben', sub: 'Namen einzeln eintragen' },
              ] as const).map(({ tab, emoji, titel, sub }) => (
                <button
                  key={tab}
                  onClick={() => { setImportStartTab(tab); setImportModalOffen(true); }}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 14,
                    padding: '14px 16px', background: 'var(--ld-bg-input)',
                    border: 'none', borderRadius: 'var(--ld-radius-xl)',
                    cursor: 'pointer', textAlign: 'left', width: '100%',
                  }}
                  onMouseEnter={e => (e.currentTarget.style.background = 'var(--ld-accent-soft)')}
                  onMouseLeave={e => (e.currentTarget.style.background = 'var(--ld-bg-input)')}
                >
                  <span style={{ color: 'var(--ld-primary)', display: 'inline-flex' }}><MIcon name={emoji} size={28} /></span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--ld-text-primary)' }}>{titel}</div>
                    <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)', marginTop: 2 }}>{sub}</div>
                  </div>
                  <span style={{ fontSize: 18, color: 'var(--ld-text-tertiary)' }}>›</span>
                </button>
              ))}
            </div>

            <button
              onClick={() => weiter()}
              style={{
                width: '100%', padding: '12px', background: 'var(--ld-bg-input)',
                border: 'none', borderRadius: 'var(--ld-radius-md)', cursor: 'pointer',
                color: 'var(--ld-text-secondary)', fontSize: 14, fontWeight: 500,
              }}
            >
              Später überspringen →
            </button>
          </div>
        )}

        {/* ── Schritt 3: Terminverfügbarkeit (nur erster Onboarding) ── */}
        {schritt === 3 && !neueKlasseMode && (() => {
          const WOCHENTAGE = [
            { nr: 1, kürzel: 'Mo' }, { nr: 2, kürzel: 'Di' }, { nr: 3, kürzel: 'Mi' },
            { nr: 4, kürzel: 'Do' }, { nr: 5, kürzel: 'Fr' },
          ];
          const toggleWt = (typ: 'vorOrt' | 'telefonisch', nr: number) => {
            setTerminEinst(prev => {
              const curr = prev[typ].wochentage;
              const neu = curr.includes(nr) ? curr.filter(x => x !== nr) : [...curr, nr];
              return { ...prev, [typ]: { ...prev[typ], wochentage: neu } };
            });
          };
          return (
            <div style={{ animation: 'fadeSlideIn .3s ease' }}>
              <h2 style={{ margin: '0 0 6px', fontSize: 22, fontWeight: 800, color: 'var(--ld-text-primary)' }}>Wann sind Sie erreichbar?</h2>
              <p style={{ margin: '0 0 20px', color: 'var(--ld-text-secondary)', fontSize: 14 }}>Für die automatische Terminvorschlag-Funktion bei Elternmails.</p>

              {/* Vor-Ort */}
              <div style={{ background: '#F8F9FA', borderRadius: 'var(--ld-radius-lg)', padding: '14px 16px', marginBottom: 14 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--ld-text-primary)', marginBottom: 10 }}>Vor-Ort-Termine</div>
                <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
                  {WOCHENTAGE.map(wt => (
                    <button key={wt.nr} onClick={() => toggleWt('vorOrt', wt.nr)} style={{
                      flex: 1, padding: '6px 0', borderRadius: 'var(--ld-radius-sm)', cursor: 'pointer', fontSize: 12, fontWeight: 700,
                      border: `1.5px solid ${terminEinst.vorOrt.wochentage.includes(wt.nr) ? BLUE : '#E5E5EA'}`,
                      background: terminEinst.vorOrt.wochentage.includes(wt.nr) ? BLUE + '15' : 'white',
                      color: terminEinst.vorOrt.wochentage.includes(wt.nr) ? BLUE : '#8E8E93',
                    }}>{wt.kürzel}</button>
                  ))}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: 12, color: 'var(--ld-text-secondary)', flexShrink: 0 }}>Bis spätestens:</span>
                  <span style={{ width: 110 }}><LdUhrzeit kompakt aria-label="bis" placeholder="HH:MM" value={terminEinst.vorOrt.bisUhrzeit} onChange={v => setTerminEinst(p => ({ ...p, vorOrt: { ...p.vorOrt, bisUhrzeit: v } }))} /></span>
                </div>
              </div>

              {/* Telefonisch */}
              <div style={{ background: '#F8F9FA', borderRadius: 'var(--ld-radius-lg)', padding: '14px 16px', marginBottom: 14 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--ld-text-primary)', marginBottom: 10 }}>Telefonische Gespräche</div>
                <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
                  {WOCHENTAGE.map(wt => (
                    <button key={wt.nr} onClick={() => toggleWt('telefonisch', wt.nr)} style={{
                      flex: 1, padding: '6px 0', borderRadius: 'var(--ld-radius-sm)', cursor: 'pointer', fontSize: 12, fontWeight: 700,
                      border: `1.5px solid ${terminEinst.telefonisch.wochentage.includes(wt.nr) ? BLUE : '#E5E5EA'}`,
                      background: terminEinst.telefonisch.wochentage.includes(wt.nr) ? BLUE + '15' : 'white',
                      color: terminEinst.telefonisch.wochentage.includes(wt.nr) ? BLUE : '#8E8E93',
                    }}>{wt.kürzel}</button>
                  ))}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: 12, color: 'var(--ld-text-secondary)', flexShrink: 0 }}>Bis spätestens:</span>
                  <span style={{ width: 110 }}><LdUhrzeit kompakt aria-label="bis" placeholder="HH:MM" value={terminEinst.telefonisch.bisUhrzeit} onChange={v => setTerminEinst(p => ({ ...p, telefonisch: { ...p.telefonisch, bisUhrzeit: v } }))} /></span>
                </div>
              </div>

              {/* Dauer & Puffer */}
              <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ld-text-secondary)', display: 'block', marginBottom: 4 }}>Termindauer (Min.)</label>
                  <input type="number" min={10} max={90} value={terminEinst.termindauer} onChange={e => setTerminEinst(p => ({ ...p, termindauer: Number(e.target.value) }))}
                    style={{ width: '100%', padding: '8px 12px', border: '1.5px solid var(--ld-outline-soft)', borderRadius: 'var(--ld-radius-sm)', fontSize: 14, outline: 'none', boxSizing: 'border-box' as const }} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ld-text-secondary)', display: 'block', marginBottom: 4 }}>Puffer (Min.)</label>
                  <input type="number" min={0} max={60} value={terminEinst.puffer} onChange={e => setTerminEinst(p => ({ ...p, puffer: Number(e.target.value) }))}
                    style={{ width: '100%', padding: '8px 12px', border: '1.5px solid var(--ld-outline-soft)', borderRadius: 'var(--ld-radius-sm)', fontSize: 14, outline: 'none', boxSizing: 'border-box' as const }} />
                </div>
              </div>

              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => setSchritt(4)} style={{ flex: 1, padding: '12px', background: 'var(--ld-bg-input)', border: 'none', borderRadius: 'var(--ld-radius-md)', cursor: 'pointer', color: 'var(--ld-text-secondary)', fontSize: 14, fontWeight: 500 }}>
                  Überspringen
                </button>
                <button onClick={() => weiter()} disabled={terminSpeichern} style={{ flex: 2, padding: '12px', background: 'var(--ld-accent)', border: 'none', borderRadius: 'var(--ld-radius-md)', cursor: 'pointer', color: 'white', fontSize: 14, fontWeight: 700, opacity: terminSpeichern ? 0.7 : 1 }}>
                  {terminSpeichern ? 'Speichern …' : 'Speichern & Weiter →'}
                </button>
              </div>
            </div>
          );
        })()}

        {/* ── Schritt 3 in neueKlasse-Modus = Fertig! / Schritt 4 im normalen Modus ── */}
        {((schritt === 3 && neueKlasseMode) || schritt === 4) && (
          <div style={{ animation: 'fadeSlideIn .3s ease', textAlign: 'center' }}>
            <div style={{ marginBottom: 12, color: 'var(--ld-success-text)' }}><MIcon name="task_alt" size={52} /></div>
            <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 800, color: 'var(--ld-text-primary)' }}>
              {klassen[klassen.length - 1]?.bezeichnung ?? 'Ihre Klasse'} ist bereit!
            </h2>
            <p style={{ margin: '0 0 24px', color: 'var(--ld-text-secondary)', fontSize: 14 }}>
              {klassen.reduce((n, k) => n + k.schueler.length, 0)} Schüler·innen eingetragen
              · {klassen.length} {klassen.length === 1 ? 'Klasse' : 'Klassen'}
            </p>

            <div style={{
              background: 'var(--ld-bg-app)', borderRadius: 'var(--ld-radius-xl)', padding: '16px 20px',
              marginBottom: 20, textAlign: 'left',
            }}>
              {klassen.map(kl => (
                <div key={kl.id} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                  <span style={{ fontWeight: 600, fontSize: 14 }}>Kl. {kl.bezeichnung}</span>
                  <span style={{ color: 'var(--ld-text-secondary)', fontSize: 13 }}>{kl.schueler.length} Schüler·innen · {kl.rolle}</span>
                </div>
              ))}
            </div>

            <button onClick={weitereKlasse} style={{
              width: '100%', padding: '12px', background: 'var(--ld-accent-soft)',
              border: 'none', borderRadius: 'var(--ld-radius-md)', cursor: 'pointer',
              color: 'var(--ld-accent)', fontSize: 15, fontWeight: 600, marginBottom: 10,
            }}>
              + Weitere Klasse hinzufügen
            </button>
            <button style={btnPrimary} onClick={fertig}>
              Los geht's! →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Mehrarbeit & Vertretungen ──────────────────────────────────────────────
interface MehrarbeitEintrag {
  id: number; datum: string; typ: string;
  klasse: string | null; stunden: number; beschreibung: string | null;
}
const MEHRARBEIT_TYP_LABEL: Record<string, string> = {
  vertretung: 'Vertretung', mehrarbeit: 'Mehrarbeit',
  aufsicht: 'Aufsicht', sonstiges: 'Sonstiges',
};

function MehrarbeitAnsicht() {
  const [detail, setDetail] = useState<MehrarbeitEintrag | null>(null);
  const [eintraege, setEintraege] = useState<MehrarbeitEintrag[]>([]);
  const [alleEintraege, setAlleEintraege] = useState<MehrarbeitEintrag[]>([]);
  const [laden, setLaden] = useState(true);
  const [monat, setMonat] = useState(() => new Date().toISOString().slice(0, 7)); // YYYY-MM
  const [modal, setModal] = useState(false);
  const [exportLaden, setExportLaden] = useState(false);
  const [datum, setDatum] = useState(() => new Date().toISOString().slice(0, 10));
  const [typ, setTyp] = useState('mehrarbeit');
  const [klasse, setKlasse] = useState('');
  const [stunden, setStunden] = useState('');
  const [beschreibung, setBeschreibung] = useState('');
  const [speichern, setSpeichern] = useState(false);

  // Diktat-State für Modal
  const [diktatPhase, setDiktatPhase] = useState<SprechPhase>('idle');
  const [diktatFehler, setDiktatFehler] = useState('');
  const maDiktatRecorderRef = React.useRef<MediaRecorder | null>(null);
  const maDiktatChunksRef   = React.useRef<Blob[]>([]);

  const [eingabeModus, setEingabeModus] = useState<null | 'manuell' | 'diktat'>(null);

  // FAB-Handler: öffnet Mehrarbeit-Eintrag-Modal (kein Auto-Stream-Acquire mehr)
  const { setFabHandler, setIsRecording } = useFab();
  useEffect(() => {
    setFabHandler(() => { setModal(true); });
    return () => { setFabHandler(null); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Modal öffnet → Modus-Auswahl zeigen; Modal schließt → alles zurücksetzen
  useEffect(() => {
    if (!modal) {
      maDiktatRecorderRef.current?.stop();
      setEingabeModus(null);
      return;
    }
    setDiktatPhase('idle');
    setDiktatFehler('');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal]);

  async function startMaDiktat() {
    if (diktatPhase === 'aufnahme') { maDiktatRecorderRef.current?.stop(); return; }
    setDiktatFehler('');

    let stream: MediaStream;
    try {
      stream = await mikrofonAnfragen();
    } catch (err) {
      setDiktatFehler(zeigeMikrofonFehler(err, { stattdessenTippen: () => { setDiktatFehler(''); setDiktatPhase('idle'); } }));
      setDiktatPhase('fehler');
      return;
    }

    const kandidaten = ['audio/webm;codecs=opus', 'audio/webm', 'audio/ogg;codecs=opus', 'audio/mp4', 'audio/wav'];
    const mime = kandidaten.find(m => MediaRecorder.isTypeSupported(m)) ?? '';
    const ext  = mime.includes('ogg') ? 'ogg' : mime.includes('mp4') ? 'mp4' : mime.includes('wav') ? 'wav' : 'webm';

    let recorder: MediaRecorder;
    try {
      recorder = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream);
    } catch (err) {
      setDiktatFehler('MediaRecorder Fehler: ' + (err instanceof Error ? err.message : String(err)));
      setDiktatPhase('fehler');
      stream.getTracks().forEach(t => t.stop());
      return;
    }

    maDiktatRecorderRef.current = recorder;
    maDiktatChunksRef.current   = [];
    recorder.ondataavailable    = e => { if (e.data.size > 0) maDiktatChunksRef.current.push(e.data); };

    recorder.onstop = async () => {
      stream.getTracks().forEach(t => t.stop());
      setIsRecording(false);
      const blob = new Blob(maDiktatChunksRef.current, { type: recorder.mimeType || mime });
      if (blob.size === 0) { setDiktatFehler('Aufnahme leer.'); setDiktatPhase('fehler'); return; }
      try {
        setDiktatPhase('transkribiert');
        const formData = new FormData();
        formData.append('audio', blob, `aufnahme.${ext}`);
        const jwtToken = holeToken();
        const whisperRes = await fetch(`${API_BASE}/api/transkribiere`, {
          method: 'POST',
          headers: jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {},
          body: formData,
        });
        if (!whisperRes.ok) { const e = await whisperRes.json().catch(() => ({})); throw new Error(e.fehler ?? `Whisper Fehler ${whisperRes.status}`); }
        const { text } = await whisperRes.json();
        if (!text?.trim()) throw new Error('Kein Text erkannt.');

        setDiktatPhase('analysiert');
        const result = await apiPost<any>('/api/analysiere-mehrarbeit', { text });

        // Formular vorausfüllen
        if (result.datum)        setDatum(result.datum);
        if (result.typ && MEHRARBEIT_TYP_LABEL[result.typ]) setTyp(result.typ);
        if (result.klasse)       setKlasse(result.klasse ?? '');
        if (result.stunden)      setStunden(String(result.stunden));
        if (result.beschreibung) setBeschreibung(result.beschreibung ?? '');
        setDiktatPhase('idle');
        setEingabeModus('manuell');
      } catch (err: unknown) {
        setDiktatFehler(err instanceof Error ? err.message : 'Unbekannter Fehler');
        setDiktatPhase('fehler');
      }
    };

    recorder.start();
    setDiktatPhase('aufnahme');
    setIsRecording(true);
  }

  function ladeEintraege(m: string) {
    setLaden(true);
    fetch(`${API_BASE}/api/mehrarbeit?monat=${m}`, { headers: apiHeaders() })
      .then(leseFallback<any[]>([], '/api/mehrarbeit?monat')).then(setEintraege).catch(() => {}).finally(() => setLaden(false));
  }

  useEffect(() => { ladeEintraege(monat); }, [monat]);

  // Alle Einträge (für Schuljahr-Summe) — neu laden bei Monatswechsel & nach Änderungen
  useEffect(() => {
    fetch(`${API_BASE}/api/mehrarbeit`, { headers: apiHeaders() })
      .then(leseFallback<any[]>([], '/api/mehrarbeit')).then(setAlleEintraege).catch(() => {});
  }, [monat, eintraege]);

  async function speichereEintrag() {
    if (!datum || !stunden) return;
    setSpeichern(true);
    try {
      const neu = await apiPost<any>('/api/mehrarbeit',
        { datum, typ, klasse: klasse || null, stunden: parseFloat(stunden), beschreibung: beschreibung || null });
      setEintraege(prev => [neu, ...prev]);
      setModal(false);
      setKlasse(''); setStunden(''); setBeschreibung(''); setTyp('mehrarbeit');
      setDatum(new Date().toISOString().slice(0, 10));
    } catch (e) { zeigeApiFehler(e, 'Speichern fehlgeschlagen'); } finally { setSpeichern(false); }
  }

  async function loescheEintrag(id: number) {
    if (!(await confirm('Eintrag löschen?', { danger: true, confirmLabel: 'Löschen' }))) return;
    try {
      await apiDelete(`/api/mehrarbeit/${id}`);
      setEintraege(prev => prev.filter(e => e.id !== id));
    } catch (e) { zeigeApiFehler(e, 'Löschen fehlgeschlagen'); }
  }

  const gesamtStunden = eintraege.reduce((s, e) => s + e.stunden, 0);
  const monatAnzeige = new Date(monat + '-01').toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });

  const fmt = (n: number) => n.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 1 });
  // Welle K3: Art nur als Punkt (Vertretung = Hauptfarbe, Aufsicht grau, Mehrarbeit türkis)
  const typFarbe = (t: string) => t === 'vertretung' ? 'var(--ld-primary)' : t === 'mehrarbeit' ? '#34A6A0' : t === 'aufsicht' ? 'var(--ld-violet-200)' : 'var(--ld-text-tertiary)';
  const WT_KURZ = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  function navMonat(delta: number) {
    const d = new Date(monat + '-01T12:00:00'); d.setMonth(d.getMonth() + delta);
    setMonat(d.toISOString().slice(0, 7));
  }
  // Aufteilung des aktuellen Monats nach Typ
  const maStd   = eintraege.filter(e => e.typ === 'mehrarbeit').reduce((s, e) => s + e.stunden, 0);
  const vertStd = eintraege.filter(e => e.typ === 'vertretung').reduce((s, e) => s + e.stunden, 0);
  const aufsStd = eintraege.filter(e => e.typ === 'aufsicht').reduce((s, e) => s + e.stunden, 0);
  const sonstStd = Math.max(0, gesamtStunden - maStd - vertStd - aufsStd);
  // Schuljahr-Gesamtsumme (Hessen: Aug–Jul), aus allen Einträgen berechnet (kein neues Schema)
  const sjFenster = schuljahrFenster();
  const sjBounds  = { start: sjFenster.von, end: sjFenster.bis };
  const schuljahrStunden = alleEintraege.filter(e => e.datum >= sjBounds.start && e.datum <= sjBounds.end).reduce((s, e) => s + e.stunden, 0);

  async function exportNachweis() {
    setExportLaden(true);
    try {
      const r = await fetch(`${API_BASE}/api/export/mehrarbeit?monat=${monat}`, { headers: apiHeaders() });
      if (r.ok) {
        const blob = await r.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a'); a.href = url;
        a.download = `Mehrarbeit_${monat}.pdf`;
        document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
      } else {
        toast('Export fehlgeschlagen', 'error');
      }
    } catch { toast('Export fehlgeschlagen', 'error'); } finally { setExportLaden(false); }
  }

  return (
    <div className="ld-page-enter">
      {/* Welle K3: Monatsumschalter, ruhige Monatskarte, ein Hauptknopf (Mikro als kleines Symbol), Liste, PDF als Zeile */}
      <div className="ld-mt-monat">
        <button type="button" onClick={() => navMonat(-1)} aria-label="Vorheriger Monat" className="ld-kt-pfeil"><MIcon name="chevron_left" size={20} /></button>
        <span className="ld-mt-monat__text">{monatAnzeige}</span>
        <button type="button" onClick={() => navMonat(1)} aria-label="Nächster Monat" className="ld-kt-pfeil"><MIcon name="chevron_right" size={20} /></button>
      </div>

      <div className="ld-ma">
        <div className="ld-ma__links">
          <div className="ld-kl-karte ld-ma-karte">
            <div className="ld-ma-karte__titel">Diesen Monat</div>
            <div className="ld-ma-karte__zahl"><b>{fmt(gesamtStunden)} Std.</b><span>aus {eintraege.length} {eintraege.length === 1 ? 'Eintrag' : 'Einträgen'}</span></div>
            <div className="ld-ma-balken" role="img" aria-label={`Vertretung ${fmt(vertStd)}, Aufsicht ${fmt(aufsStd)}, Mehrarbeit ${fmt(maStd)}, Sonstiges ${fmt(sonstStd)} Stunden`}>
              {vertStd > 0 && <span style={{ flex: vertStd, background: typFarbe('vertretung') }} />}
              {aufsStd > 0 && <span style={{ flex: aufsStd, background: typFarbe('aufsicht') }} />}
              {maStd > 0 && <span style={{ flex: maStd, background: typFarbe('mehrarbeit') }} />}
              {sonstStd > 0 && <span style={{ flex: sonstStd, background: typFarbe('sonstiges') }} />}
            </div>
            <div className="ld-ma-legende">
              {([['vertretung', vertStd], ['aufsicht', aufsStd], ['mehrarbeit', maStd]] as const).map(([t, n]) => (
                <span key={t}><i style={{ background: typFarbe(t) }} />{MEHRARBEIT_TYP_LABEL[t]} {fmt(n)}</span>
              ))}
              {sonstStd > 0 && <span><i style={{ background: typFarbe('sonstiges') }} />Sonstiges {fmt(sonstStd)}</span>}
            </div>
            <div className="ld-ma-sj"><span>Schuljahr {sjFenster.label} bisher</span><b>{fmt(schuljahrStunden)} Std.</b></div>
          </div>
          <div className="ld-ma-knoepfe">
            <button type="button" className="ld-kl-haupt" onClick={() => setModal(true)}><MIcon name="add" size={19} />Eintrag</button>
            <QuickMicButton modul="mehrarbeit" size="sm" />
          </div>
        </div>

        <div className="ld-ma__rechts">
          {laden ? <LoadingBlock text="Lade Einträge …" /> : eintraege.length === 0 ? (
            <div className="ld-kl-karte ld-kt-leer">Keine Einträge im {monatAnzeige.split(' ')[0]}. Erfasse Mehrarbeit oder eine Vertretung mit „+ Eintrag“.</div>
          ) : (
            <div className="ld-kl-karte">
              {eintraege.map((e, i) => (
                <button key={e.id} type="button" className={`ld-mt-zeile${i > 0 ? ' ld-kl-trenn' : ''}`} onClick={() => setDetail(e)}>
                  <span className="ld-mt-datum"><small>{WT_KURZ[new Date(e.datum + 'T12:00:00').getDay()]}</small><b>{Number(e.datum.slice(8, 10))}</b></span>
                  <span className="ld-mt-zeile__text">
                    <b>{e.beschreibung || MEHRARBEIT_TYP_LABEL[e.typ] || e.typ}</b>
                    <small><i className="ld-mt-punkt" style={{ background: typFarbe(e.typ) }} />{[MEHRARBEIT_TYP_LABEL[e.typ] ?? e.typ, e.klasse || null].filter(Boolean).join(', ')}</small>
                  </span>
                  <span className="ld-ma-std">{fmt(e.stunden)} Std.</span>
                </button>
              ))}
            </div>
          )}
          <div className="ld-kl-karte" style={{ marginTop: 12 }}>
            <button type="button" className="ld-kf-pdf" onClick={exportNachweis} disabled={exportLaden || eintraege.length === 0}>
              <MIcon name="description" size={20} />
              <span style={{ flex: 1 }}>{exportLaden ? 'PDF wird erstellt …' : `Nachweis ${monatAnzeige.split(' ')[0]} als PDF`}</span>
              <MIcon name="chevron_right" size={20} className="ld-kl-pfeil" />
            </button>
          </div>
        </div>
      </div>

      {/* Welle K3: Zeile antippen → Eintrag ansehen, Löschen mit Rückfrage (Bearbeiten gibt es auf dem Server nicht) */}
      <LdSheet open={!!detail} onClose={() => setDetail(null)} maxWidth={440}
        kopf={{ titel: detail ? (detail.beschreibung || MEHRARBEIT_TYP_LABEL[detail.typ] || detail.typ) : 'Mehrarbeit', kontext: detail ? `${wtKommaTm(detail.datum)}, ${fmt(detail.stunden)} Std.` : null }}>
        {detail && (
          <div className="ld-se">
            <dl className="ld-kt-zeilen" style={{ margin: '16px 20px' }}>
              <dt>Art</dt><dd>{MEHRARBEIT_TYP_LABEL[detail.typ] ?? detail.typ}</dd>
              <dt>Datum</dt><dd>{datumTTMMJJJJ(detail.datum)}</dd>
              <dt>Stunden</dt><dd>{fmt(detail.stunden)}</dd>
              {detail.klasse && <><dt>Klasse</dt><dd>{detail.klasse}</dd></>}
              {detail.beschreibung && <><dt>Beschreibung</dt><dd>{detail.beschreibung}</dd></>}
            </dl>
            <div className="ld-se-fuss">
              <button type="button" className="ld-kl-link" style={{ color: 'var(--ld-danger-text)' }} onClick={() => { const e = detail; setDetail(null); void loescheEintrag(e.id); }}>
                <MIcon name="delete" size={17} />Eintrag löschen
              </button>
              <span className="ld-se-fuss__platz" />
              <button type="button" className="ld-kl-zweit" onClick={() => setDetail(null)}>Schließen</button>
            </div>
          </div>
        )}
      </LdSheet>

      {/* Modal: Neuer Eintrag */}
      <LdSheet open={modal} onClose={() => setModal(false)} maxWidth={440} ariaLabel="Mehrarbeit-Eintrag">
        <div style={{ overflowY: 'auto' }}>

          {/* Modal-Header (weißes ld-Form-Muster: Icon-Chip + Titel + Close) */}
          <div className="ld-fe-kopf">
            {eingabeModus !== null
              ? <button type="button" className="ld-fe-zu" onClick={() => setEingabeModus(null)} aria-label="Zurück"><MIcon name="arrow_back" size={20} /></button>
              : <span className="ld-fe-kopf__icon" aria-hidden="true"><MIcon name="schedule" size={20} /></span>}
            <div className="ld-fe-kopf__text">
              <h3 className="ld-fe-kopf__titel">{eingabeModus === 'diktat' ? 'Mehrarbeit per Sprache' : eingabeModus === 'manuell' ? 'Mehrarbeit eintragen' : 'Neue Mehrarbeit'}</h3>
            </div>
            <button type="button" className="ld-fe-zu" aria-label="Schließen" onClick={() => setModal(false)}><MIcon name="close" size={20} /></button>
          </div>

          {/* Modus-Auswahl */}
          {eingabeModus === null && (
            <div className="ld-modus-auswahl">
              <p style={{ margin: 0, fontSize: 13, color: 'var(--ld-text-secondary)', textAlign: 'center' }}>Wie möchtest du den Eintrag erfassen?</p>
              <div className="ld-modus-buttons">
                <button onClick={() => setEingabeModus('manuell')} className="ld-modus-card">
                  <MIcon name="edit" size={28} style={{ color: 'var(--ld-primary)' }} />
                  <strong>Manuell eingeben</strong>
                  <span>Felder direkt ausfüllen</span>
                </button>
                <button onClick={() => { setEingabeModus('diktat'); void startMaDiktat(); }} className="ld-modus-card">
                  <MIcon name="mic" size={28} style={{ color: 'var(--ld-primary)' }} />
                  <strong>Mit Diktat</strong>
                  <span>Sprechen, KI füllt Felder vor</span>
                </button>
              </div>
            </div>
          )}

          {/* Diktat-Bereich */}
          {eingabeModus === 'diktat' && (
            <div style={{ padding: '20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: 'var(--ld-primary-soft)', borderRadius: 14, padding: '14px 16px' }}>
                <button
                  className="ld-fz-mic"
                  onClick={() => void startMaDiktat()}
                  disabled={diktatPhase === 'transkribiert' || diktatPhase === 'analysiert'}
                  aria-label={diktatPhase === 'aufnahme' ? 'Stoppen & Analysieren' : 'Diktat starten'}
                  style={{
                    width: 56, height: 56, borderRadius: '50%', border: 'none', cursor: 'pointer', flexShrink: 0,
                    background: diktatPhase === 'aufnahme' ? 'var(--ld-danger)' : 'var(--ld-primary)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    animation: diktatPhase === 'aufnahme' ? 'micPulse 1.2s ease-in-out infinite' : 'none',
                    transition: 'background 0.3s', color: 'white',
                  }}
                >
                  {diktatPhase === 'aufnahme' ? <MIcon name="stop" size={24} color="#fff" /> : (diktatPhase === 'transkribiert' || diktatPhase === 'analysiert') ? <MIcon name="hourglass_top" size={22} color="#fff" /> : <MIcon name="mic" size={24} color="#fff" />}
                </button>
                <div style={{ flex: 1, minWidth: 0, fontSize: 13 }}>
                  {diktatPhase === 'aufnahme' && (
                    <>
                      <div style={{ fontWeight: 600, marginBottom: 4, color: 'var(--ld-text-primary)' }}>Aufnahme läuft — tippen zum Stoppen</div>
                      <div className="ld-fz-wave" style={{ display: 'flex', alignItems: 'flex-end', gap: 2, height: 16 }}>
                        {[0.9,1.1,0.7,1.3,0.8,1.2].map((d, i) => (
                          <div key={i} style={{ width: 3, borderRadius: 2, background: 'var(--ld-primary)', height: 5, animation: `waveBar ${d}s ease-in-out ${i*0.07}s infinite alternate` }} />
                        ))}
                      </div>
                    </>
                  )}
                  {diktatPhase === 'transkribiert' && <div style={{ color: 'var(--ld-text-secondary)', display: 'flex', alignItems: 'center', gap: 6 }}><span className="ld-mail-spin" style={{ display: 'inline-flex' }}><MIcon name="progress_activity" size={14} /></span>Transkription läuft …</div>}
                  {diktatPhase === 'analysiert'    && <div style={{ color: 'var(--ld-text-secondary)', display: 'flex', alignItems: 'center', gap: 6 }}><span className="ld-mail-spin" style={{ display: 'inline-flex' }}><MIcon name="progress_activity" size={14} /></span>KI analysiert …</div>}
                  {diktatPhase === 'fehler'         && (
                    <div style={{ color: 'var(--ld-danger-text)' }}><MIcon name="error" size={13} style={{ verticalAlign: '-2px' }} /> {diktatFehler}
                      <button onClick={() => { setDiktatFehler(''); setDiktatPhase('idle'); void startMaDiktat(); }}
                        style={{ marginLeft: 8, background: 'none', border: `1px solid var(--ld-danger)`, borderRadius: 5, color: 'var(--ld-danger-text)', fontSize: 10, padding: '1px 6px', cursor: 'pointer' }}>Erneut</button>
                    </div>
                  )}
                  {diktatPhase === 'idle' && !diktatFehler && (
                    <div style={{ color: 'var(--ld-text-secondary)' }}>Drücke den Mikrofon-Button zum Starten</div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Formular */}
          {eingabeModus === 'manuell' && (
            <div style={{ padding: 20 }}>
              {[
                { label: 'Datum', child: <LdDatum value={datum} onChange={e => setDatum(e.target.value)} /> },
                { label: 'Typ', child: (
                  <div style={{ display: 'flex', gap: 8 }}>
                    {([['mehrarbeit', 'Mehrarbeit', '#6B5FD4'], ['vertretung', 'Vertretung', '#34A6A0']] as const).map(([v, l, col]) => {
                      const aktiv = typ === v;
                      return (
                        <button key={v} type="button" onClick={() => setTyp(v)} aria-pressed={aktiv} style={{
                          flex: 1, padding: '11px 12px', borderRadius: 12,
                          border: aktiv ? `1.5px solid ${col}` : '1.5px solid var(--ld-field-border)',
                          background: aktiv ? col + '18' : 'var(--ld-bg-card)',
                          color: aktiv ? col : 'var(--ld-text-secondary)',
                          fontSize: 14, fontWeight: aktiv ? 700 : 600, cursor: 'pointer',
                          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
                        }}>
                          <span style={{ width: 9, height: 9, borderRadius: '50%', background: col, flexShrink: 0 }} />{l}
                        </button>
                      );
                    })}
                  </div>
                )},
                { label: 'Stunden', child: <input type="number" step="0.5" min="0.5" max="20" className="ld-compose-input" value={stunden} onChange={e => setStunden(e.target.value)} placeholder="z.B. 2" style={{ width: '100%', padding: '10px 12px', borderRadius: 12, border: '1.5px solid var(--ld-field-border)', background: 'var(--ld-bg-card)', fontSize: 14, outline: 'none', boxSizing: 'border-box' as const, color: 'var(--ld-text-primary)' }} /> },
                { label: 'Klasse (optional)', child: <input className="ld-compose-input" value={klasse} onChange={e => setKlasse(e.target.value)} placeholder="z.B. 10a" style={{ width: '100%', padding: '10px 12px', borderRadius: 12, border: '1.5px solid var(--ld-field-border)', background: 'var(--ld-bg-card)', fontSize: 14, outline: 'none', boxSizing: 'border-box' as const, color: 'var(--ld-text-primary)' }} /> },
                { label: 'Beschreibung (optional)', child: <input className="ld-compose-input" value={beschreibung} onChange={e => setBeschreibung(e.target.value)} placeholder="z.B. Bio für Frau Müller" style={{ width: '100%', padding: '10px 12px', borderRadius: 12, border: '1.5px solid var(--ld-field-border)', background: 'var(--ld-bg-card)', fontSize: 14, outline: 'none', boxSizing: 'border-box' as const, color: 'var(--ld-text-primary)' }} /> },
              ].map(({ label, child }) => (
                <div key={label} style={{ marginBottom: 14 }}>
                  <label style={{ fontSize: 13, fontWeight: 700, color: 'var(--ld-text-primary)', display: 'block', marginBottom: 5 }}>{label}</label>
                  {child}
                </div>
              ))}
              <div style={{ display: 'flex', gap: 10, marginTop: 6 }}>
                <button onClick={() => setModal(false)} style={{ flex: 1, padding: 12, background: 'var(--ld-bg-input)', color: 'var(--ld-text-secondary)', border: 'none', borderRadius: 'var(--ld-radius-pill)', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>Abbrechen</button>
                <button onClick={speichereEintrag} disabled={speichern || !datum || !stunden} style={{ flex: 2, padding: 12, background: (!datum || !stunden) ? 'var(--ld-bg-muted)' : 'linear-gradient(135deg,#6B5FD4,#4A3FB0)', color: (!datum || !stunden) ? 'var(--ld-text-secondary)' : 'white', border: 'none', borderRadius: 'var(--ld-radius-pill)', fontSize: 14, fontWeight: 700, cursor: (!datum || !stunden) ? 'not-allowed' : 'pointer', opacity: speichern ? 0.7 : 1, boxShadow: (!datum || !stunden) ? 'none' : 'var(--ld-shadow-elev-hero)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                  <MIcon name="check" size={18} />{speichern ? 'Speichern …' : 'Speichern'}
                </button>
              </div>
            </div>
          )}
        </div>
      </LdSheet>
    </div>
  );
}

// ── Mein Tag (Stundenplan + Tasks + Kalender + Mehrarbeit) ──────────────────
// Welle K3: Mein Tag mit EINEM Kopf („Mein Tag“, Datum und KW, ⋯-Menü des Reiters) und einer festen
// Leiste Aufgaben · Stundenplan · Kalender · Mehrarbeit (Handy Segment ohne Wischen, PC Reiterzeile).
// Seitenleiste Kalender/Stundenplan/Mehrarbeit öffnen diese Ansicht mit dem passenden Reiter (start).
type MeinTagReiter = 'tasks' | 'stundenplan' | 'kalender' | 'mehrarbeit';
export type MenuSetzen = (eintraege: KopfMenuEintrag[]) => void;
function MeinTagAnsicht({ start = 'tasks' }: { start?: MeinTagReiter } = {}) {
  const [subTab, setSubTab] = useState<MeinTagReiter>(start);
  const [menu, setMenu] = useState<KopfMenuEintrag[]>([]);
  const isMobile = useIsMobile();
  // Menü beim Reiterwechsel leeren (im Klick, nicht im Effekt — sonst überschriebe es das Menü des neuen Reiters)
  const wechsle = (r: MeinTagReiter) => { if (r !== subTab) { setMenu([]); setSubTab(r); } };
  const tabs: { key: MeinTagReiter; label: string }[] = [
    { key: 'tasks',       label: 'Aufgaben'    },
    { key: 'stundenplan', label: 'Stundenplan' },
    { key: 'kalender',    label: 'Kalender'    },
    { key: 'mehrarbeit',  label: 'Mehrarbeit'  },
  ];
  const heute = heuteIso();
  const kontext = `${new Date(heute + 'T12:00:00').toLocaleDateString('de-DE', { weekday: 'long' })}, ${datumTTMM(heute)}, KW ${kalenderwoche(heute)}`;
  return (
    <div className="ld-page-enter ld-mt">
      <header className="ld-kk">
        <div className="ld-kk__zeile">
          <div className="ld-kk__titel-block">
            <div className="ld-kk__titel-zeile"><h1 className="ld-kk__titel">Mein Tag</h1>{!isMobile && <span className="ld-mt-kontext">{kontext}</span>}</div>
            {isMobile && <p className="ld-kk__kontext">{kontext}</p>}
          </div>
          {menu.length > 0 && <KkMenu eintraege={menu} />}
        </div>
      </header>
      {isMobile ? (
        <div className="ld-kr"><div className="ld-kr-seg ld-mt-seg" role="tablist" aria-label="Bereiche von Mein Tag">
          {tabs.map(t => (
            <button key={t.key} type="button" role="tab" aria-selected={subTab === t.key} className={`ld-kr-seg__item${subTab === t.key ? ' ld-kr-seg__item--aktiv' : ''}`}
              onClick={() => wechsle(t.key)}>{t.label}</button>
          ))}
        </div></div>
      ) : (
        <div className="ld-kr ld-kr--pc"><div className="ld-kr-linie" role="tablist" aria-label="Bereiche von Mein Tag">
          {tabs.map(t => (
            <button key={t.key} type="button" role="tab" aria-selected={subTab === t.key} className={`ld-kr-linie__item${subTab === t.key ? ' ld-kr-linie__item--aktiv' : ''}`}
              onClick={() => wechsle(t.key)}>{t.label}</button>
          ))}
        </div></div>
      )}
      {subTab === 'stundenplan' && <div className="ld-tab-panel"><StundenplanAnsicht menuSetzen={setMenu} /></div>}
      {subTab === 'tasks'       && <div className="ld-tab-panel"><TasksAnsicht /></div>}
      {subTab === 'kalender'    && <div className="ld-tab-panel"><KalenderAnsicht /></div>}
      {subTab === 'mehrarbeit'  && <div className="ld-tab-panel"><MehrarbeitAnsicht /></div>}
    </div>
  );
}

// ── DSGVO / Datenschutz ────────────────────────────────────────────────────
function DsgvoAnsicht({ onAbmelden: _onAbmelden, ohneZurueck = false }: { onAbmelden: () => void; ohneZurueck?: boolean }) {
  const isMobile = useIsMobile();
  const [exportLaden, setExportLaden] = useState(false);
  // Deletion flow state
  const [loeschenSchritt, setLoeschenSchritt] = useState<0 | 1 | 2>(0); // 0=closed, 1=confirm, 2=token
  const [loeschenLaden, setLoeschenLaden] = useState(false);
  const [bestaetigung, setBestaetigung] = useState('');
  const [loeschToken, setLoeschToken] = useState('');
  const [tokenInput, setTokenInput] = useState('');
  // Einwilligung status
  const [einwStatus, setEinwStatus] = useState<{ aktuelle_version: string; nutzer_version: string | null; einwilligung_am: string | null; ki_verarbeitung_akzeptiert: boolean; needs_update: boolean } | null>(null);
  const [einwModalOffen, setEinwModalOffen] = useState(false);
  // Audit trail
  const [auditTrail, setAuditTrail] = useState<{ id: number; entity_type: string; entity_id: number; action: string; created_at: string }[]>([]);
  const [auditModalOffen, setAuditModalOffen] = useState(false);
  // Verarbeitungsverzeichnis
  const [verarbData, setVerarbData] = useState<any>(null);
  const [verarbModalOffen, setVerarbModalOffen] = useState(false);

  const [einwLaden, setEinwLaden] = useState(false);
  const einwNeuLaden = useCallback(() => {
    fetch(`${API_BASE}/api/einwilligung/status`, { headers: apiHeaders() })
      .then(leseFallback<any>(null, '/api/einwilligung/status')).then(d => d && setEinwStatus(d)).catch(() => {});
  }, []);
  useEffect(() => { einwNeuLaden(); }, [einwNeuLaden]);

  // KI-Einwilligung erteilen/widerrufen bzw. aktuelle Fassung bestätigen — dieselben
  // Endpunkte wie Einstellungen › Datenschutz & KI.
  async function einwSetzen(ki: boolean) {
    setEinwLaden(true);
    try {
      await apiPost('/api/einwilligung/aktualisieren', { ki_verarbeitung: ki });
      toast(ki ? 'KI-Verarbeitung erlaubt' : 'Einwilligung gespeichert');
      einwNeuLaden();
    } catch (e) { zeigeApiFehler(e, 'Speichern fehlgeschlagen'); } finally { setEinwLaden(false); }
  }
  async function kiWiderrufen() {
    setEinwLaden(true);
    try {
      await apiPost('/api/einwilligung/widerrufen');
      toast('KI-Einwilligung widerrufen');
      einwNeuLaden();
    } catch (e) { zeigeApiFehler(e, 'Widerruf fehlgeschlagen'); } finally { setEinwLaden(false); }
  }

  async function exportieren() {
    setExportLaden(true);
    try {
      const r = await fetch(`${API_BASE}/api/datenschutz/export`, { headers: apiHeaders() });
      if (r.ok) {
        const blob = await r.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = `lehrerdesk-export-${new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' })}.json`;
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else {
        toast('Export fehlgeschlagen', 'error');
      }
    } catch { toast('Export fehlgeschlagen', 'error'); } finally { setExportLaden(false); }
  }

  async function loeschenVorbereiten() {
    if (bestaetigung !== 'LÖSCHEN') return;
    setLoeschenLaden(true);
    try {
      const d = await apiPost<any>('/api/datenschutz/account/vorbereiten');
      setLoeschToken(d.token); setTokenInput(''); setLoeschenSchritt(2);
    } catch (e) { zeigeApiFehler(e); } finally { setLoeschenLaden(false); }
  }

  async function kontoLoeschenEndgueltig() {
    setLoeschenLaden(true);
    try {
      await apiFetch('/api/datenschutz/account', { method: 'DELETE', body: JSON.stringify({ token: tokenInput }) });
      setLoeschenSchritt(0); localStorage.clear(); window.location.href = '/';
    } catch (e) { zeigeApiFehler(e); } finally { setLoeschenLaden(false); }
  }

  async function auditLaden() {
    try { setAuditTrail(await apiGet<any[]>('/api/audit/eigene')); }
    catch (e) { zeigeApiFehler(e, 'Audit-Trail laden fehlgeschlagen'); }
    setAuditModalOffen(true);
  }

  // Welle S8: alle Sitzungen beenden (Server erhöht die Sitzungs-Version), danach hier aufräumen
  const [passwortOffen, setPasswortOffen] = useState(false); // Welle A3
  async function ueberallAbmelden() {
    const ok = await confirm('Alle Geräte, auf denen du angemeldet bist, werden abgemeldet, auch dieses. Danach meldest du dich neu an.', { title: 'Auf allen Geräten abmelden?', confirmLabel: 'Überall abmelden' });
    if (!ok) return;
    try { await apiPost('/api/auth/logout-all-devices'); } catch (e) { zeigeApiFehler(e, 'Abmelden fehlgeschlagen'); return; }
    void abmeldenUndAufraeumen();
  }

  async function verarbLaden() {
    try { setVerarbData(await apiGet<any>('/api/datenschutz/verarbeitung')); }
    catch (e) { zeigeApiFehler(e, 'Laden fehlgeschlagen'); }
    setVerarbModalOffen(true);
  }

  const ACTION_LABEL: Record<string, string> = { create: 'erstellt', update: 'geändert', delete: 'gelöscht', verlassen: 'als verlassen markiert', reaktivieren: 'reaktiviert' };
  const ENTITY_LABEL: Record<string, string> = {
    note: 'Note', fehlzeit: 'Fehlzeit', schueler: 'Schüler', gespraech: 'Gespräch', mitarbeit: 'Mündliche Mitarbeit',
    halbjahres_note: 'Halbjahresnote', vorjahres_note: 'Vorjahresnote', mdl_vorschlag: 'Notenvorschlag', schultermin: 'Termin',
  };

  return (
    <div style={{ padding: isMobile ? '16px 12px' : '24px 32px', maxWidth: 720, margin: '0 auto' }}>
      {!ohneZurueck && <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '0 0 24px' }}>
        <button onClick={() => globalNav('einstellungen')} aria-label="Zurück zu den Einstellungen" style={{ width: 36, height: 36, borderRadius: 11, flexShrink: 0, background: 'var(--ld-bg-input)', color: 'var(--ld-text-secondary)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><MIcon name="arrow_back" size={18} /></button>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: 'var(--ld-text-primary)' }}>Datenschutz & Konto</h2>
      </div>}

      {/* Account & Daten */}
      <div style={{ background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)' as any, padding: 24, boxShadow: 'var(--ld-shadow-card)' as any, marginBottom: 20 }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 800, color: 'var(--ld-text-primary)' }}>Account & Daten</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {/* Export */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid var(--ld-bg-input)' }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ld-text-primary)' }}>Meine Daten exportieren</div>
              <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)' }}>Vollständiger DSGVO-Export (Art. 20) als JSON</div>
            </div>
            <button onClick={exportieren} disabled={exportLaden} style={{ padding: '9px 18px', background: 'var(--ld-primary)', color: 'white', border: 'none', borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: 'pointer', opacity: exportLaden ? 0.7 : 1, whiteSpace: 'nowrap' }}>
              {exportLaden ? 'Läuft …' : <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><MIcon name="download" size={16} />Herunterladen</span>}
            </button>
          </div>
          {/* Einwilligungen */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid var(--ld-bg-input)' }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ld-text-primary)' }}>Einwilligungen ansehen und ändern</div>
              <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)' }}>
                {einwStatus ? `Version ${einwStatus.nutzer_version ?? '–'} · ${einwStatus.einwilligung_am ? datumTTMMJJJJ(einwStatus.einwilligung_am) : '–'}` : 'Lädt …'}
              </div>
            </div>
            <button onClick={() => setEinwModalOffen(true)} style={{ padding: '9px 18px', background: 'var(--ld-bg-input)', border: 'none', borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>Ansehen</button>
          </div>
          {/* Verarbeitungsverzeichnis */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid var(--ld-bg-input)' }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ld-text-primary)' }}>Datenverarbeitungsübersicht</div>
              <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)' }}>Welche Daten werden wofür verarbeitet</div>
            </div>
            <button onClick={verarbLaden} style={{ padding: '9px 18px', background: 'var(--ld-bg-input)', border: 'none', borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>Ansehen</button>
          </div>
          {/* Audit Trail */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid var(--ld-bg-input)' }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ld-text-primary)' }}>Meine Aktivität</div>
              <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)' }}>Letzte 50 Änderungen in deinem Konto</div>
            </div>
            <button onClick={auditLaden} style={{ padding: '9px 18px', background: 'var(--ld-bg-input)', border: 'none', borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>Anzeigen</button>
          </div>
          {/* Welle A3: Passwort ändern (beendet alle anderen Sitzungen) */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid var(--ld-bg-input)' }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ld-text-primary)' }}>Passwort ändern</div>
              <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)' }}>Danach sind alle anderen Geräte abgemeldet.</div>
            </div>
            <button onClick={() => setPasswortOffen(true)} style={{ padding: '9px 18px', background: 'var(--ld-bg-input)', border: 'none', borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' }}>Ändern</button>
          </div>
          <PasswortFenster open={passwortOffen} onClose={() => setPasswortOffen(false)} />
          {/* Welle S8: alle Sitzungen beenden (z. B. Handy verloren), auch diese */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid var(--ld-bg-input)' }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ld-text-primary)' }}>Auf allen Geräten abmelden</div>
              <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)' }}>Zum Beispiel, wenn ein Handy verloren ist. Auch dieses Gerät wird abgemeldet.</div>
            </div>
            <button onClick={ueberallAbmelden} style={{ padding: '9px 18px', background: 'var(--ld-bg-input)', border: 'none', borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' }}>Abmelden</button>
          </div>
          {/* Löschen */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0' }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#BE123C' }}>Account unwiderruflich löschen</div>
              <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)' }}>Alle Daten permanent entfernen (Art. 17)</div>
            </div>
            <button onClick={() => { setBestaetigung(''); setLoeschenSchritt(1); }} style={{ padding: '9px 18px', background: '#FFF1F2', color: '#BE123C', border: '1.5px solid #FECDD3', borderRadius: 10, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><MIcon name="delete" size={16} />Löschen</span>
            </button>
          </div>
        </div>
      </div>

      {/* Datenschutzerklärung — derselbe Text wie öffentlich und in der Registrierung (Welle U10) */}
      <div style={{ background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)' as any, padding: 24, boxShadow: 'var(--ld-shadow-card)' as any }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 800, color: 'var(--ld-text-primary)' }}>Datenschutzerklärung</h3>
        <DatenschutzerklaerungText />
        <RechtsLinks ausrichtung="flex-start" style={{ marginTop: 18 }} />
      </div>

      {/* Welle Z3: Konto-Fenster im K4-Rahmen — Texte und Abläufe unverändert */}
      {/* Lösch-Modal Schritt 1: LÖSCHEN tippen */}
      <LdSheet open={loeschenSchritt === 1} onClose={() => setLoeschenSchritt(0)} maxWidth={440}
        kopf={{ titel: 'Konto wirklich löschen?', icon: 'warning' }}
        fuss={<>
          <button type="button" className="ld-fe-knopf ld-fe-knopf--zweit" onClick={() => setLoeschenSchritt(0)}>Abbrechen</button>
          <button type="button" className="ld-fe-knopf ld-fe-knopf--haupt ist-gefahr" onClick={loeschenVorbereiten} disabled={bestaetigung !== 'LÖSCHEN' || loeschenLaden}>
            {loeschenLaden ? 'Bitte warten …' : 'Weiter →'}
          </button>
        </>}>
        <p className="ld-fe-text">
          Dieser Schritt löscht <strong>unwiderruflich alle Daten</strong>. Tippe <strong>LÖSCHEN</strong> zur Bestätigung.
        </p>
        <LdEingabe aria-label="LÖSCHEN zur Bestätigung" value={bestaetigung} onChange={e => setBestaetigung(e.target.value)} placeholder="LÖSCHEN"
          style={{ textAlign: 'center' }} />
      </LdSheet>

      {/* Lösch-Modal Schritt 2: Token eingeben */}
      <LdSheet open={loeschenSchritt === 2} onClose={() => setLoeschenSchritt(0)} maxWidth={440}
        kopf={{ titel: 'Bestätigungs-Code eingeben' }}
        fuss={<>
          <button type="button" className="ld-fe-knopf ld-fe-knopf--zweit" onClick={() => setLoeschenSchritt(0)}>Abbrechen</button>
          <button type="button" className="ld-fe-knopf ld-fe-knopf--haupt ist-gefahr" onClick={kontoLoeschenEndgueltig} disabled={!tokenInput.trim() || loeschenLaden}>
            {loeschenLaden ? 'Löschen …' : 'Endgültig löschen'}
          </button>
        </>}>
        <p className="ld-fe-text">
          Dein Bestätigungs-Code (gültig 10 Minuten):<br />
          <code style={{ background: 'var(--ld-bg-muted)', padding: '4px 8px', borderRadius: 6, fontSize: 13, fontWeight: 700, letterSpacing: 1 }}>{loeschToken}</code>
        </p>
        <p className="ld-fe-text">Bitte kopiere den Code oben und füge ihn unten ein:</p>
        <LdEingabe aria-label="Code eingeben" value={tokenInput} onChange={e => setTokenInput(e.target.value)} placeholder="Code eingeben" style={{ fontFamily: 'monospace' }} />
      </LdSheet>

      {/* Einwilligung-Status */}
      <LdSheet open={einwModalOffen && !!einwStatus} onClose={() => setEinwModalOffen(false)} maxWidth={460}
        kopf={{ titel: 'Meine Einwilligungen' }}
        fuss={<LdFensterFuss onAbbrechen={() => setEinwModalOffen(false)} abbrechen="Schließen" />}>
        {einwStatus && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, fontSize: 13 }}>
            <div className="ld-z3-feld">
              <div style={{ fontWeight: 700, marginBottom: 4 }}>Datenverarbeitung (Pflicht)</div>
              <div style={{ color: einwStatus.nutzer_version ? 'var(--ld-success-text)' : 'var(--ld-danger-text)', fontWeight: 600 }}>
                {einwStatus.nutzer_version ? (einwStatus.needs_update ? 'Erteilt (ältere Fassung)' : 'Erteilt') : 'Nicht erteilt'}
              </div>
              <div style={{ color: 'var(--ld-text-secondary)', marginTop: 2 }}>Version: {einwStatus.nutzer_version ?? '–'} · {einwStatus.einwilligung_am ? datumTTMMJJJJ(einwStatus.einwilligung_am) : '–'}</div>
            </div>
            <div className="ld-z3-feld">
              <div style={{ fontWeight: 700, marginBottom: 4 }}>KI-Verarbeitung (Optional)</div>
              <div style={{ color: einwStatus.ki_verarbeitung_akzeptiert ? 'var(--ld-success-text)' : 'var(--ld-danger-text)', fontWeight: 600 }}>
                {einwStatus.ki_verarbeitung_akzeptiert ? 'Erteilt' : 'Nicht erteilt / widerrufen'}
              </div>
              <div style={{ color: 'var(--ld-text-secondary)', marginTop: 2 }}>Betrifft: Diktat, Zeugnis-KI, Mail-Antworten, Stoffplan-Vorschläge</div>
              <div style={{ marginTop: 10 }}>
                {einwStatus.ki_verarbeitung_akzeptiert
                  ? <Button variant="secondary" size="sm" disabled={einwLaden} onClick={kiWiderrufen}>KI-Einwilligung widerrufen</Button>
                  : <Button variant="primary" size="sm" disabled={einwLaden} onClick={() => einwSetzen(true)}>KI-Verarbeitung erlauben</Button>}
              </div>
            </div>
            {einwStatus.needs_update && (
              <div style={{ padding: 12, background: 'var(--ld-warning-soft)', borderRadius: 12, fontSize: 12, color: 'var(--ld-warning-text)' }}>
                <div style={{ marginBottom: 8 }}>Es gibt eine aktualisierte Fassung der Einwilligung ({einwStatus.aktuelle_version}).</div>
                <Button variant="secondary" size="sm" disabled={einwLaden} onClick={() => einwSetzen(einwStatus.ki_verarbeitung_akzeptiert)}>Aktuelle Fassung bestätigen</Button>
              </div>
            )}
          </div>
        )}
      </LdSheet>

      {/* Audit-Trail */}
      <LdSheet open={auditModalOffen} onClose={() => setAuditModalOffen(false)} maxWidth={560}
        kopf={{ titel: 'Meine Aktivität (letzte 50)' }}>
        {auditTrail.length === 0 ? (
          <div style={{ textAlign: 'center', color: 'var(--ld-text-secondary)', padding: 24 }}>Keine Aktivitäten vorhanden.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {auditTrail.map(e => (
              <div key={e.id} style={{ padding: '9px 12px', borderRadius: 10, background: 'var(--ld-bg-muted)', fontSize: 13 }}>
                <span style={{ fontWeight: 600, color: 'var(--ld-text-primary)' }}>
                  {e.entity_type === 'alle_sitzungen' ? 'Auf allen Geräten abgemeldet' : <>{/* Welle S8 */}
                  {ENTITY_LABEL[e.entity_type] ?? e.entity_type} #{e.entity_id}{' '}
                  <span style={{ color: e.action === 'delete' ? '#DC2626' : e.action === 'create' ? 'var(--ld-success)' : '#8A5E0E', fontWeight: 700 }}>{ACTION_LABEL[e.action] ?? e.action}</span></>}
                </span>
                <span style={{ color: 'var(--ld-text-tertiary)', marginLeft: 8, fontSize: 11 }}>{new Date(e.created_at).toLocaleString('de-DE')}</span>
              </div>
            ))}
          </div>
        )}
      </LdSheet>

      {/* Verarbeitungsverzeichnis */}
      <LdSheet open={verarbModalOffen && !!verarbData} onClose={() => setVerarbModalOffen(false)} maxWidth={600}
        kopf={{ titel: 'Datenverarbeitungsübersicht', kontext: verarbData ? `Version ${verarbData.version} · Verantwortlicher: ${verarbData.verantwortlicher?.name} (${verarbData.verantwortlicher?.email})` : null }}>
        {verarbData && <VerarbeitungsListe verarbeitungen={verarbData.verarbeitungen ?? []} />}
      </LdSheet>
    </div>
  );
}

// ── Klassenorganisation ────────────────────────────────────────────────────
interface Elternbeiraet {
  id: number; klasse_id: number; vorname: string; nachname: string;
  email: string; telefon: string | null; rolle: string; notizen: string | null;
}
interface KlassenAktion {
  id: number; klasse_id: number; titel: string; beschreibung: string | null;
  faellig_am: string | null; kategorie: string;
  erledigt_anzahl: number; gesamt_anzahl: number;
}
interface AktionSchuelerStatus {
  id: number; vorname: string; nachname: string; erledigt: number; notiz: string;
}

const ROLLENLABEL: Record<string, string> = {
  vorsitz: 'Vorsitz', stellvertretung: 'Stellv.', kassenwart: 'Kassenwart', beisitzer: 'Beisitzer',
};
const AKTIONSKATEGORIE_LABEL: Record<string, string> = {
  einverstaendnis: 'Einverständnis', zahlung: 'Zahlung', material: 'Material',
  rueckgabe: 'Rückgabe', klassenfahrt: 'Klassenfahrt', ausflug: 'Ausflug', sonstiges: 'Sonstiges',
};
const AKTIONSKATEGORIE_ICON: Record<string, string> = {
  einverstaendnis: 'fact_check', zahlung: 'payments', material: 'backpack', rueckgabe: 'assignment_return', klassenfahrt: 'directions_bus', ausflug: 'backpack', sonstiges: 'checklist',
};
// Kategorie-Farben: KAT_FARBEN wo vorhanden (ausflug/klassenfahrt), sonst additive Töne (KEINE KAT_FARBE-Neudefinition)
const AKTIONSKATEGORIE_FARBE: Record<string, string> = {
  einverstaendnis: '#6B5FD4', zahlung: '#2F8B4E', material: KAT_FARBEN.ausflug, rueckgabe: '#3A6BA8', klassenfahrt: KAT_FARBEN.klassenfahrt, ausflug: KAT_FARBEN.ausflug, sonstiges: '#8E8E93',
};

interface Ausgabe {
  id: number; aktion_id: number; lehrer_id: number;
  beschreibung: string; betrag: number; kategorie: string;
  beleg_foto: string | null; datum: string; created_at: string;
}
const AUSGABEN_KAT_LABEL: Record<string, string> = {
  transport: 'Transport', verpflegung: 'Verpflegung', eintritt: 'Eintritt',
  unterkunft: 'Unterkunft', sonstiges: 'Sonstiges',
};
const AUSGABEN_KAT_ICON: Record<string, string> = {
  transport: 'directions_bus', verpflegung: 'restaurant', eintritt: 'local_activity', unterkunft: 'hotel', sonstiges: 'payments',
};

// Welle K1: tab = Unterreiter aus dem Klassenkopf (KlasseTab) — dann ohne eigene Überschrift, Klassen-Leiste und Reiter
function KlasseAnsicht({ onNav, externeKlasseId, aktionenZiel, tab: tabVorgabe }: { onNav: (k: NavItem) => void; externeKlasseId?: number | null; aktionenZiel?: { aktionId: number | null } | null; tab?: 'elternbeirat' | 'aktionen' | 'ausgaben' }) {
  const isMobile = useIsMobile();
  const [tabLokal, setTab] = useState<'elternbeirat' | 'aktionen' | 'ausgaben'>('elternbeirat');
  const tab = tabVorgabe ?? tabLokal;
  const gesteuert = tabVorgabe !== undefined;
  const [klassen, setKlassen] = useState<KlasseFachEintrag[]>([]);
  const [aktiveKlasseId, setAktiveKlasseId] = useState<number | null>(null);

  // Elternbeirat state
  const [elternbeirate, setElternbeirate] = useState<Elternbeiraet[]>([]);
  const [ebLaden, setEbLaden] = useState(false);
  const [ebModal, setEbModal] = useState(false);
  const [ebEdit, setEbEdit] = useState<Elternbeiraet | null>(null);
  const [ebVorname, setEbVorname] = useState('');
  const [ebNachname, setEbNachname] = useState('');
  const [ebEmail, setEbEmail] = useState('');
  const [ebTelefon, setEbTelefon] = useState('');
  const [ebRolle, setEbRolle] = useState('beisitzer');
  const [ebNotizen, setEbNotizen] = useState('');
  const [ebSpeichern, setEbSpeichern] = useState(false);

  // Aktionen state
  const [aktionen, setAktionen] = useState<KlassenAktion[]>([]);
  const [akLaden, setAkLaden] = useState(false);
  const [akModal, setAkModal] = useState(false);
  const [akEdit, setAkEdit] = useState<KlassenAktion | null>(null);
  const [akTitel, setAkTitel] = useState('');
  const [akBeschreibung, setAkBeschreibung] = useState('');
  const [akFaellig, setAkFaellig] = useState('');
  const [akKategorie, setAkKategorie] = useState('sonstiges');
  const [akSpeichern, setAkSpeichern] = useState(false);

  // Status-Detail
  const [statusAktion, setStatusAktion] = useState<KlassenAktion | null>(null);
  const [statusListe, setStatusListe] = useState<AktionSchuelerStatus[]>([]);
  const [statusLaden, setStatusLaden] = useState(false);

  // Erinnerungs-Mail
  const [erinnerungLaden, setErinnerungLaden] = useState(false);
  const [erinnerungText, setErinnerungText] = useState('');
  const [erinnerungModal, setErinnerungModal] = useState(false);

  // Ausgaben
  const [ausgaben, setAusgaben] = useState<Ausgabe[]>([]);
  const [ausgabenAktionId, setAusgabenAktionId] = useState<number | null>(null);
  const [ausgabenAktion, setAusgabenAktion] = useState<KlassenAktion | null>(null);
  const [ausgabenLaden, setAusgabenLaden] = useState(false);
  const [ausgabeModal, setAusgabeModal] = useState(false);
  const [ausgabeBeschr, setAusgabeBeschr] = useState('');
  const [ausgabeBetrag, setAusgabeBetrag] = useState('');
  const [ausgabeKat, setAusgabeKat] = useState('sonstiges');
  const [ausgabeDatum, setAusgabeDatum] = useState(() => new Date().toISOString().slice(0, 10));
  const [ausgabeSpeichern, setAusgabeSpeichern] = useState(false);
  const [ausgabeExportLaden, setAusgabeExportLaden] = useState(false);

  useEffect(() => {
    if (externeKlasseId != null) setAktiveKlasseId(externeKlasseId);
  }, [externeKlasseId]);

  // Welle U2: Sprung aus „Heute" → Tab Aktionen, Ziel-Aktion sichtbar + hervorgehoben
  const zielAktionId = aktionenZiel?.aktionId ?? null;
  useEffect(() => { if (aktionenZiel) setTab('aktionen'); }, [aktionenZiel]);
  useEffect(() => {
    if (zielAktionId == null || akLaden || tab !== 'aktionen') return;
    const t = setTimeout(() => document.getElementById(`ld-aktion-${zielAktionId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 200);
    return () => clearTimeout(t);
  }, [zielAktionId, akLaden, tab, aktionen]);

  useEffect(() => {
    fetch(`${API_BASE}/api/meine-klassen`, { headers: apiHeaders() })
      .then(leseFallback<KlasseFachEintrag[]>([], '/api/meine-klassen'))
      .then((data: KlasseFachEintrag[]) => {
        setKlassen(data);
        // Welle B1: nur ohne bereits gesetzte Klasse — die Vorgabe von außen (KlasseTab) kann
        // vor dieser Antwort ankommen; der alte Closure-Vergleich überschrieb sie mit data[0]
        if (data.length > 0) setAktiveKlasseId(prev => prev ?? data[0].klasse_id);
      }).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!aktiveKlasseId) return;
    setEbLaden(true);
    fetch(`${API_BASE}/api/klassen/${aktiveKlasseId}/elternbeirat`, { headers: apiHeaders() })
      .then(leseFallback<any[]>([], '/api/klassen/:id/elternbeirat')).then(setElternbeirate).catch(() => {}).finally(() => setEbLaden(false));
  }, [aktiveKlasseId]);

  useEffect(() => {
    if (!aktiveKlasseId) return;
    setAkLaden(true);
    fetch(`${API_BASE}/api/klassen/${aktiveKlasseId}/aktionen`, { headers: apiHeaders() })
      .then(leseFallback<any[]>([], '/api/klassen/:id/aktionen')).then(setAktionen).catch(() => {}).finally(() => setAkLaden(false));
  }, [aktiveKlasseId]);

  function oeffneEbModal(eb?: Elternbeiraet) {
    setEbEdit(eb ?? null);
    setEbVorname(eb?.vorname ?? '');
    setEbNachname(eb?.nachname ?? '');
    setEbEmail(eb?.email ?? '');
    setEbTelefon(eb?.telefon ?? '');
    setEbRolle(eb?.rolle ?? 'beisitzer');
    setEbNotizen(eb?.notizen ?? '');
    setEbModal(true);
  }

  async function speichereEb() {
    if (!aktiveKlasseId || !ebVorname.trim() || !ebNachname.trim() || !ebEmail.trim()) return;
    setEbSpeichern(true);
    try {
      const body = { vorname: ebVorname, nachname: ebNachname, email: ebEmail, telefon: ebTelefon, rolle: ebRolle, notizen: ebNotizen };
      const saved = ebEdit
        ? await apiPut<any>(`/api/elternbeirat/${ebEdit.id}`, body)
        : await apiPost<any>(`/api/klassen/${aktiveKlasseId}/elternbeirat`, body);
      setElternbeirate(prev => ebEdit ? prev.map(e => e.id === saved.id ? saved : e) : [...prev, saved]);
      setEbModal(false);
    } catch (e) { zeigeApiFehler(e, 'Speichern fehlgeschlagen'); } finally { setEbSpeichern(false); }
  }

  async function loescheEb(id: number) {
    if (!(await confirm('Elternbeiratsmitglied wirklich löschen?', { danger: true, confirmLabel: 'Löschen' }))) return;
    try {
      await apiDelete(`/api/elternbeirat/${id}`);
      setElternbeirate(prev => prev.filter(e => e.id !== id));
    } catch (e) { zeigeApiFehler(e, 'Löschen fehlgeschlagen'); }
  }

  function oeffneAkModal(ak?: KlassenAktion) {
    setAkEdit(ak ?? null);
    setAkTitel(ak?.titel ?? '');
    setAkBeschreibung(ak?.beschreibung ?? '');
    setAkFaellig(ak?.faellig_am ?? '');
    setAkKategorie(ak?.kategorie ?? 'sonstiges');
    setAkModal(true);
  }

  async function speichereAk() {
    if (!aktiveKlasseId || !akTitel.trim()) return;
    setAkSpeichern(true);
    try {
      const body = { titel: akTitel, beschreibung: akBeschreibung, faellig_am: akFaellig || null, kategorie: akKategorie };
      const saved = akEdit
        ? await apiPut<any>(`/api/aktionen/${akEdit.id}`, body)
        : await apiPost<any>(`/api/klassen/${aktiveKlasseId}/aktionen`, body);
      setAktionen(prev => akEdit ? prev.map(a => a.id === saved.id ? saved : a) : [...prev, saved]);
      setAkModal(false);
    } catch (e) { zeigeApiFehler(e, 'Speichern fehlgeschlagen'); } finally { setAkSpeichern(false); }
  }

  async function loescheAk(id: number) {
    if (!(await confirm('Aktion wirklich löschen?', { danger: true, confirmLabel: 'Löschen' }))) return;
    try {
      await apiDelete(`/api/aktionen/${id}`);
      setAktionen(prev => prev.filter(a => a.id !== id));
    } catch (e) { zeigeApiFehler(e, 'Löschen fehlgeschlagen'); }
  }

  async function ladeStatus(aktion: KlassenAktion) {
    setStatusAktion(aktion);
    setStatusLaden(true);
    try { setStatusListe(await apiGet<any[]>(`/api/aktionen/${aktion.id}/status`)); }
    catch (e) { zeigeApiFehler(e, 'Status laden fehlgeschlagen'); }
    setStatusLaden(false);
  }

  async function toggleStatus(aktionId: number, schuelerId: number, erledigt: boolean) {
    try {
      await apiFetch(`/api/aktionen/${aktionId}/status/${schuelerId}`, { method: 'PATCH', body: JSON.stringify({ erledigt }) });
      toast(erledigt ? 'Als erledigt markiert' : 'Status zurückgesetzt', 'success');
    } catch (e) { zeigeApiFehler(e, 'Status ändern fehlgeschlagen'); return; }
    setStatusListe(prev => prev.map(s => s.id === schuelerId ? { ...s, erledigt: erledigt ? 1 : 0 } : s));
    // Update counter in aktionen list
    setAktionen(prev => prev.map(a => {
      if (a.id !== aktionId) return a;
      const delta = erledigt ? 1 : -1;
      return { ...a, erledigt_anzahl: Math.max(0, a.erledigt_anzahl + delta) };
    }));
  }

  async function generiereErinnerung(aktion: KlassenAktion) {
    setErinnerungLaden(true);
    setErinnerungText('');
    try {
      const data = await apiPost<any>(`/api/aktionen/${aktion.id}/erinnerung`);
      setErinnerungText(data.mailtext ?? '');
      setErinnerungModal(true);
    } catch (e) { zeigeApiFehler(e, 'Erinnerung generieren fehlgeschlagen'); } finally { setErinnerungLaden(false); }
  }

  function ladeAusgaben(aktionId: number) {
    setAusgabenLaden(true);
    fetch(`${API_BASE}/api/ausgaben?aktion_id=${aktionId}`, { headers: apiHeaders() })
      .then(leseFallback<any[]>([], '/api/ausgaben')).then(setAusgaben).catch(() => {}).finally(() => setAusgabenLaden(false));
  }

  async function speichereAusgabe() {
    if (!ausgabenAktionId || !ausgabeBeschr.trim() || !ausgabeBetrag) return;
    setAusgabeSpeichern(true);
    try {
      const neu = await apiPost<any>('/api/ausgaben', {
        aktion_id: ausgabenAktionId, beschreibung: ausgabeBeschr,
        betrag: parseFloat(ausgabeBetrag.replace(',', '.')), kategorie: ausgabeKat, datum: ausgabeDatum,
      });
      setAusgaben(prev => [neu, ...prev]);
      setAusgabeModal(false); setAusgabeBeschr(''); setAusgabeBetrag(''); setAusgabeKat('sonstiges');
    } catch (err) {
      zeigeApiFehler(err, 'Speichern fehlgeschlagen');
    } finally { setAusgabeSpeichern(false); }
  }

  async function loescheAusgabe(id: number) {
    try {
      await apiDelete(`/api/ausgaben/${id}`);
      setAusgaben(prev => prev.filter(a => a.id !== id));
    } catch (err) {
      zeigeApiFehler(err, 'Löschen fehlgeschlagen');
    }
  }

  async function exportiereAusgaben() {
    if (!ausgabenAktionId) return;
    setAusgabeExportLaden(true);
    try {
      const r = await fetch(`${API_BASE}/api/export/ausgaben/${ausgabenAktionId}`, { headers: apiHeaders() });
      if (r.ok) {
        const blob = await r.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a'); a.href = url; a.download = `Ausgaben.pdf`;
        document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
      } else {
        toast('Export fehlgeschlagen', 'error');
      }
    } catch { toast('Export fehlgeschlagen', 'error'); } finally { setAusgabeExportLaden(false); }
  }

  const heute = new Date().toISOString().slice(0, 10);

  // Deduplizierte Klassen-Liste für Pills (eine Pill pro Klasse, nicht pro Fach)
  const eindeutigeKlassenOrg = React.useMemo(() => {
    const seen = new Map<number, KlasseFachEintrag>();
    for (const k of klassen) {
      if (!seen.has(k.klasse_id)) seen.set(k.klasse_id, k);
    }
    return Array.from(seen.values());
  }, [klassen]);

  return (
    <div className="ld-page-enter" style={gesteuert ? undefined : { padding: isMobile ? '16px 12px' : '24px 32px', maxWidth: 900, margin: '0 auto' }}>
      {/* Eigenständig (ohne Klassenkopf): Titel, Klassen-Leiste und Reiter wie bisher — im Klassen-Bereich übernimmt das der Klassenkopf */}
      {!gesteuert && (
        <h2 style={{ margin: '0 0 20px', fontSize: 22, fontWeight: 800, color: 'var(--ld-text-primary)' }}>Klasse</h2>
      )}

      {/* Klassen-Picker */}
      {!gesteuert && externeKlasseId == null && eindeutigeKlassenOrg.length > 1 && (
        <div className="ld-kl-umschalter" style={{ marginBottom: 16, flexWrap: 'wrap' }}>
          {eindeutigeKlassenOrg.map(k => (
            <button key={k.klasse_id} type="button" aria-pressed={Number(aktiveKlasseId) === Number(k.klasse_id)} onClick={() => setAktiveKlasseId(k.klasse_id)}>{k.klasse_name}</button>
          ))}
        </div>
      )}

      {klassen.length === 0 && (
        <div className="ld-kl-leer" style={{ padding: 48 }}>
          <div style={{ marginBottom: 10, color: 'var(--ld-text-tertiary)' }}><MIcon name="school" size={40} /></div>
          <div style={{ fontWeight: 600 }}>Noch keine Klasse zugewiesen.</div>
        </div>
      )}

      {aktiveKlasseId && (
        <>
          {!gesteuert && (
            <div className="ld-kl-umschalter" style={{ marginBottom: 18 }}>
              {([['elternbeirat', 'Elternbeiräte'], ['aktionen', 'Aktionen'], ['ausgaben', 'Ausgaben']] as const).map(([k, l]) => (
                <button key={k} type="button" aria-pressed={tab === k} onClick={() => setTab(k)}>{l}</button>
              ))}
            </div>
          )}

          {/* ── Elternbeiräte ── */}
          {tab === 'elternbeirat' && (
            <div>
              <div className="ld-ko-kopf">
                <h2 className="ld-kl-abschnitt">Elternbeiräte <span className="ld-kl-abschnitt__zahl">{elternbeirate.length}</span></h2>
                <button type="button" className="ld-kl-zweit" onClick={() => oeffneEbModal()}><MIcon name="add" size={18} />Hinzufügen</button>
              </div>
              {ebLaden ? <LoadingBlock text="Lade Elternbeirat …" /> : elternbeirate.length === 0 ? (
                <div className="ld-kl-karte ld-kl-leer">Noch keine Elternbeiratsmitglieder eingetragen.</div>
              ) : (
                <div className="ld-kl-karte">
                  {elternbeirate.map((eb, i) => (
                    <div key={eb.id} className={i > 0 ? 'ld-kl-trenn' : undefined} style={{ padding: '12px 14px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <span className="ld-kl-avatar" aria-hidden="true">{`${eb.vorname[0] ?? ''}${eb.nachname[0] ?? ''}`.toUpperCase()}</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div className="ld-kl-zeile__name">{eb.vorname} {eb.nachname}</div>
                          <div className="ld-kl-zeile__unter" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{[ROLLENLABEL[eb.rolle] ?? eb.rolle, eb.email, eb.telefon].filter(Boolean).join(', ')}</div>
                        </div>
                        <button onClick={() => { if (_openNeueMailMitEmpfaenger) { _openNeueMailMitEmpfaenger(eb.email, `Betreff: `); onNav('mails'); } }} aria-label="Mail schreiben" title="Mail" className="ld-org-iconbtn" style={{ color: 'var(--ld-primary)' }}><MIcon name="mail" size={18} /></button>
                        <button onClick={() => oeffneEbModal(eb)} aria-label="Bearbeiten" title="Bearbeiten" className="ld-org-iconbtn" style={{ color: 'var(--ld-text-secondary)' }}><MIcon name="edit" size={18} /></button>
                        <button onClick={() => loescheEb(eb.id)} aria-label="Löschen" title="Löschen" className="ld-org-iconbtn" style={{ color: 'var(--ld-text-secondary)' }}><MIcon name="delete" size={18} /></button>
                      </div>
                      {eb.notizen && <div className="ld-kl-zeile__unter" style={{ marginTop: 6, paddingLeft: 52 }}>{eb.notizen}</div>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* ── Aktionen & Tracking ── */}
          {tab === 'aktionen' && (
            <div>
              <div className="ld-ko-kopf">
                <h2 className="ld-kl-abschnitt">Aktionen <span className="ld-kl-abschnitt__zahl">{aktionen.length}</span></h2>
                <button type="button" className="ld-kl-zweit" onClick={() => oeffneAkModal()}><MIcon name="add" size={18} />Neue Aktion</button>
              </div>
              {akLaden ? <LoadingBlock text="Lade Aktionen …" /> : aktionen.length === 0 ? (
                <div className="ld-kl-karte ld-kl-leer">Noch keine Aktionen angelegt.</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {aktionen.map(ak => {
                    const offen = ak.gesamt_anzahl - ak.erledigt_anzahl;
                    const ueberfaellig = !!ak.faellig_am && ak.faellig_am < heute;
                    const fortschritt = ak.gesamt_anzahl > 0 ? (ak.erledigt_anzahl / ak.gesamt_anzahl) * 100 : 0;
                    return (
                      <div key={ak.id} id={`ld-aktion-${ak.id}`} className="ld-kl-karte" style={{ padding: '14px 16px', boxShadow: zielAktionId === ak.id ? '0 0 0 2px var(--ld-primary), var(--ld-shadow-elev-low)' : undefined }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                          {/* Kategorie-Farbe nur als kleiner Punkt */}
                          <span className="ld-ko-icon" aria-hidden="true">
                            <MIcon name={AKTIONSKATEGORIE_ICON[ak.kategorie] ?? 'checklist'} size={20} />
                            <span className="ld-ko-punkt" style={{ background: AKTIONSKATEGORIE_FARBE[ak.kategorie] ?? 'var(--ld-primary)' }} />
                          </span>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div className="ld-kl-zeile__name" style={{ whiteSpace: 'normal' }}>{ak.titel}</div>
                            <div className="ld-kl-zeile__unter">
                              {AKTIONSKATEGORIE_LABEL[ak.kategorie] ?? ak.kategorie}
                              {ak.faellig_am && <>, <span style={ueberfaellig && offen > 0 ? { color: 'var(--ld-danger-text)', fontWeight: 600 } : undefined}>fällig {datumTTMMJJJJ(ak.faellig_am)}</span></>}
                            </div>
                            {ak.beschreibung && <div className="ld-kl-zeile__unter" style={{ color: 'var(--ld-text-tertiary)' }}>{ak.beschreibung}</div>}
                            <div className="ld-ko-fortschritt">
                              <div className="ld-ko-fortschritt__spur"><span className={fortschritt === 100 ? 'ld-ko-fertig' : undefined} style={{ width: `${fortschritt}%` }} /></div>
                              <span className="ld-ko-fortschritt__zahl">{ak.erledigt_anzahl} von {ak.gesamt_anzahl}</span>
                            </div>
                          </div>
                        </div>
                        <div className="ld-ko-leiste">
                          <button type="button" className="ld-kl-link" onClick={() => ladeStatus(ak)}>Status</button>
                          <div style={{ flex: 1 }} />
                          <button onClick={() => generiereErinnerung(ak)} disabled={erinnerungLaden || offen === 0} aria-label="Erinnerung senden" title="Erinnerung" className="ld-org-iconbtn" style={{ color: 'var(--ld-primary)', opacity: offen === 0 ? 0.4 : 1 }}><MIcon name="mail" size={18} /></button>
                          <button onClick={() => oeffneAkModal(ak)} aria-label="Bearbeiten" title="Bearbeiten" className="ld-org-iconbtn" style={{ color: 'var(--ld-text-secondary)' }}><MIcon name="edit" size={18} /></button>
                          <button onClick={() => loescheAk(ak.id)} aria-label="Löschen" title="Löschen" className="ld-org-iconbtn" style={{ color: 'var(--ld-text-secondary)' }}><MIcon name="delete" size={18} /></button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
          {/* ── Ausgaben ── */}
          {tab === 'ausgaben' && (
            <div>
              {aktionen.length === 0 ? (
                <div className="ld-kl-karte ld-kl-leer">Lege zuerst eine Aktion an, zum Beispiel eine Klassenfahrt.</div>
              ) : (
                <>
                  <h2 className="ld-kl-abschnitt">Zu welcher Aktion?</h2>
                  <div className="ld-kl-umschalter" style={{ marginBottom: 14, flexWrap: 'wrap' }}>
                    {aktionen.map(ak => (
                      <button key={ak.id} type="button" aria-pressed={ausgabenAktionId === ak.id} onClick={() => {
                        setAusgabenAktionId(ak.id); setAusgabenAktion(ak); ladeAusgaben(ak.id);
                      }}>{ak.titel}</button>
                    ))}
                  </div>

                  {ausgabenAktionId && (
                    <>
                      {ausgaben.length > 0 && (
                        <div className="ld-kl-karte ld-ko-summe">
                          <div>
                            <small>Gesamt</small>
                            <b>{ausgaben.reduce((s, a) => s + a.betrag, 0).toLocaleString('de-DE', { minimumFractionDigits: 2 })} €</b>
                            <small>
                              {Object.entries(
                                ausgaben.reduce((m, a) => { m[a.kategorie] = (m[a.kategorie] ?? 0) + a.betrag; return m; }, {} as Record<string, number>)
                              ).map(([k, v]) => `${AUSGABEN_KAT_LABEL[k] ?? k} ${v.toLocaleString('de-DE', { maximumFractionDigits: 0 })} €`).join(', ')}
                            </small>
                          </div>
                          <button type="button" className="ld-kl-zweit" onClick={exportiereAusgaben} disabled={ausgabeExportLaden}>
                            <MIcon name="picture_as_pdf" size={17} />{ausgabeExportLaden ? 'Wird erstellt …' : 'PDF'}
                          </button>
                        </div>
                      )}

                      <div className="ld-ko-kopf">
                        <h2 className="ld-kl-abschnitt">Ausgaben <span className="ld-kl-abschnitt__zahl">{ausgaben.length}</span></h2>
                        <button type="button" className="ld-kl-zweit" onClick={() => setAusgabeModal(true)}><MIcon name="add" size={18} />Ausgabe</button>
                      </div>

                      {ausgabenLaden ? <LoadingBlock text="Lade Ausgaben …" /> : ausgaben.length === 0 ? (
                        <div className="ld-kl-karte ld-kl-leer">Noch keine Ausgaben für {ausgabenAktion?.titel}.</div>
                      ) : (
                        <div className="ld-kl-karte">
                          {ausgaben.map((a, i) => (
                            <div key={a.id} className={i > 0 ? 'ld-kl-trenn' : undefined} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px' }}>
                              <span className="ld-ko-icon" aria-hidden="true"><MIcon name={AUSGABEN_KAT_ICON[a.kategorie] ?? 'payments'} size={20} /></span>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div className="ld-kl-zeile__name" style={{ fontSize: 14.5 }}>{a.beschreibung}</div>
                                <div className="ld-kl-zeile__unter">{AUSGABEN_KAT_LABEL[a.kategorie] ?? a.kategorie}, {datumTTMMJJJJ(a.datum)}</div>
                              </div>
                              <div style={{ fontWeight: 700, fontSize: 16, color: 'var(--ld-text-primary)', flexShrink: 0 }}>
                                {a.betrag.toLocaleString('de-DE', { minimumFractionDigits: 2 })} €
                              </div>
                              <button onClick={() => loescheAusgabe(a.id)} aria-label="Löschen" title="Löschen" className="ld-org-iconbtn" style={{ color: 'var(--ld-text-tertiary)' }}><MIcon name="close" size={16} /></button>
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          )}
        </>
      )}

      {/* ── Modal: Ausgabe hinzufügen ── */}
      <LdSheet open={ausgabeModal} onClose={() => setAusgabeModal(false)} maxWidth={440} title="Ausgabe hinzufügen">
        <div style={{ padding: '0 24px 24px' }}>
            {[
              { label: 'Datum', child: <LdDatum value={ausgabeDatum} onChange={e => setAusgabeDatum(e.target.value)} /> },
              { label: 'Beschreibung', child: <input value={ausgabeBeschr} onChange={e => setAusgabeBeschr(e.target.value)} placeholder="z.B. Busfahrt zur Burg" style={{ width: '100%', padding: '10px 12px', borderRadius: 10, border: '1.5px solid var(--ld-outline-soft)', fontSize: 14, outline: 'none', boxSizing: 'border-box' as const }} /> },
              { label: 'Betrag (€)', child: <input type="number" step="0.01" min="0" value={ausgabeBetrag} onChange={e => setAusgabeBetrag(e.target.value)} placeholder="z.B. 47.50" style={{ width: '100%', padding: '10px 12px', borderRadius: 10, border: '1.5px solid var(--ld-outline-soft)', fontSize: 14, outline: 'none', boxSizing: 'border-box' as const }} /> },
              { label: 'Kategorie', child: (
                <LdAuswahl value={ausgabeKat} onChange={e => setAusgabeKat(e.target.value)}>
                  {Object.entries(AUSGABEN_KAT_LABEL).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </LdAuswahl>
              )},
            ].map(({ label, child }) => (
              <div key={label} style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--ld-text-secondary)', letterSpacing: .4, display: 'block', marginBottom: 5 }}>{label}</label>
                {child}
              </div>
            ))}
            <div style={{ display: 'flex', gap: 10, marginTop: 6 }}>
              <Button variant="secondary" onClick={() => setAusgabeModal(false)} style={{ flex: 1 }}>Abbrechen</Button>
              <Button variant="primary" onClick={speichereAusgabe} loading={ausgabeSpeichern} disabled={ausgabeSpeichern || !ausgabeBeschr.trim() || !ausgabeBetrag} style={{ flex: 2 }}>Speichern</Button>
            </div>
        </div>
      </LdSheet>

      {/* ── Modal: Elternbeirat ── */}
      <LdSheet open={ebModal} onClose={() => setEbModal(false)} maxWidth={460} title={ebEdit ? 'Mitglied bearbeiten' : 'Mitglied hinzufügen'}>
        <div style={{ padding: '0 24px 24px' }}>
            {(() => {
              const fld = (label: string, icon: string, value: string, set: (v: string) => void, type = 'text') => (
                <div style={{ flex: 1, minWidth: 0 }}>
                  <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--ld-text-secondary)', letterSpacing: .4, display: 'flex', alignItems: 'center', gap: 5, marginBottom: 6 }}><MIcon name={icon} size={13} />{label}</label>
                  <input type={type} value={value} onChange={e => set(e.target.value)} style={{ width: '100%', padding: '11px 13px', borderRadius: 'var(--ld-radius-md)', border: '1.5px solid var(--ld-field-border)', fontSize: 15, outline: 'none', boxSizing: 'border-box' as const, background: 'var(--ld-bg-card)', color: 'var(--ld-text-primary)' }} />
                </div>
              );
              return (
                <>
                  <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
                    {fld('Vorname', 'person', ebVorname, setEbVorname)}
                    {fld('Nachname', 'badge', ebNachname, setEbNachname)}
                  </div>
                  <div style={{ marginBottom: 14 }}>{fld('E-Mail', 'mail', ebEmail, setEbEmail, 'email')}</div>
                  <div style={{ marginBottom: 14 }}>{fld('Telefon (optional)', 'call', ebTelefon, setEbTelefon, 'tel')}</div>
                </>
              );
            })()}
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--ld-text-secondary)', letterSpacing: .4, display: 'flex', alignItems: 'center', gap: 5, marginBottom: 6 }}><MIcon name="star" size={13} />Rolle</label>
              <LdAuswahl value={ebRolle} onChange={e => setEbRolle(e.target.value)}>
                {Object.entries(ROLLENLABEL).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </LdAuswahl>
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--ld-text-secondary)', letterSpacing: .4, display: 'block', marginBottom: 6 }}>Notizen (optional)</label>
              <textarea value={ebNotizen} onChange={e => setEbNotizen(e.target.value)} rows={3} style={{ width: '100%', padding: '11px 13px', borderRadius: 'var(--ld-radius-md)', border: '1.5px solid var(--ld-outline-soft)', fontSize: 15, outline: 'none', resize: 'none', boxSizing: 'border-box' as const }} />
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <Button variant="secondary" onClick={() => setEbModal(false)} style={{ flex: 1 }}>Abbrechen</Button>
              <Button variant="primary" onClick={speichereEb} loading={ebSpeichern} disabled={ebSpeichern || !ebVorname.trim() || !ebNachname.trim() || !ebEmail.trim()} style={{ flex: 2 }}>Speichern</Button>
            </div>
        </div>
      </LdSheet>

      {/* ── Modal: Aktion ── */}
      <LdSheet open={akModal} onClose={() => setAkModal(false)} maxWidth={460} title={akEdit ? 'Aktion bearbeiten' : 'Neue Aktion'}>
        <div style={{ padding: '0 24px 24px' }}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--ld-text-secondary)', letterSpacing: .4, display: 'block', marginBottom: 6 }}>Titel</label>
              <input value={akTitel} onChange={e => setAkTitel(e.target.value)} style={{ width: '100%', padding: '11px 13px', borderRadius: 'var(--ld-radius-md)', border: '1.5px solid var(--ld-outline-soft)', fontSize: 15, outline: 'none', boxSizing: 'border-box' as const }} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--ld-text-secondary)', letterSpacing: .4, display: 'block', marginBottom: 6 }}>Kategorie</label>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {Object.entries(AKTIONSKATEGORIE_LABEL).map(([v, l]) => {
                  const aktiv = akKategorie === v;
                  const col = AKTIONSKATEGORIE_FARBE[v] ?? '#6B5FD4';
                  return (
                    <button key={v} type="button" onClick={() => setAkKategorie(v)} aria-pressed={aktiv} style={{
                      display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 12px', borderRadius: 'var(--ld-radius-pill)',
                      border: aktiv ? `1.5px solid ${col}` : '1.5px solid var(--ld-field-border)',
                      background: col + (aktiv ? '22' : '12'), color: col, fontSize: 12, fontWeight: aktiv ? 700 : 600, cursor: 'pointer',
                      boxShadow: aktiv ? `0 0 0 3px ${col}22` : 'none',
                    }}>
                      <MIcon name={AKTIONSKATEGORIE_ICON[v] ?? 'checklist'} size={14} />{l}
                    </button>
                  );
                })}
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--ld-text-secondary)', letterSpacing: .4, display: 'block', marginBottom: 6 }}>Fällig bis (optional)</label>
              <LdDatum value={akFaellig} onChange={e => setAkFaellig(e.target.value)} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--ld-text-secondary)', letterSpacing: .4, display: 'block', marginBottom: 6 }}>Beschreibung (optional)</label>
              <textarea value={akBeschreibung} onChange={e => setAkBeschreibung(e.target.value)} rows={3} style={{ width: '100%', padding: '11px 13px', borderRadius: 'var(--ld-radius-md)', border: '1.5px solid var(--ld-outline-soft)', fontSize: 15, outline: 'none', resize: 'none', boxSizing: 'border-box' as const }} />
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <Button variant="secondary" onClick={() => setAkModal(false)} style={{ flex: 1 }}>Abbrechen</Button>
              <Button variant="primary" onClick={speichereAk} loading={akSpeichern} disabled={akSpeichern || !akTitel.trim()} style={{ flex: 2 }}>Speichern</Button>
            </div>
        </div>
      </LdSheet>

      {/* ── Status-Detail-Modal ── */}
      {statusAktion && (
        <LdSheet open onClose={() => setStatusAktion(null)} maxWidth={500}
          kopf={{ titel: statusAktion.titel, kontext: `${statusAktion.erledigt_anzahl} von ${statusAktion.gesamt_anzahl} erledigt` }}>
          <div>
            {statusLaden ? <LoadingBlock text="Lade Status …" /> : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {statusListe.map(s => (
                  <div key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', borderRadius: 'var(--ld-radius-md)', background: s.erledigt ? '#F0FFF4' : '#F9F9FB', border: `1px solid ${s.erledigt ? '#86EFAC' : '#E5E5EA'}` }}>
                    <button onClick={() => toggleStatus(statusAktion.id, s.id, !s.erledigt)}
                      style={{ width: 28, height: 28, borderRadius: 'var(--ld-radius-sm)', border: `2px solid ${s.erledigt ? '#22C55E' : '#E5E5EA'}`, background: s.erledigt ? '#22C55E' : 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 14 }}>
                      {s.erledigt ? <MIcon name="check" size={16} /> : ''}
                    </button>
                    <span style={{ fontWeight: 600, fontSize: 14, color: 'var(--ld-text-primary)', flex: 1 }}>{s.vorname} {s.nachname}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </LdSheet>
      )}

      {/* ── Erinnerungs-Mail-Modal ── */}
      <LdSheet open={erinnerungModal} onClose={() => setErinnerungModal(false)} maxWidth={520} title="KI-Erinnerungsmail">
        <div style={{ padding: '0 24px 24px' }}>
            <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)', marginBottom: 12 }}>Vorschlag — zum Kopieren oder Anpassen:</div>
            <textarea value={erinnerungText} onChange={e => setErinnerungText(e.target.value)} rows={10}
              style={{ width: '100%', padding: '12px 14px', borderRadius: 'var(--ld-radius-md)', border: '1.5px solid var(--ld-outline-soft)', fontSize: 14, outline: 'none', resize: 'vertical', boxSizing: 'border-box' as const }} />
            <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
              <Button variant="secondary" onClick={() => setErinnerungModal(false)} style={{ flex: 1 }}>Schließen</Button>
              <Button variant="primary" onClick={() => { navigator.clipboard?.writeText(erinnerungText).catch(() => {}); setErinnerungModal(false); }} style={{ flex: 2 }}>In Zwischenablage kopieren</Button>
            </div>
        </div>
      </LdSheet>
    </div>
  );
}

// ── Auth Screens ────────────────────────────────────────────────────────────
const NUTZER_KEY = 'lehrerdesk_nutzer';

function ladeNutzer(): NutzerProfil | null {
  // Welle S8: bei kurzer Sitzung liegt das Profil wie das Token im sessionStorage
  try { return JSON.parse(sessionStorage.getItem(NUTZER_KEY) ?? localStorage.getItem(NUTZER_KEY) ?? 'null'); } catch { return null; }
}

function nutzerInitialen(n: NutzerProfil): string {
  return `${n.vorname[0] ?? '?'}${n.nachname[0] ?? '?'}`.toUpperCase();
}

function AuthHintergrund({ children }: { children: React.ReactNode }) {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #F6F2FC 0%, #F0ECF7 55%, #FCF8FF 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      padding: '24px 16px', position: 'relative', overflow: 'hidden',
    }}>
      {/* Dekorative Kreise */}
      <div style={{ position: 'absolute', top: -80,  left: -80,  width: 320, height: 320, borderRadius: '50%', background: 'rgba(107, 95, 212,0.06)',  pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -60, right: -60, width: 280, height: 280, borderRadius: '50%', background: 'rgba(219,39,119,0.05)',  pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', top: '40%', right: '10%', width: 160, height: 160, borderRadius: '50%', background: 'rgba(8,145,178,0.04)', pointerEvents: 'none' }} />
      {children}
    </div>
  );
}

function AuthKarte({ children }: { children: React.ReactNode }) {
  return (
    <div style={{
      background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)' as any, padding: '40px 44px',
      width: '100%', maxWidth: 440,
      boxShadow: 'var(--ld-shadow-lg)' as any,
      position: 'relative', zIndex: 1,
      animation: 'fadeSlideIn .35s ease',
    }}>
      {children}
    </div>
  );
}

function AuthLogo() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 32 }}>
      <div style={{
        width: 60, height: 60, borderRadius: 18,
        background: 'var(--ld-primary)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 8px 24px rgba(107, 95, 212,0.35)',
        marginBottom: 14,
      }}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <rect x="2" y="3" width="20" height="14" rx="2" stroke="white" strokeWidth="2"/>
          <path d="M8 21h8M12 17v4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </div>
      <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--ld-text-primary)', letterSpacing: -0.3 }}>LehrerDesk</div>
      <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)', marginTop: 2 }}>Hessen · Schuljahr 2025/26</div>
    </div>
  );
}

function LoginScreen({ onLogin, onZurRegistrierung }: {
  onLogin: (token: string, nutzer: NutzerProfil, angemeldetBleiben: boolean) => void;
  onZurRegistrierung: () => void;
}) {
  const [email,             setEmail]             = useState('');
  const [passwort,          setPasswort]          = useState('');
  // Welle S8: vorausgewählt nur in der installierten App am Handy, im Browser nicht
  const [angemeldetBleiben, setAngemeldetBleiben] = useState(istInstallierteApp);
  const [fehler,            setFehler]            = useState('');
  const [laden,             setLaden]             = useState(false);
  const [pwSichtbar,        setPwSichtbar]        = useState(false);

  async function absenden(e: React.FormEvent) {
    e.preventDefault();
    if (!email.includes('@')) { setFehler('Bitte eine gültige E-Mail-Adresse eingeben.'); return; }
    if (passwort.length < 1)  { setFehler('Bitte ein Passwort eingeben.'); return; }
    setFehler('');
    setLaden(true);
    try {
      const res  = await fetch(`${API_BASE}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, passwort, angemeldet_bleiben: angemeldetBleiben }),
      });
      const data = await res.json();
      if (!res.ok) { setFehler(data.fehler ?? 'Anmeldung fehlgeschlagen.'); return; }
      onLogin(data.token, data.nutzer as NutzerProfil, angemeldetBleiben);
    } catch {
      setFehler('Verbindung zum Server fehlgeschlagen. Läuft das Backend?');
    } finally {
      setLaden(false);
    }
  }

  const trustZeilen = [
    'Server in Deutschland',
    'Export und Löschung jederzeit',
    'KI schlägt vor – Lehrkraft bestätigt',
  ];

  return (
    <AuthHintergrund>
      {/* Login-spezifisches Styling — scoped via .ld-login-*, lässt RegistrierungScreen
          (teilt AuthHintergrund/AuthKarte) unberührt. Responsiv rein über @media(1024). */}
      <style>{`
        @keyframes fadeSlideIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes spin { to { transform: rotate(360deg); } }
        .ld-login-card {
          position: relative; z-index: 1; width: 100%; max-width: 440px;
          background: var(--ld-bg-card); border-radius: var(--ld-radius-xl);
          box-shadow: var(--ld-shadow-lg); overflow: hidden;
          display: flex; flex-direction: column;
          animation: fadeSlideIn .35s ease;
        }
        /* Marken-Panel nur Desktop */
        .ld-login-brand { display: none; }
        .ld-login-form { padding: 40px 36px; }
        .ld-login-label {
          display: block; margin-bottom: 7px;
          font-size: 12px; font-weight: 700; letter-spacing: .5px; color: var(--ld-text-secondary);
        }
        .ld-login-input {
          width: 100%; box-sizing: border-box; min-height: 44px; padding: 12px 14px;
          font-size: 15px; font-family: inherit; color: var(--ld-text-primary);
          background: var(--ld-bg-input); border: 1px solid var(--ld-border);
          border-radius: var(--ld-radius-md); outline: none;
          transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
        }
        .ld-login-input::placeholder { color: var(--ld-text-tertiary); }
        .ld-login-input:focus-visible, .ld-login-input:focus {
          border-color: var(--ld-border-focus); background: var(--ld-bg-input-focus);
          box-shadow: 0 0 0 3px rgba(107, 95, 212, .18);
        }
        .ld-login-card button:focus-visible {
          outline: 2px solid var(--ld-border-focus); outline-offset: 2px;
        }
        .ld-login-trust { display: flex; align-items: center; gap: 12px; font-size: 14px; color: rgba(255,255,255,.92); }
        .ld-login-trust-dot {
          width: 26px; height: 26px; border-radius: 50%; flex-shrink: 0;
          background: rgba(255,255,255,.18); display: flex; align-items: center; justify-content: center;
        }
        @media (min-width: 1024px) {
          .ld-login-card { max-width: 940px; flex-direction: row; align-items: stretch; }
          .ld-login-brand {
            flex: 1 1 0; min-width: 0; display: flex; flex-direction: column;
            padding: 48px 44px; color: #fff;
            background: linear-gradient(135deg, #6B5FD4, #4A3FB0);
          }
          .ld-login-form { flex: 1 1 0; min-width: 0; padding: 56px 56px; }
          .ld-login-mobilebrand { display: none; }
        }
        @media (prefers-reduced-motion: reduce) {
          .ld-login-card { animation: none; }
          .ld-login-input { transition: none; }
        }
      `}</style>

      <div className="ld-login-card">

        {/* ── Marken-Panel (Desktop ≥1024px) ── */}
        <div className="ld-login-brand">
          <div style={{
            width: 56, height: 56, borderRadius: 16, background: 'rgba(255,255,255,.16)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16,
          }}>
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="3" width="20" height="14" rx="2" stroke="white" strokeWidth="2"/>
              <path d="M8 21h8M12 17v4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <div style={{ fontSize: 26, fontWeight: 800, letterSpacing: -0.3 }}>LehrerDesk</div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,.75)', marginTop: 4 }}>Hessen · Schuljahr 2025/26</div>

          <div style={{ flex: 1, minHeight: 28 }} />

          <div style={{ fontSize: 22, fontWeight: 700, lineHeight: 1.3, marginBottom: 24 }}>
            Weniger Verwaltung.<br />Mehr Zeit für Unterricht.
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {trustZeilen.map(z => (
              <div key={z} className="ld-login-trust">
                <span className="ld-login-trust-dot"><MIcon name="check" size={16} color="#fff" /></span>
                {z}
              </div>
            ))}
          </div>
        </div>

        {/* ── Formular ── */}
        <div className="ld-login-form">
          {/* Marke nur mobil (Panel ausgeblendet) */}
          <div className="ld-login-mobilebrand" style={{ flexDirection: 'column', alignItems: 'center', marginBottom: 28 }}>
            <div style={{
              width: 56, height: 56, borderRadius: 16, background: 'var(--ld-primary)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12,
              boxShadow: '0 8px 24px rgba(107, 95, 212,0.35)',
            }}>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                <rect x="2" y="3" width="20" height="14" rx="2" stroke="white" strokeWidth="2"/>
                <path d="M8 21h8M12 17v4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <div style={{ fontSize: 20, fontWeight: 800, color: 'var(--ld-text-primary)', letterSpacing: -0.3 }}>LehrerDesk</div>
          </div>

          <h2 style={{ margin: '0 0 4px', fontSize: 26, fontWeight: 800, color: 'var(--ld-text-primary)' }}>
            Willkommen zurück
          </h2>
          <p style={{ margin: '0 0 28px', fontSize: 14, color: 'var(--ld-text-secondary)' }}>
            Melden Sie sich bei Ihrem Konto an.
          </p>

          <form onSubmit={absenden}>
            {/* E-Mail */}
            <div style={{ marginBottom: 16 }}>
              <label className="ld-login-label">E-Mail-Adresse</label>
              <input
                type="email" className="ld-login-input" placeholder="name@schule.de"
                value={email} onChange={e => setEmail(e.target.value)}
              />
            </div>

            {/* Passwort */}
            <div style={{ marginBottom: 10 }}>
              <label className="ld-login-label">Passwort</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={pwSichtbar ? 'text' : 'password'} className="ld-login-input" style={{ paddingRight: 48 }}
                  placeholder="••••••••"
                  value={passwort} onChange={e => setPasswort(e.target.value)}
                />
                <button type="button" onClick={() => setPwSichtbar(v => !v)}
                  aria-label={pwSichtbar ? 'Passwort verbergen' : 'Passwort anzeigen'}
                  style={{
                    position: 'absolute', right: 4, top: '50%', transform: 'translateY(-50%)',
                    width: 44, height: 44, background: 'none', border: 'none', cursor: 'pointer',
                    color: 'var(--ld-text-secondary)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    borderRadius: 'var(--ld-radius-sm)',
                  }}>
                  <MIcon name={pwSichtbar ? 'visibility_off' : 'visibility'} size={20} />
                </button>
              </div>
            </div>

            {/* Angemeldet bleiben + Passwort vergessen */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 20 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14, color: 'var(--ld-text-secondary)' }}>
                <input
                  type="checkbox" checked={angemeldetBleiben}
                  onChange={e => setAngemeldetBleiben(e.target.checked)}
                  style={{ width: 16, height: 16, accentColor: '#6B5FD4', cursor: 'pointer', flexShrink: 0 }}
                />
                <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3 }}>
                  Angemeldet bleiben
                  <small style={{ fontSize: 12, color: 'var(--ld-text-tertiary)' }}>Nur auf deinem eigenen Gerät</small>
                </span>
              </label>
              <button type="button" style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: 'var(--ld-primary)', fontSize: 13, fontWeight: 600,
              }}>
                Passwort vergessen?
              </button>
            </div>

            {/* Fehler */}
            {fehler && (
              <div style={{
                background: 'var(--ld-danger-soft)', border: 'none', borderRadius: 'var(--ld-radius-md)',
                padding: '10px 14px', marginBottom: 16, fontSize: 13, color: 'var(--ld-danger-text)',
              }}>{fehler}</div>
            )}

            {/* Anmelden Button — Brand-Gradient */}
            <button type="submit" disabled={laden} style={{
              width: '100%', minHeight: 44, padding: '14px', borderRadius: 'var(--ld-radius-md)', border: 'none',
              background: 'linear-gradient(135deg, #6B5FD4, #4A3FB0)',
              color: 'white', fontSize: 16, fontWeight: 700, cursor: laden ? 'default' : 'pointer',
              opacity: laden ? 0.85 : 1,
              boxShadow: laden ? 'none' : '0 6px 20px rgba(107, 95, 212,0.35)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
              transition: 'all .2s',
            }}>
              {laden && <span style={{ width: 18, height: 18, border: '2px solid white', borderTopColor: 'transparent', borderRadius: '50%', display: 'inline-block', animation: 'spin .6s linear infinite' }} />}
              {laden ? 'Wird angemeldet …' : 'Anmelden'}
            </button>
          </form>

          {/* Registrieren — dezenter Text-Link (einziger Registrieren-Hinweis) */}
          <div style={{ textAlign: 'center', marginTop: 24 }}>
            <span style={{ fontSize: 14, color: 'var(--ld-text-secondary)' }}>Noch kein Konto?{' '}</span>
            <button onClick={onZurRegistrierung} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: 'var(--ld-accent)', fontSize: 14, fontWeight: 700,
            }}>Jetzt registrieren</button>
          </div>
          <RechtsLinks style={{ marginTop: 20 }} />
        </div>

      </div>
    </AuthHintergrund>
  );
}

function RegistrierungScreen({ onRegistriert, onZurLogin }: {
  onRegistriert: (token: string, nutzer: NutzerProfil) => void;
  onZurLogin: () => void;
}) {
  const [vorname,    setVorname]    = useState('');
  const [nachname,   setNachname]   = useState('');
  const [email,      setEmail]      = useState('');
  const [passwort,   setPasswort]   = useState('');
  const [schule,     setSchule]     = useState('');
  const [klasse,     setKlasse]     = useState('');
  const [bundesland, setBundesland] = useState('Hessen');
  const [fehler,     setFehler]     = useState('');
  const [laden,      setLaden]      = useState(false);
  const [pwSichtbar, setPwSichtbar] = useState(false);
  const [einwDatenschutz, setEinwDatenschutz] = useState(false);
  const [einwKi,          setEinwKi]          = useState(false);
  const [dseModalOffen,   setDseModalOffen]   = useState(false);

  const inputStyle: React.CSSProperties = {
    width: '100%', padding: '12px 14px', borderRadius: 'var(--ld-radius-md)' as any,
    border: 'none', fontSize: 15, outline: 'none',
    fontFamily: 'inherit', boxSizing: 'border-box', color: 'var(--ld-text-primary)' as any,
    background: 'var(--ld-bg-input)' as any,
  };
  const labelStyle: React.CSSProperties = {
    fontSize: 12, fontWeight: 700, color: 'var(--ld-text-secondary)' as any, letterSpacing: 0.5,
    marginBottom: 7, display: 'block',
  };

  async function absenden(e: React.FormEvent) {
    e.preventDefault();
    if (!vorname.trim())        { setFehler('Bitte Ihren Vornamen eingeben.');             return; }
    if (!nachname.trim())       { setFehler('Bitte Ihren Nachnamen eingeben.');            return; }
    if (!email.includes('@'))   { setFehler('Bitte eine gültige E-Mail eingeben.');        return; }
    if (passwort.length < 8)    { setFehler('Passwort muss mindestens 8 Zeichen haben.');  return; }
    if (!schule.trim())         { setFehler('Bitte den Namen Ihrer Schule eingeben.');      return; }
    if (!einwDatenschutz)       { setFehler('Bitte die Einwilligung zur Datenverarbeitung bestätigen.'); return; }
    setFehler('');
    setLaden(true);
    try {
      const res  = await fetch(`${API_BASE}/api/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ vorname, nachname, email, passwort, schule, klasse, bundesland, einwilligung_datenschutz: einwDatenschutz, einwilligung_ki: einwKi }),
      });
      const data = await res.json();
      if (!res.ok) { setFehler(data.fehler ?? 'Registrierung fehlgeschlagen.'); return; }
      onRegistriert(data.token, data.nutzer as NutzerProfil);
    } catch {
      setFehler('Verbindung zum Server fehlgeschlagen. Läuft das Backend?');
    } finally {
      setLaden(false);
    }
  }

  const focusStyle = (_e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => {};
  const blurStyle  = (_e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => {};

  return (
    <AuthHintergrund>
      <AuthKarte>
        <AuthLogo />

        <h2 style={{ margin: '0 0 4px', fontSize: 22, fontWeight: 800, color: 'var(--ld-text-primary)', textAlign: 'center' }}>
          Konto erstellen
        </h2>
        <p style={{ margin: '0 0 26px', fontSize: 14, color: 'var(--ld-text-secondary)', textAlign: 'center' }}>
          Kostenlos registrieren — dauert nur 1 Minute.
        </p>

        <form onSubmit={absenden}>
          {/* Vorname + Nachname nebeneinander */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 14 }}>
            <div>
              <label style={labelStyle}>Vorname</label>
              <input style={inputStyle} placeholder="Anna"
                value={vorname} onChange={e => setVorname(e.target.value)}
                onFocus={focusStyle} onBlur={blurStyle} />
            </div>
            <div>
              <label style={labelStyle}>Nachname</label>
              <input style={inputStyle} placeholder="Müller"
                value={nachname} onChange={e => setNachname(e.target.value)}
                onFocus={focusStyle} onBlur={blurStyle} />
            </div>
          </div>

          {/* E-Mail */}
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>E-Mail-Adresse</label>
            <input type="email" style={inputStyle} placeholder="name@schule.de"
              value={email} onChange={e => setEmail(e.target.value)}
              onFocus={focusStyle} onBlur={blurStyle} />
          </div>

          {/* Passwort */}
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Passwort</label>
            <div style={{ position: 'relative' }}>
              <input
                type={pwSichtbar ? 'text' : 'password'}
                style={{ ...inputStyle, paddingRight: 44 }}
                placeholder="Mind. 8 Zeichen"
                value={passwort} onChange={e => setPasswort(e.target.value)}
                onFocus={focusStyle} onBlur={blurStyle}
              />
              <button type="button" onClick={() => setPwSichtbar(v => !v)} style={{
                position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: 'none', cursor: 'pointer',
                fontSize: 16, color: 'var(--ld-text-secondary)', padding: 2,
              }} aria-label={pwSichtbar ? 'Passwort verbergen' : 'Passwort zeigen'}><MIcon name={pwSichtbar ? 'visibility_off' : 'visibility'} size={20} /></button>
            </div>
          </div>

          {/* Schule + Klasse nebeneinander */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 10, marginBottom: 14 }}>
            <div>
              <label style={labelStyle}>Schule</label>
              <input style={inputStyle} placeholder="z. B. IGS Wiesbaden"
                value={schule} onChange={e => setSchule(e.target.value)}
                onFocus={focusStyle} onBlur={blurStyle} />
            </div>
            <div>
              <label style={labelStyle}>Klasse</label>
              <input style={{ ...inputStyle, width: 72 }} placeholder="10b"
                value={klasse} onChange={e => setKlasse(e.target.value)}
                onFocus={focusStyle} onBlur={blurStyle} />
            </div>
          </div>

          {/* Bundesland */}
          <div style={{ marginBottom: 22 }}>
            <label style={labelStyle}>Bundesland</label>
            <LdAuswahl value={bundesland} onChange={e => setBundesland(e.target.value)}>
              {BUNDESLAENDER.map(b => <option key={b}>{b}</option>)}
            </LdAuswahl>
          </div>

          {/* Einwilligungs-Checkboxen */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 18 }}>
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer', fontSize: 13, color: 'var(--ld-text-primary)' }}>
              <input type="checkbox" checked={einwDatenschutz} onChange={e => setEinwDatenschutz(e.target.checked)} style={{ marginTop: 3, flexShrink: 0, accentColor: 'var(--ld-primary)' }} />
              <span>
                Ich willige in die Datenverarbeitung gemäß{' '}
                <button type="button" onClick={() => setDseModalOffen(true)} style={{ background: 'none', border: 'none', color: 'var(--ld-accent)', cursor: 'pointer', fontSize: 13, fontWeight: 600, padding: 0, textDecoration: 'underline' }}>
                  Datenschutzerklärung
                </button>{' '}
                ein. <span style={{ color: '#DC2626', fontWeight: 700 }}>*</span>
              </span>
            </label>
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer', fontSize: 13, color: 'var(--ld-text-secondary)' }}>
              <input type="checkbox" checked={einwKi} onChange={e => setEinwKi(e.target.checked)} style={{ marginTop: 3, flexShrink: 0, accentColor: 'var(--ld-primary)' }} />
              <span>Ich willige in die KI-Verarbeitung meiner Eingaben durch Anthropic (USA) und OpenAI (USA) ein, um KI-Features zu nutzen. Diese Einwilligung kann jederzeit widerrufen werden. (Optional)</span>
            </label>
          </div>

          {/* Fehler */}
          {fehler && (
            <div style={{
              background: 'var(--ld-danger-soft)', border: 'none', borderRadius: 'var(--ld-radius-md)',
              padding: '10px 14px', marginBottom: 16, fontSize: 13, color: 'var(--ld-danger-text)',
            }}>{fehler}</div>
          )}

          {/* Button */}
          <button type="submit" disabled={laden || !einwDatenschutz} style={{
            width: '100%', padding: '14px', borderRadius: 'var(--ld-radius-md)', border: 'none',
            background: laden ? 'var(--ld-primary-hover)' : 'var(--ld-primary)',
            color: 'white', fontSize: 16, fontWeight: 700, cursor: laden ? 'default' : 'pointer',
            boxShadow: laden ? 'none' : '0 6px 20px rgba(107, 95, 212,0.35)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
            transition: 'all .2s',
          }}>
            {laden && <span style={{ width: 18, height: 18, border: '2px solid white', borderTopColor: 'transparent', borderRadius: '50%', display: 'inline-block', animation: 'spin .6s linear infinite' }} />}
            {laden ? 'Konto wird erstellt …' : 'Konto erstellen'}
          </button>
        </form>

        {/* Trennlinie */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '24px 0' }}>
          <div style={{ flex: 1, height: 1, background: 'var(--ld-bg-input)' }} />
          <span style={{ fontSize: 12, color: 'var(--ld-text-secondary)', fontWeight: 500 }}>oder</span>
          <div style={{ flex: 1, height: 1, background: 'var(--ld-bg-input)' }} />
        </div>

        {/* Zurück zu Login */}
        <div style={{ textAlign: 'center' }}>
          <span style={{ fontSize: 14, color: 'var(--ld-text-secondary)' }}>Bereits ein Konto?{' '}</span>
          <button onClick={onZurLogin} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'var(--ld-accent)', fontSize: 14, fontWeight: 700,
          }}>Zum Login</button>
        </div>
        <RechtsLinks neuerTab style={{ marginTop: 18 }} />
      </AuthKarte>

      {/* Datenschutzerklärung Modal */}
      {/* Welle Z3: im K4-Rahmen, Text unverändert */}
      <LdSheet open={dseModalOffen} onClose={() => setDseModalOffen(false)} maxWidth={560} kopf={{ titel: 'Datenschutzerklärung' }}
        fuss={<button type="button" className="ld-fe-knopf ld-fe-knopf--haupt" onClick={() => setDseModalOffen(false)}>Verstanden</button>}>
        <DatenschutzerklaerungText />
      </LdSheet>
    </AuthHintergrund>
  );
}

// ── Mobile Header ──────────────────────────────────────────────────────────
function MobileHeader({ nutzer, konfig, onNav, onAbmelden, onSuche }: {
  nutzer: NutzerProfil | null;
  konfig: AppKonfig;
  onNav: (k: NavItem) => void;
  onAbmelden: () => void;
  onSuche?: () => void;
}) {
  const [offen, setOffen] = React.useState(false);
  const kuerzel = nutzer ? nutzerInitialen(nutzer)
    : (konfig.lehrer.kuerzel || konfig.lehrer.name.slice(0, 2).toUpperCase() || '?');

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 400,
      height: 56, background: 'var(--ld-bg-card)',
      borderBottom: '1px solid var(--ld-border-light)',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0 16px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{
          width: 32, height: 32, borderRadius: 10,
          background: 'var(--ld-primary)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>{icons.logo}</div>
        <span style={{ fontWeight: 'var(--ld-font-weight-bold)' as any, fontSize: 'var(--ld-font-size-sm)', color: 'var(--ld-text-primary)' }}>LehrerDesk</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {onSuche && (
          <button onClick={onSuche} aria-label="Suchen" title="Suchen" style={{
            width: 36, height: 36, borderRadius: '50%', background: 'var(--ld-bg-muted)',
            border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
            WebkitTapHighlightColor: 'transparent' as any,
          }}>
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#3C3C43" strokeWidth="2.2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </button>
        )}
      <div style={{ position: 'relative' }}>
        <button onClick={() => setOffen(o => !o)} className="ld-user-avatar" style={{
          width: 32, height: 32, borderRadius: '50%',
          background: 'var(--ld-primary)',
          border: 'none', cursor: 'pointer',
          color: 'white', fontSize: 12, fontWeight: 700,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          WebkitTapHighlightColor: 'transparent' as any,
        }}>{kuerzel}</button>

        {offen && (
          <>
            <div onClick={() => setOffen(false)} style={{
              position: 'fixed', inset: 0, zIndex: 399,
            }} />
            <div style={{
              position: 'absolute', top: 44, right: 0, zIndex: 401,
              background: 'white', borderRadius: 'var(--ld-radius-lg)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
              minWidth: 180, overflow: 'hidden',
              border: '1px solid rgba(0,0,0,0.06)',
            }}>
              <button onClick={() => { onNav('einstellungen'); setOffen(false); }} style={{
                width: '100%', textAlign: 'left', padding: '14px 18px',
                background: 'none', border: 'none', cursor: 'pointer',
                fontSize: 14, color: 'var(--ld-text-primary)',
                display: 'flex', alignItems: 'center', gap: 10,
                WebkitTapHighlightColor: 'transparent' as any,
              }}>
                {icons.einstellungen} Einstellungen
              </button>
              <div style={{ height: 1, background: '#F0F0F5' }} />
              <button onClick={() => { onAbmelden(); setOffen(false); }} style={{
                width: '100%', textAlign: 'left', padding: '14px 18px',
                background: 'none', border: 'none', cursor: 'pointer',
                fontSize: 14, color: '#FF6B6B',
                display: 'flex', alignItems: 'center', gap: 10,
                WebkitTapHighlightColor: 'transparent' as any,
              }}>
                <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                Abmelden
              </button>
            </div>
          </>
        )}
      </div>
      </div> {/* end search+avatar wrapper */}
    </div>
  );
}

// ── Stoffverteilungsplan ──────────────────────────────────────────────────────
interface StoffplanEintrag { id: number; position: number; woche_start: string | null; thema: string; stunden: number; notizen: string | null; abgeschlossen: number; }
interface Stoffplan { id: number; klasse_id: number; klasse_name: string; fach: string; schuljahr: string; stunden_pro_woche: number; gesamt: number; erledigt: number; eintraege?: StoffplanEintrag[]; }

function StoffplanAnsicht() {
  const [plaene, setPlaene] = useState<Stoffplan[]>([]);
  const [laden, setLaden] = useState(false);
  const [detailPlan, setDetailPlan] = useState<Stoffplan | null>(null);
  const [neuesPlanModal, setNeuesPlanModal] = useState(false);
  const [neuesEintragModal, setNeuesEintragModal] = useState(false);
  // Neuer Plan Felder
  const [npKlasseId, setNpKlasseId] = useState('');
  const [npFach, setNpFach] = useState('');
  const [npSchuljahr, setNpSchuljahr] = useState(`${new Date().getFullYear()}/${new Date().getFullYear() + 1}`);
  const [npStundenPW, setNpStundenPW] = useState(2);
  const [npSpeichert, setNpSpeichert] = useState(false);
  const [npKiLaden, setNpKiLaden] = useState(false);
  // Neuer Eintrag Felder
  const [neThema, setNeThema] = useState('');
  const [neStunden, setNeStunden] = useState(2);
  const [neWocheStart, setNeWocheStart] = useState('');
  const [neNotizen, setNeNotizen] = useState('');
  const [neSpeichert, setNeSpeichert] = useState(false);

  const [meineKlassen, setMeineKlassen] = useState<KlasseFachEintrag[]>([]);

  function ladePlaene() {
    setLaden(true);
    fetch(`${API_BASE}/api/stoffplan`, { headers: apiHeaders() })
      .then(leseFallback<Stoffplan[]>([], '/api/stoffplan')).then(setPlaene).catch(() => {}).finally(() => setLaden(false));
  }

  function ladeDetail(planId: number) {
    fetch(`${API_BASE}/api/stoffplan/${planId}`, { headers: apiHeaders() })
      .then(leseFallback<Stoffplan | null>(null, '/api/stoffplan/:id')).then(d => d && setDetailPlan(d)).catch(() => {});
  }

  useEffect(() => {
    ladePlaene();
    fetch(`${API_BASE}/api/meine-klassen`, { headers: apiHeaders() })
      .then(leseFallback<KlasseFachEintrag[]>([], '/api/meine-klassen')).then((data: KlasseFachEintrag[]) => setMeineKlassen(data)).catch(() => {});
  }, []);

  async function planAnlegen() {
    if (!npKlasseId || !npFach.trim()) return;
    setNpSpeichert(true);
    try {
      const d = await apiPost<any>('/api/stoffplan',
        { klasse_id: Number(npKlasseId), fach: npFach, schuljahr: npSchuljahr, stunden_pro_woche: npStundenPW });
      setNeuesPlanModal(false);
      ladePlaene();
      ladeDetail(d.id);
      toast('Plan angelegt');
    } catch (e) { zeigeApiFehler(e, 'Plan anlegen fehlgeschlagen'); } finally { setNpSpeichert(false); }
  }

  async function kiVorschlagHolen() {
    if (!npKlasseId || !npFach.trim()) { toast('Klasse und Fach angeben', 'error'); return; }
    setNpKiLaden(true);
    try {
      const klasse = meineKlassen.find(k => String(k.klasse_id) === npKlasseId);
      const d = await apiPost<any>('/api/stoffplan/vorschlag',
        { fach: npFach, schuljahr: npSchuljahr, stunden_pro_woche: npStundenPW, klasse_name: klasse?.klasse_name ?? npKlasseId });
      // Create plan first, then populate entries
      const { id: planId } = await apiPost<any>('/api/stoffplan',
        { klasse_id: Number(npKlasseId), fach: npFach, schuljahr: npSchuljahr, stunden_pro_woche: npStundenPW });
      const entries = d.eintraege ?? [];
      for (const e of entries) {
        await apiPost(`/api/stoffplan/${planId}/eintraege`,
          { thema: e.thema, stunden: e.stunden ?? npStundenPW, woche_start: e.woche_start ?? null, notizen: e.notizen ?? null });
      }
      setNeuesPlanModal(false);
      ladePlaene();
      ladeDetail(planId);
      toast(`Vorschlag mit ${entries.length} Einheiten erstellt`);
    } catch (e) { zeigeApiFehler(e, 'KI-Vorschlag fehlgeschlagen'); } finally { setNpKiLaden(false); }
  }

  async function eintragSpeichern() {
    if (!detailPlan || !neThema.trim()) return;
    setNeSpeichert(true);
    try {
      await apiPost(`/api/stoffplan/${detailPlan.id}/eintraege`,
        { thema: neThema, stunden: neStunden, woche_start: neWocheStart || null, notizen: neNotizen || null });
      ladeDetail(detailPlan.id); ladePlaene(); setNeuesEintragModal(false); setNeThema(''); setNeWocheStart(''); setNeNotizen(''); toast('Einheit hinzugefügt');
    } catch (e) { zeigeApiFehler(e, 'Einheit hinzufügen fehlgeschlagen'); } finally { setNeSpeichert(false); }
  }

  async function eintragPosition(id: number, richtung: 'up' | 'down') {
    if (!detailPlan) return;
    try { await apiPut(`/api/stoffplan/eintrag/${id}`, { richtung }); }
    catch (e) { zeigeApiFehler(e, 'Verschieben fehlgeschlagen'); }
    ladeDetail(detailPlan.id);
  }

  async function eintragAbgeschlossen(id: number, val: boolean) {
    if (!detailPlan) return;
    try {
      await apiPut(`/api/stoffplan/eintrag/${id}`, { abgeschlossen: val ? 1 : 0 });
    } catch (e) { zeigeApiFehler(e, 'Status ändern fehlgeschlagen'); return; }
    setDetailPlan(prev => prev ? { ...prev, eintraege: (prev.eintraege ?? []).map(e => e.id === id ? { ...e, abgeschlossen: val ? 1 : 0 } : e) } : prev);
    ladePlaene();
  }

  async function eintragLoeschen(id: number) {
    // TODO UX: durch custom Confirm-Modal ersetzen (einheitliches Styling statt Browser-native)
    if (!detailPlan || !(await confirm('Einheit löschen?', { danger: true, confirmLabel: 'Löschen' }))) return;
    try {
      await apiDelete(`/api/stoffplan-eintrag/${id}`);
      toast('Einheit gelöscht');
      ladeDetail(detailPlan.id); ladePlaene();
    } catch (e) {
      zeigeApiFehler(e, 'Einheit konnte nicht gelöscht werden');
    }
  }

  function mdExport() {
    if (!detailPlan?.eintraege) return;
    const lines = [
      `# Stoffverteilungsplan ${detailPlan.fach} – ${detailPlan.klasse_name} (${schuljahrKurz(detailPlan.schuljahr)})`,
      '',
      '| # | Woche | Thema | Stunden | Status |',
      '|---|-------|-------|---------|--------|',
      ...(detailPlan.eintraege ?? []).map((e, i) =>
        `| ${i + 1} | ${e.woche_start ?? '–'} | ${e.thema} | ${e.stunden} | ${e.abgeschlossen ? 'erledigt' : 'offen'} |`
      ),
    ];
    navigator.clipboard?.writeText(lines.join('\n'));
    toast('Als Markdown kopiert');
  }

  // Detail view
  if (detailPlan) {
    const eintraege = detailPlan.eintraege ?? [];
    const erledigt = eintraege.filter(e => e.abgeschlossen).length;
    const gesamt = eintraege.length;
    const pct = gesamt > 0 ? Math.round(erledigt / gesamt * 100) : 0;
    return (
      <div style={{ padding: '0 0 120px' }}>
        <button onClick={() => setDetailPlan(null)} style={{ background: 'var(--ld-bg-input)', border: 'none', cursor: 'pointer', color: 'var(--ld-accent)', fontSize: 14, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 20, padding: '8px 14px', borderRadius: 'var(--ld-radius-md)' }}>
          ← Alle Pläne
        </button>
        <div style={{ background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)' as any, padding: 22, boxShadow: 'var(--ld-shadow-md)', marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, marginBottom: 12 }}>
            <div>
              <div style={{ fontSize: 17, fontWeight: 700, color: 'var(--ld-text-primary)' }}>{detailPlan.fach} – {detailPlan.klasse_name}</div>
              <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)', marginTop: 2 }}>{schuljahrKurz(detailPlan.schuljahr)} · {detailPlan.stunden_pro_woche} Std./Woche</div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={mdExport} style={{ padding: '8px 14px', background: 'var(--ld-bg-input)', border: 'none', borderRadius: 10, fontSize: 12, fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 }}><MIcon name="content_copy" size={16} />Kopieren</button>
              <button onClick={() => setNeuesEintragModal(true)} style={{ padding: '8px 14px', background: 'var(--ld-primary)', color: 'white', border: 'none', borderRadius: 10, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>+ Einheit</button>
            </div>
          </div>
          {/* Progress */}
          <div style={{ marginBottom: 4, display: 'flex', justifyContent: 'space-between', fontSize: 12, color: 'var(--ld-text-secondary)' }}>
            <span>Fortschritt</span><span>{erledigt}/{gesamt} ({pct}%)</span>
          </div>
          <div style={{ height: 8, borderRadius: 4, background: '#E5E5EA', overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${pct}%`, background: pct === 100 ? 'var(--ld-success)' : 'var(--ld-primary)', borderRadius: 4, transition: 'width .5s ease' }} />
          </div>
        </div>

        {eintraege.length === 0 ? (
          <div style={{ textAlign: 'center', color: 'var(--ld-text-secondary)', padding: 40 }}>Noch keine Einheiten – füge die erste hinzu.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {eintraege.map((e, idx) => (
              <div key={e.id} style={{ background: 'var(--ld-bg-card)', borderRadius: 14, border: `1.5px solid ${e.abgeschlossen ? '#D1FAE5' : '#E5E5EA'}`, padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
                {/* Checkbox */}
                <div onClick={() => eintragAbgeschlossen(e.id, !e.abgeschlossen)} style={{ width: 22, height: 22, borderRadius: 6, border: `2px solid ${e.abgeschlossen ? 'var(--ld-success)' : 'var(--ld-text-tertiary)'}`, background: e.abgeschlossen ? 'var(--ld-success)' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0, transition: 'all .2s' }}>
                  {e.abgeschlossen ? <MIcon name="check" size={14} color="#fff" /> : null}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: e.abgeschlossen ? '#6B7280' : 'var(--ld-text-primary)', textDecoration: e.abgeschlossen ? 'line-through' : 'none' }}>{e.thema}</div>
                  <div style={{ fontSize: 11, color: 'var(--ld-text-tertiary)', marginTop: 2 }}>
                    {e.woche_start ? `Woche ${e.woche_start}` : `Einheit ${idx + 1}`} · {e.stunden} Std.
                    {e.notizen ? ` · ${e.notizen}` : ''}
                  </div>
                </div>
                {/* Up/Down */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2, flexShrink: 0 }}>
                  <button onClick={() => eintragPosition(e.id, 'up')} disabled={idx === 0} style={{ padding: '3px 7px', background: 'var(--ld-bg-input)', border: 'none', borderRadius: 6, fontSize: 11, cursor: idx === 0 ? 'default' : 'pointer', opacity: idx === 0 ? 0.3 : 1 }}>▲</button>
                  <button onClick={() => eintragPosition(e.id, 'down')} disabled={idx === eintraege.length - 1} style={{ padding: '3px 7px', background: 'var(--ld-bg-input)', border: 'none', borderRadius: 6, fontSize: 11, cursor: idx === eintraege.length - 1 ? 'default' : 'pointer', opacity: idx === eintraege.length - 1 ? 0.3 : 1 }}>▼</button>
                </div>
                <button onClick={() => eintragLoeschen(e.id)} style={{ padding: '5px 9px', background: '#FFF0EF', border: 'none', borderRadius: 'var(--ld-radius-sm)', cursor: 'pointer', color: '#DC2626', flexShrink: 0, display: 'inline-flex' }} aria-label="Einheit löschen"><MIcon name="delete" size={17} /></button>
              </div>
            ))}
          </div>
        )}

        {/* Neuer Eintrag — Welle Z3: K4-Rahmen */}
        <LdSheet open={neuesEintragModal} onClose={() => setNeuesEintragModal(false)} maxWidth={480}
          kopf={{ titel: 'Einheit hinzufügen', kontext: `${detailPlan.fach}, ${detailPlan.klasse_name}` }}
          fuss={<LdFensterFuss onAbbrechen={() => setNeuesEintragModal(false)} haupt="Speichern" onHaupt={eintragSpeichern} laden={neSpeichert} aus={!neThema.trim()} />}>
          <LdFeld label="Thema" htmlFor="ld-sv-thema">
            <LdEingabe id="ld-sv-thema" value={neThema} onChange={e => setNeThema(e.target.value)} placeholder="z. B. Pythagoras einführen" />
          </LdFeld>
          <LdFeldReihe>
            <LdFeld label="Stunden">
              <LdZahl aria-label="Stunden" value={neStunden} min={1} max={20} onChange={setNeStunden} />
            </LdFeld>
            <LdFeld label="Woche ab" optional>
              <LdDatum aria-label="Woche ab" value={neWocheStart} onChange={e => setNeWocheStart(e.target.value)} />
            </LdFeld>
          </LdFeldReihe>
          <LdFeld label="Notizen" optional htmlFor="ld-sv-notizen">
            <LdEingabe id="ld-sv-notizen" value={neNotizen} onChange={e => setNeNotizen(e.target.value)} placeholder="Materialien, Methoden" />
          </LdFeld>
        </LdSheet>
      </div>
    );
  }

  // List view
  return (
    <div style={{ padding: '0 0 120px' }}>
      {/* Welle K5: ein Kopf (Titel + Kontext); „Neuer Plan“ oben nur, wenn es schon Pläne gibt */}
      <div className="ld-sv-kopf">
        <div>
          <h1 className="ld-sv-kopf__titel">Stoffverteilung</h1>
          <p className="ld-sv-kopf__kontext">{plaene.length === 0 ? 'Jahresplan je Fach und Klasse' : `${plaene.length} ${plaene.length === 1 ? 'Plan' : 'Pläne'}`}</p>
        </div>
        {plaene.length > 0 && <button type="button" className="ld-kl-haupt" onClick={() => setNeuesPlanModal(true)}><MIcon name="add" size={19} />Neuer Plan</button>}
      </div>

      {laden ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--ld-text-secondary)' }}>Lädt …</div>
      ) : plaene.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)' as any, boxShadow: 'var(--ld-shadow-md)' }}>
          <div style={{ marginBottom: 12, color: 'var(--ld-primary)' }}><MIcon name="format_list_bulleted" size={34} /></div>
          <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--ld-text-primary)', marginBottom: 6 }}>Noch kein Stoffverteilungsplan</div>
          <div style={{ fontSize: 13, color: 'var(--ld-text-secondary)', marginBottom: 20 }}>Erstelle einen Plan für ein Fach – mit KI-Vorschlag in Sekunden.</div>
          <button onClick={() => setNeuesPlanModal(true)} style={{ padding: '12px 24px', background: 'var(--ld-primary)', color: 'white', border: 'none', borderRadius: 'var(--ld-radius-md)', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>Plan erstellen</button>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {plaene.map(p => {
            const pct = p.gesamt > 0 ? Math.round(p.erledigt / p.gesamt * 100) : 0;
            return (
              <div key={p.id} onClick={() => ladeDetail(p.id)} style={{ background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)' as any, padding: '18px 20px', boxShadow: 'var(--ld-shadow-md)', cursor: 'pointer' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--ld-text-primary)' }}>{p.fach}</div>
                    <div style={{ fontSize: 12, color: 'var(--ld-text-secondary)', marginTop: 2 }}>{p.klasse_name} · {schuljahrKurz(p.schuljahr)}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: pct === 100 ? 'var(--ld-success)' : 'var(--ld-primary)' }}>{pct}%</div>
                    <div style={{ fontSize: 11, color: 'var(--ld-text-tertiary)' }}>{p.erledigt}/{p.gesamt} Einh.</div>
                  </div>
                </div>
                <div style={{ height: 6, borderRadius: 3, background: '#E5E5EA', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: `${pct}%`, background: pct === 100 ? 'var(--ld-success)' : 'var(--ld-primary)', borderRadius: 3, transition: 'width .5s ease' }} />
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Neuer Plan — Welle Z3: K4-Rahmen; Hauptaktion KI-Vorschlag, leerer Plan als Link */}
      <LdSheet open={neuesPlanModal} onClose={() => setNeuesPlanModal(false)} maxWidth={540} kopf={{ titel: 'Neuer Stoffverteilungsplan' }}
        fuss={<LdFensterFuss onAbbrechen={() => setNeuesPlanModal(false)} haupt={npKiLaden ? 'KI erstellt Plan …' : 'Mit KI-Vorschlag erstellen'} onHaupt={kiVorschlagHolen}
          aus={npKiLaden || !npKlasseId || !npFach.trim()}
          links={<button type="button" className="ld-kl-link" onClick={planAnlegen} disabled={npSpeichert || !npKlasseId || !npFach.trim()}>{npSpeichert ? 'Erstellt …' : 'Leeren Plan anlegen'}</button>} />}>
        <LdFeld label="Klasse">
          <LdAuswahl aria-label="Klasse" value={npKlasseId} onChange={e => setNpKlasseId(e.target.value)} placeholder="Klasse wählen">
            {eindeutigeKlassen(meineKlassen).map(k => <option key={k.klasse_id} value={k.klasse_id}>{k.klasse_name}</option>)}
          </LdAuswahl>
        </LdFeld>
        <LdFeld label="Fach" htmlFor="ld-np-fach">
          <LdEingabe id="ld-np-fach" value={npFach} onChange={e => setNpFach(e.target.value)} placeholder="z. B. Mathematik, Deutsch" />
        </LdFeld>
        <LdFeldReihe>
          <LdFeld label="Schuljahr" htmlFor="ld-np-sj">
            <LdEingabe id="ld-np-sj" value={npSchuljahr} onChange={e => setNpSchuljahr(e.target.value)} placeholder="2025/2026" />
          </LdFeld>
          <LdFeld label="Stunden pro Woche">
            <LdZahl aria-label="Stunden pro Woche" value={npStundenPW} min={1} max={10} onChange={setNpStundenPW} />
          </LdFeld>
        </LdFeldReihe>
        <LdKiHinweis>Die KI erstellt einen vollständigen Jahresplan nach hessischem Kerncurriculum. Du prüfst ihn danach.</LdKiHinweis>
      </LdSheet>
    </div>
  );
}

// ── Bottom-Navigation (Mobile) ──────────────────────────────────────────────
function BottomNav({ active, onNav }: { active: NavItem; onNav: (k: NavItem) => void }) {
  const ungelesen = mails.filter(m => !m.gelesen).length;
  const [mehrOffen, setMehrOffen] = React.useState(false);

  const hauptItems: { key: NavItem; label: string; icon: React.ReactNode }[] = [
    { key: 'home',    label: 'Heute',    icon: <MIcon name="home" size={22} /> },
    { key: 'klasse',  label: 'Klasse',   icon: <MIcon name="group" size={22} /> },
    { key: 'meinTag', label: 'Mein Tag', icon: <MIcon name="event" size={22} /> },
    { key: 'mails',   label: 'Mails',    icon: <MIcon name="mail" size={22} /> },
  ];

  const mehrItems: { key: NavItem; label: string; icon: string }[] = [
    { key: 'klassenbuch',   label: 'Klassenbuch',     icon: 'menu_book' },
    { key: 'notizen',       label: 'Notizen',         icon: 'sticky_note_2' },   // Welle U4b
    { key: 'stoffplan',     label: 'Stoffverteilung', icon: 'format_list_bulleted' },
    { key: 'mitteilungen',  label: 'Sicherheit & Tipps', icon: 'shield' },
    { key: 'einstellungen', label: 'Einstellungen',      icon: 'settings' },
  ];

  const isMehrActive = mehrItems.some(i => i.key === active);

  return (
    <>
      {/* Mehr — Fenster im gemeinsamen Rahmen (Welle K5) */}
      <LdSheet open={mehrOffen} onClose={() => setMehrOffen(false)} maxWidth={480} kopf={{ titel: 'Weitere Bereiche' }}>
        <nav className="ld-mehr-liste" aria-label="Weitere Bereiche">
          {mehrItems.map(({ key, label, icon }) => (
            <button key={key} type="button" className={`ld-es-nav${active === key ? ' ist-an' : ''}`} aria-current={active === key ? 'page' : undefined}
              onClick={() => { onNav(key); setMehrOffen(false); }}>
              <span className="ld-es-nav__icon" aria-hidden="true"><MIcon name={icon} size={20} /></span>
              <span className="ld-es-nav__text"><b>{label}</b></span>
              <MIcon name="chevron_right" size={20} className="ld-es-nav__pfeil" />
            </button>
          ))}
        </nav>
        <RechtsLinks style={{ marginTop: 4 }} />
      </LdSheet>

      <nav className="ld-bottom-nav ld-bottom-nav--dock" style={{
        position: 'fixed',
        display: 'flex', justifyContent: 'space-around', alignItems: 'center',
        zIndex: 500,
      }}>
        {hauptItems.map(({ key, label, icon }) => {
          const isActive = active === key;
          return (
            <button key={key} onClick={() => { onNav(key); setMehrOffen(false); }}
              className="ld-bottom-nav__item"
              style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
              padding: '6px 12px', borderRadius: 'var(--ld-radius-pill)',
              background: 'transparent',
              border: 'none', cursor: 'pointer', minWidth: 56,
              color: isActive ? 'var(--ld-primary)' : 'var(--ld-text-tertiary)',
              transition: 'var(--ld-transition-fast)', position: 'relative',
              WebkitTapHighlightColor: 'transparent' as any,
            }}>
              <span style={{ display: 'flex', lineHeight: 1 }}>{icon}</span>
              <span style={{ fontSize: 11, fontWeight: isActive ? 600 : 400, lineHeight: 1 }}>{label}</span>
              {key === 'mails' && ungelesen > 0 && (
                <span style={{ position: 'absolute', top: 2, right: 6, background: 'var(--ld-accent)', color: 'white', borderRadius: 'var(--ld-radius-pill)', fontSize: 10, padding: '1px 5px', fontWeight: 700, lineHeight: 1.4 }}>{ungelesen}</span>
              )}
            </button>
          );
        })}
        {/* Mehr-Button */}
        <button onClick={() => setMehrOffen(o => !o)}
          className="ld-bottom-nav__item"
          style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
          padding: '6px 12px', borderRadius: 'var(--ld-radius-pill)',
          background: 'transparent',
          border: 'none', cursor: 'pointer', minWidth: 56,
          color: (isMehrActive || mehrOffen) ? 'var(--ld-primary)' : 'var(--ld-text-tertiary)',
          transition: 'var(--ld-transition-fast)',
          WebkitTapHighlightColor: 'transparent' as any,
        }}>
          <span style={{ display: 'flex', lineHeight: 1 }}><MIcon name="more_horiz" size={22} /></span>
          <span style={{ fontSize: 11, fontWeight: (isMehrActive || mehrOffen) ? 600 : 400, lineHeight: 1 }}>Mehr</span>
        </button>
      </nav>
    </>
  );
}

// Welle U6b: Treffer der globalen Suche — Zusatzfelder öffnen den Eintrag direkt
type SuchTreffer = {
  typ: string; titel: string; untertitel: string; id: string;
  datum?: string; stunde?: number; klasse_id?: number | null; kategorie?: string;
  schueler_id?: number; archiviert?: boolean;
};

// Welle B1: Schulrecht ist aus dem Menü genommen (Code und Daten bleiben ein Quartal).
// Wer den Bildschirm noch über einen alten Verlaufseintrag aufruft, landet auf Heute.
const ENTFERNTE_BILDSCHIRME: NavItem[] = ['schulrecht'];
function ohneEntfernte(screen: NavItem): NavItem {
  return ENTFERNTE_BILDSCHIRME.includes(screen) ? 'home' : screen;
}

// ── Haupt-App ──────────────────────────────────────────────────────────────
function LehrkraftApp() {
  const isMobile = useIsMobile();
  const [aktiv, setAktiv] = useState<NavItem>('home');
  const aktuellesModalRef = useRef<string | null>(null);
  const [uebergangHard, setUebergangHard] = useState<{ naechstes_sj: string } | null>(null);
  const [ausflugDetailId, setAusflugDetailId] = useState<number | null>(null);
  const [ausflugHerkunft, setAusflugHerkunft] = useState<NavItem | ProfilHerkunft>('kalender'); // U5: Ziel von "← Zurück" (U6b: auch Profil)

  // Navigiert zu einem Screen und schreibt einen History-Eintrag (Zurück-Taste)
  // Welle U6b: aus dem offenen Such-Overlay wird dessen History-Eintrag durch das Ziel ERSETZT
  // (wie U2 beim Schüler-Sprung) — so führt Zurück nicht wieder in die Suche.
  // Welle Z2: aus einer offenen Bereich-Seite des Schülerprofils ebenso — sonst bliebe deren Eintrag
  // im Verlauf liegen und ein späteres Zurück liefe ins Leere.
  const navigiere = useCallback((ziel: NavItem, extra: Record<string, unknown> = {}) => {
    const neuerScreen = ohneEntfernte(ziel);
    const ersetzen = window.history.state?.ldModal === 'suche' || !!window.history.state?.ldBereich;
    window.history[ersetzen ? 'replaceState' : 'pushState'](
      { ldScreen: neuerScreen, ldExtra: extra, ts: Date.now() },
      '',
      window.location.pathname
    );
    setAktiv(neuerScreen);
  // setAktiv ist stabil (useState-Setter)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Service Worker registrieren
  React.useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').then(reg => {
        setInterval(() => reg.update().catch(() => {}), 30 * 60 * 1000);
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated' && navigator.serviceWorker.controller) {
              console.warn('[SW] Neue Version aktiviert, lade neu...');
              window.location.reload();
            }
          });
        });
      }).catch(() => {});
    }
    // Push-NAV Nachrichten vom SW verarbeiten
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (e) => {
        // Welle B1: derselbe Auflöser wie beim Kaltstart (pushZielOeffnen)
        if (e.data?.type === 'PUSH_NAV' && e.data.url) pushZielRef.current?.(String(e.data.url));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only listener setup; navigiere stable after init
  }, []);

  // Erster History-Eintrag: damit popstate immer einen ldScreen-State vorfindet
  // Welle B1: ein Push-Link als Startadresse (Kaltstart) wird gemerkt und durch / ersetzt
  const startLinkRef = useRef<string | null>(
    istPushStart(window.location.pathname, window.location.search) ? window.location.pathname + window.location.search : null);
  useEffect(() => {
    // Welle B2: nur die Push-Parameter entfernen — ?gmail=… liest der OAuth-Effekt danach noch
    window.history.replaceState({ ldScreen: 'home' }, '', startLinkRef.current
      ? ohnePushParameter(window.location.pathname, window.location.search)
      : window.location.pathname + window.location.search);
  }, []);

  // Offline-Queue: Sync-Listener einmalig registrieren
  useEffect(() => { registerSyncListener(); }, []);

  // OAuth Callbacks: ?gmail=connected / ?gmail=error / ?outlook=connected → Toast + URL bereinigen
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('gmail') === 'connected') {
      window.history.replaceState({}, '', window.location.pathname);
      navigiere('mails');
      setTimeout(() => toast('Gmail verbunden', 'success'), 600);
    } else if (params.get('gmail') === 'error') {
      window.history.replaceState({}, '', window.location.pathname);
      navigiere('einstellungen');
      const grund = params.get('grund');
      const nachricht = grund
        ? `Gmail-Verbindung fehlgeschlagen: ${grund}`
        : 'Gmail-Verbindung fehlgeschlagen. Bitte erneut versuchen.';
      setTimeout(() => toast(nachricht, 'error'), 600);
    } else if (params.get('outlook') === 'connected') {
      window.history.replaceState({}, '', window.location.pathname);
      setTimeout(() => toast('Outlook verbunden', 'success'), 600);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only URL-param check; navigiere stable after init
  }, []);
  const [konfig, setKonfig] = useState<AppKonfig>(() => ladeKonfig() ?? DEFAULT_KONFIG);
  const [onboarding, setOnboarding] = useState(false);
  const [showSplash, setShowSplash] = useState(() => isStandalone());


  const [showIosBanner, setShowIosBanner] = useState(
    () => isIosSafari() && !isStandalone() && !localStorage.getItem('ios-banner-dismissed')
  );
  const [authScreen, setAuthScreen] = useState<'login' | 'registrierung'>('login');
  const [eingeloggt,  setEingeloggt]  = useState<boolean>(
    () => !!holeToken()
  );
  // Welle D3b: gespeichertes Profil schon beim App-Start registrieren (vorher nur beim Login)
  const [nutzer, setNutzer] = useState<NutzerProfil | null>(() => { const n = ladeNutzer(); registerAktuellerNutzer(n); return n; });

  // ── Zentrale Klassen-Quelle ────────────────────────────────────────────────
  // Sync Backend → konfig.klassen → Sidebar-Dropdown immer aktuell.
  const reloadMeineKlassen = useCallback(async () => {
    try {
      const data: KlasseFachEintrag[] = await fetch(
        `${API_BASE}/api/meine-klassen`, { headers: apiHeaders() }
      ).then(leseFallback<KlasseFachEintrag[]>([], '/api/meine-klassen'));
      const seen = new Map<number, KlasseFachEintrag>();
      for (const k of data) {
        if (!seen.has(k.klasse_id)) seen.set(k.klasse_id, k);
      }
      const neuKlassen: KlasseKonfig[] = Array.from(seen.values()).map(k => ({
        id:          String(k.klasse_id),
        bezeichnung: k.klasse_name,
        schuljahr:   k.schuljahr,
        rolle:       (k.rolle === 'klassenleiter' ? 'Klassenlehrer' : 'Fachlehrer') as Lehrerrolle,
        schueler:    [],
      }));
      setKonfig(prev => {
        const aktiveGueltig = neuKlassen.some(k => k.id === prev.aktiveKlasseId);
        const updated: AppKonfig = {
          ...prev,
          klassen:        neuKlassen,
          aktiveKlasseId: aktiveGueltig ? prev.aktiveKlasseId : (neuKlassen[0]?.id ?? ''),
        };
        speichereKonfig(updated);
        return updated;
      });
    } catch {}
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Nach Login sofort laden; nach Onboarding ebenfalls.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (eingeloggt) reloadMeineKlassen(); }, [eingeloggt]);

  // Hard-Cutoff-Check: ab 01.08. wenn kein abgeschlossener Übergang
  useEffect(() => {
    if (!eingeloggt) { setUebergangHard(null); return; }
    const check = () => {
      fetch(`${API_BASE}/api/uebergang/status`, { headers: apiHeaders() })
        .then(leseFallback<any>(null, '/api/uebergang/status'))
        .then(d => {
          if (d?.trigger_status === 'hard') {
            setUebergangHard({ naechstes_sj: d.naechstes_schuljahr });
          } else {
            setUebergangHard(null);
          }
        })
        .catch(() => {});
    };
    check();
    const t = setInterval(check, 5 * 60 * 1000);
    return () => clearInterval(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eingeloggt]);

  // Klassen-Reload-Event aus KlasseEinrichtenModal (Upload-Flow)
  useEffect(() => {
    const handler = () => reloadMeineKlassen();
    window.addEventListener('lehrerdesk-klassen-reload', handler);
    return () => window.removeEventListener('lehrerdesk-klassen-reload', handler);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Beim ersten Laden: Onboarding zeigen wenn nicht abgeschlossen
  // WICHTIG: Nur wenn onboardingAbgeschlossen === false zeigen — NICHT bei leerem API-Ergebnis,
  // da das nach Refresh / Netzwerkproblemen fälschlicherweise Onboarding auslösen würde.
  // Welle S8: Abmelden räumt den Browser-Speicher auf (auch diese Einstellung). Hat die Lehrkraft
  // auf dem Server schon Klassen, gilt das Onboarding als erledigt — sonst käme es nach jedem
  // Abmelden wieder. Nur ein bestätigtes Ergebnis zählt; bei Netzfehlern bleibt es beim Onboarding.
  useEffect(() => {
    if (!eingeloggt || konfig.onboardingAbgeschlossen) return;
    let ab = false;
    apiGet<unknown[]>('/api/meine-klassen')
      .then(liste => {
        if (ab) return;
        if (Array.isArray(liste) && liste.length > 0) konfigAktualisieren({ ...konfig, onboardingAbgeschlossen: true });
        else setOnboarding(true);
      })
      .catch(() => { if (!ab) setOnboarding(true); });
    return () => { ab = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eingeloggt]);

  // Globale Navigation für cross-component Bridges (z.B. Elternmail aus Schülerprofil)
  useEffect(() => {
    registerNav(navigiere);
    registerAusflugOpener((id, herkunft) => {
      setAusflugDetailId(id);
      if (herkunft !== 'behalten') setAusflugHerkunft(herkunft ?? 'kalender');
      if (istProfilHerkunft(herkunft)) merkeProfilHerkunft(herkunft); // U6b: auch Geräte-Zurück → Profil
      navigiere('ausflug');
    });
    return () => { registerNav(null); registerAusflugOpener(null); };
  // navigiere ist stabil (useCallback mit [])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fehlzeiten-Schwellenwerte beim Start laden (für "Angemeldet bleiben"-Sessions)
  useEffect(() => {
    if (!eingeloggt) return;
    fetch(`${API_BASE}/api/lehrer/einstellungen`, { headers: apiHeaders() })
      .then(leseFallback<any>(null, '/api/lehrer/einstellungen'))
      .then(data => {
        if (data) {
          localStorage.setItem(FEHLZEITEN_GRENZEN_KEY, JSON.stringify({
            achtung:  data.schwellwertGelb,
            kritisch: data.schwellwertRot,
          }));
        }
      })
      .catch(() => {});
  }, [eingeloggt]);

  function konfigAktualisieren(k: AppKonfig) {
    setKonfig(k);
    speichereKonfig(k);
  }

  function onboardingFertig(k: AppKonfig) {
    konfigAktualisieren(k);
    setOnboarding(false);
    setNeueKlasseKonfig(undefined);
    // Sidebar-Dropdown sofort mit Backend-Daten befüllen
    reloadMeineKlassen();
  }

  function anmelden(token: string, nutzerData: NutzerProfil, angemeldetBleiben: boolean) {
    // Welle S8: mit „Angemeldet bleiben“ im localStorage, sonst im sessionStorage (endet mit dem
    // Browser); Profil am selben Ort wie das Token
    setzeToken(token, angemeldetBleiben);
    try { (angemeldetBleiben ? localStorage : sessionStorage).setItem(NUTZER_KEY, JSON.stringify(nutzerData)); } catch { /* egal */ }
    // Welle S8: das Admin-Konto bekommt nur die Verwaltung (App entscheidet beim Start)
    if (nutzerData.is_admin) { window.location.replace('/'); return; }
    registerAktuellerNutzer(nutzerData);
    setNutzer(nutzerData);
    setEingeloggt(true);
    // Fehlzeiten-Schwellenwerte vom Server laden und in localStorage cachen
    fetch(`${API_BASE}/api/lehrer/einstellungen`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(leseFallback<any>(null, '/api/lehrer/einstellungen (Login)'))
      .then(data => {
        if (data) {
          localStorage.setItem(FEHLZEITEN_GRENZEN_KEY, JSON.stringify({
            achtung:  data.schwellwertGelb,
            kritisch: data.schwellwertRot,
          }));
        }
      })
      .catch(() => {});
  }

  // Welle S8: Abmelden räumt auf (App-Speicher, IndexedDB, API-Caches, Push dieses Geräts) und
  // startet neu — danach nur die Anmeldung, Zurück führt nicht in alte Ansichten
  function abmelden() {
    registerAktuellerNutzer(null);
    void abmeldenUndAufraeumen();
  }

  function neuStarten() {
    localStorage.removeItem(STORAGE_KEY);
    setKonfig(DEFAULT_KONFIG);
    setOnboarding(true);
    setAktiv('home');
  }

  const [neueKlasseKonfig, setNeueKlasseKonfig] = useState<AppKonfig | undefined>(undefined);
  const [openProfilId, setOpenProfilIdRoh] = useState<number | null>(null);
  const [openProfilZiel, setOpenProfilZiel] = useState<ProfilZiel | null>(null);
  // Welle U2: Profil-Sprung mit optionalem Ziel-Tab; ohne Ziel wie bisher (Überblick)
  const setOpenProfilId = useCallback((id: number | null, ziel?: ProfilZiel) => {
    setOpenProfilIdRoh(id);
    setOpenProfilZiel(id === null ? null : (ziel ?? null));
  }, []);
  // ── Welle B1: Push-Ziel öffnen (offene App per PUSH_NAV und Kaltstart) ──
  // Erst prüfen, ob das Ziel noch existiert (Kind, Klasse, Aktion) — sonst Heute.
  // pushLauf hängt den Zielbildschirm neu ein, damit er sein Ziel abholt, auch wenn er
  // schon offen ist.
  const [pushLauf, setPushLauf] = useState(0);
  const pushZielOeffnen = useCallback(async (link: string) => {
    const z = pushZiel(link);
    const heute = () => { setPushLauf(n => n + 1); navigiere('home'); };
    try {
      if (z.art === 'schueler') {
        const liste = await apiGet<{ id: number }[]>('/api/schueler');
        if (!liste.some(x => Number(x.id) === z.schuelerId)) return heute();
      } else if (z.art !== 'heute' && z.art !== 'beitrag' && z.klasseId != null) {
        const klassen = await apiGet<KlasseFachEintrag[]>('/api/meine-klassen');
        if (!klassen.some(k => Number(k.klasse_id) === z.klasseId)) return heute();
        if (z.art === 'aktion' && z.aktionId != null) {
          const aktionen = await apiGet<{ id: number }[]>(`/api/klassen/${z.klasseId}/aktionen`);
          if (!aktionen.some(a => Number(a.id) === z.aktionId)) return heute();
        }
      }
    } catch { return heute(); }
    // Welle A3: „Sicherheit & Tipps“ holt den Beitrag selbst ab (offene Seite per Ereignis, sonst beim Einhängen)
    if (z.art !== 'beitrag') setPushLauf(n => n + 1);
    switch (z.art) {
      case 'heute':      if (z.noteVorschlaege) zeigeNoteVorschlaege(); else navigiere('home'); break;
      case 'schueler':   setOpenProfilId(z.schuelerId, z.bereich ?? undefined); navigiere('schueler'); break;
      case 'klasse':     oeffneKlasse(z.klasseId); break;
      case 'aktion':     oeffneKlassenAktionen(z.klasseId, z.aktionId); break;
      case 'fehlzeiten': oeffneFehlzeiten(z.klasseId); break;
      case 'beitrag':    oeffneBeitrag(z.beitragId); break;
    }
  }, [navigiere, setOpenProfilId]);
  const pushZielRef = useRef(pushZielOeffnen);
  pushZielRef.current = pushZielOeffnen;
  // Welle B2: Profil eines Kindes mit Ziel-Bereich öffnen (Kalender → „Gespräch dokumentieren“)
  useEffect(() => {
    registerProfilOeffner((id, ziel) => { setOpenProfilId(id, ziel); navigiere('schueler'); });
    return () => registerProfilOeffner(null);
  }, [navigiere, setOpenProfilId]);
  useEffect(() => {
    if (!eingeloggt || !startLinkRef.current) return;
    const link = startLinkRef.current;
    startLinkRef.current = null;
    pushZielOeffnen(link);
  }, [eingeloggt]); // eslint-disable-line react-hooks/exhaustive-deps

  const [sucheOffen, setSucheOffen] = useState(false);
  const [sucheQ, setSucheQ] = useState('');
  const [suchErgebnisse, setSuchErgebnisse] = useState<SuchTreffer[]>([]);
  const [suchLaden, setSuchLaden] = useState(false);

  function sucheOeffnen() {
    // Welle Z3: aus einer offenen Bereich-Seite ersetzt die Suche deren Eintrag (kein zusätzlicher
    // Zurück-Schritt); Schließen stellt den Bereich wieder her
    const vorher = window.history.state;
    if (vorher?.ldBereich) window.history.replaceState({ ldModal: 'suche', ldVorher: vorher }, '', window.location.pathname);
    else window.history.pushState({ ldModal: 'suche' }, '', window.location.pathname);
    aktuellesModalRef.current = 'suche';
    setSucheOffen(true);
  }

  // Welle U6b: Treffer öffnen genau den Eintrag (Profil, Mail, Termin/Ausflug, Klassenbuch-Datum, Notiz)
  function suchTrefferOeffnen(t: SuchTreffer) {
    const id = Number(t.id);
    switch (t.typ) {
      case 'schueler':    setOpenProfilId(id); navigiere('schueler'); break;
      case 'mail':        oeffneMailVonAussen(id); break;
      case 'termin':      if (t.kategorie === 'ausflug') openAusflugDetail(id); else oeffneTerminBearbeiten(id); break;
      case 'klassenbuch': oeffneKlassenbuch({ datum: t.datum!, stunde: t.stunde ?? null, klasseId: t.klasse_id ?? null }); break;
      case 'notiz':       oeffneNotizen(t.schueler_id!, null, id, !!t.archiviert); break;
      case 'aktion':      oeffneKlassenAktionen(t.klasse_id ?? null, id); break;
      default:            navigiere('home');
    }
  }

  function sucheSchliessen() {
    aktuellesModalRef.current = null;
    setSucheOffen(false);
    setSucheQ('');
    setSuchErgebnisse([]);
    if (window.history.state?.ldModal === 'suche') {
      if (window.history.state.ldVorher) window.history.replaceState(window.history.state.ldVorher, '', window.location.pathname);
      else window.history.back();
    }
  }

  // Smartphone-/Browser-Zurück-Taste: Modal schließen oder Screen wechseln
  useEffect(() => {
    const handlePopState = (e: PopStateEvent) => {
      if (aktuellesModalRef.current === 'suche') {
        aktuellesModalRef.current = null;
        setSucheOffen(false);
        setSucheQ('');
        setSuchErgebnisse([]);
        return;
      }
      // Welle U6b: Rückkehr in einen Eintrag, aus dem in ein Profil-Ziel gesprungen wurde
      if (istProfilHerkunft(e.state?.ldExtra?.profil)) setOpenProfilId(e.state.ldExtra.profil.profilId, e.state.ldExtra.profil.ziel);
      if (e.state?.ldScreen) {
        setAktiv(ohneEntfernte(e.state.ldScreen as NavItem));
      } else {
        setAktiv('home');
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  // ── Auth-Wall: Login / Registrierung ──────────────────────────────
  if (!eingeloggt) {
    if (authScreen === 'registrierung') {
      return (
        <RegistrierungScreen
          onRegistriert={(token, n) => { anmelden(token, n, true); }}
          onZurLogin={() => setAuthScreen('login')}
        />
      );
    }
    return (
      <LoginScreen
        onLogin={(token, n, bleiben) => anmelden(token, n, bleiben)}
        onZurRegistrierung={() => setAuthScreen('registrierung')}
      />
    );
  }

  const seiten: Record<NavItem, React.ReactNode> = {
    home:          <HeuteScreen />,
    schueler:      <SchuelerAnsicht />,
    unterricht:    <UnterrichtAnsicht />,
    meinTag:       <MeinTagAnsicht />,
    // Welle K3: Seitenleiste Kalender/Stundenplan/Mehrarbeit = Mein Tag mit dem passenden Reiter
    stundenplan:   <MeinTagAnsicht key="sp" start="stundenplan" />,
    schulrecht:    <SchulrechtAnsicht nutzer={nutzer} />,
    kalender:      <MeinTagAnsicht key="kal" start="kalender" />,
    notizen:       <NotizenAnsicht />,
    fehlzeiten:    <FehlzeitenScreen />,
    klassenbuch:   <KlassenbuchScreen />,
    mails:         <MailScreen />,
    klasse:        <KlasseTab
                     schueler={(k, ansicht, onDetail) => <SchuelerAnsicht aktiveKlasse={k} ansicht={ansicht} onDetail={onDetail} />}
                     unterricht={(k, art, aktiv) => <UnterrichtAnsicht vorgabeKlasseId={k?.klasse_id ?? null} art={art} aktiv={aktiv} />}
                     klasse={(k, aktionenZiel, art) => <KlasseAnsicht onNav={navigiere} externeKlasseId={k?.klasse_id ?? null} aktionenZiel={aktionenZiel} tab={art} />} />,
    stoffplan:     <StoffplanAnsicht />,
    mehrarbeit:    <MeinTagAnsicht key="ma" start="mehrarbeit" />,
    datenschutz:   <DsgvoAnsicht onAbmelden={abmelden} />,
    klaerung:      <KlaerungInbox />,
    uebergang:     <UebergangWizard onFertig={() => { navigiere('home'); setUebergangHard(null); window.dispatchEvent(new CustomEvent('lehrerdesk-klassen-reload')); }} onNavStundenplan={() => { navigiere('stundenplan'); setUebergangHard(null); window.dispatchEvent(new CustomEvent('lehrerdesk-klassen-reload')); }} />,
    archiv:        <ArchivScreen />,
    mitteilungen:  <SicherheitSeite />,
    admin:         null, // eigene Shell, siehe unten
    ausflug:       <AusflugDetail terminId={ausflugDetailId} onBack={() => {
      // Welle U6b: Herkunft Profil → genau dieses Profil im gemerkten Tab
      if (istProfilHerkunft(ausflugHerkunft)) { setOpenProfilId(ausflugHerkunft.profilId, ausflugHerkunft.ziel); navigiere('schueler'); }
      else navigiere(ausflugHerkunft);
    }} />,
    einstellungen: (
      <EinstellungenAnsicht
        konfig={konfig}
        onKonfigUpdate={konfigAktualisieren}
        onNeuStart={neuStarten}
        onAbmelden={abmelden}
        nutzer={nutzer}
        onKlassenReload={reloadMeineKlassen}
      />
    ),
  };

  // Welle S8: Das Admin-Konto sieht diese App nicht mehr (AdminBereich, siehe App unten).
  // Ein „admin“-Ziel aus älteren Links führt hier einfach auf die normale Ansicht.
  return (
    <KlassenProvider eingeloggt={eingeloggt}>
    <FabProvider>
    <SchuelerProvider eingeloggt={eingeloggt} openProfilId={openProfilId} openProfilZiel={openProfilZiel} onOpenProfilChange={setOpenProfilId}>
      {/* iOS: Prevent auto-zoom on input focus by ensuring font-size ≥ 16px */}
      <style>{`
        input, select, textarea { font-size: max(16px, 1em) !important; }
        @media (orientation: landscape) and (max-height: 500px) {
          nav[style] { min-height: 52px !important; }
          nav[style] button { padding: 4px 0 !important; gap: 1px !important; }
          nav[style] button span[style] { font-size: 18px !important; }
          nav[style] button div { font-size: 10px !important; }
          main { padding-top: 8px !important; padding-bottom: 58px !important; }
        }
      `}</style>
      {showSplash && <SplashScreen onDone={() => setShowSplash(false)} />}
      {uebergangHard && aktiv !== 'uebergang' && (
        <HardCutoffModal
          naechstes_sj={uebergangHard.naechstes_sj}
          onStart={() => navigiere('uebergang')}
        />
      )}
      <OfflineBanner />
      <ToastContainer />
      <ConfirmHost /><MikrofonHinweisHost />
      <SitzungWaechter />{/* Welle S8: kurze Sitzung ohne „Angemeldet bleiben“ */}
      <KlassenarbeitListeHost />{/* Welle B2: ein Fenster für die ganze App */}
      <KonferenzHosts />{/* Welle B4: Blatt, Konferenzliste, AV/SV-Vorschläge */}
      <KlassenbuchNachtragenHost />{/* Welle B3: Per Sprache nachtragen */}
      <div style={{ display: 'flex', minHeight: '100vh', fontFamily: 'var(--ld-font-family)' as any, background: 'var(--ld-surface-page-glow), var(--ld-surface-page-gradient)', color: 'var(--ld-text-primary)' }}>
        {onboarding && (
          <OnboardingFlow
            onFertig={onboardingFertig}
            vorhandeneKonfig={neueKlasseKonfig}
          />
        )}
        {!isMobile && (
          <Sidebar
            active={aktiv}
            onNav={navigiere}
            konfig={konfig}
            nutzer={nutzer}
            onSuche={sucheOeffnen}
          />
        )}
        {isMobile && (
          <MobileHeader
            nutzer={nutzer}
            konfig={konfig}
            onNav={navigiere}
            onAbmelden={abmelden}
            onSuche={sucheOeffnen}
          />
        )}
        <main className="ld-main-content" style={{
          flex: 1,
          // Welle B1/B2: liegt der schwebende Mikro-Knopf da, endet der Inhalt über ihm
          // (index.css: body[data-mikroknopf] .ld-main-content, Lage wie im FAB)
          padding: isMobile ? '72px 16px 88px' : '36px 36px',
          overflowY: 'auto',
          // Welle K6: Heute (Widget-Board) darf am PC breiter werden, alle anderen Seiten bleiben bei 1100
          maxWidth: isMobile ? '100%' : aktiv === 'home' ? 1480 : 1100,
          overflowX: 'hidden',
          width: isMobile ? '100%' : undefined,
          boxSizing: 'border-box',
        }}>
          <div key={`${aktiv}-${pushLauf}`} style={{ display: 'contents' }}>
            {seiten[aktiv]}
          </div>
        </main>
        {isMobile && <BottomNav active={aktiv} onNav={navigiere} />}
        {isMobile && !showSplash && <FAB onNav={navigiere} activeNav={aktiv} />}
        {!showSplash && <UniversaldiktatFAB aktiv={aktiv} />}
        {!showSplash && (
          <div style={{ position: 'fixed', bottom: isMobile ? 80 : 24, left: 16, zIndex: 900 }}>
            <OfflineQueueIndicator />
          </div>
        )}
        {showIosBanner && (
          <IosInstallBanner onClose={() => {
            localStorage.setItem('ios-banner-dismissed', '1');
            setShowIosBanner(false);
          }} />
        )}

        {/* ── Such-Overlay ── */}
        {sucheOffen && (
          <div className="ld-backdrop-enter" onClick={sucheSchliessen}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 2000, backdropFilter: 'blur(4px)', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 60, padding: '60px 16px 0' }}>
            <div className="ld-drawer-enter" onClick={e => e.stopPropagation()} style={{ background: 'white', borderRadius: 'var(--ld-radius-xl)', width: '100%', maxWidth: 600, maxHeight: '80vh', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 80px rgba(0,0,0,0.25)' }}>
              {/* Suchfeld */}
              <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--ld-border-light)', display: 'flex', alignItems: 'center', gap: 12 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                <input
                  autoFocus
                  value={sucheQ}
                  onChange={async e => {
                    const q = e.target.value;
                    setSucheQ(q);
                    if (q.length < 2) { setSuchErgebnisse([]); return; }
                    setSuchLaden(true);
                    try {
                      const d = await fetch(`${API_BASE}/api/suche?q=${encodeURIComponent(q)}`, { headers: apiHeaders() })
                        .then(leseFallback<any[]>([], '/api/suche'));
                      setSuchErgebnisse(d);
                    } catch { /* ignore */ } finally { setSuchLaden(false); }
                  }}
                  placeholder="Schüler, Mails, Klassenbuch und mehr …"
                  style={{ flex: 1, border: 'none', outline: 'none', fontSize: 16, color: 'var(--ld-text-primary)', background: 'transparent' }}
                />
                {suchLaden && <div style={{ width: 16, height: 16, border: '2px solid var(--ld-outline-soft)', borderTopColor: '#6B5FD4', borderRadius: '50%', animation: 'spin .7s linear infinite', flexShrink: 0 }} />}
                <button onClick={sucheSchliessen}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ld-text-secondary)', lineHeight: 1, display: 'inline-flex' }} aria-label="Suche schließen"><MIcon name="close" size={20} /></button>
              </div>
              {/* Ergebnisse */}
              <div style={{ overflowY: 'auto', flex: 1 }}>
                {sucheQ.length < 2 && suchErgebnisse.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '48px 24px', color: '#9CA3AF' }}>
                    <div style={{ marginBottom: 10, color: 'var(--ld-text-tertiary)' }}><MIcon name="search" size={30} /></div>
                    <div style={{ fontSize: 14 }}>Schüler, Mails, Klassenbuch und mehr durchsuchen</div>
                  </div>
                )}
                {sucheQ.length >= 2 && suchErgebnisse.length === 0 && !suchLaden && (
                  <div style={{ textAlign: 'center', padding: '48px 24px', color: '#9CA3AF' }}>
                    <div style={{ fontSize: 14 }}>Nichts gefunden für „{sucheQ}"</div>
                  </div>
                )}
                {suchErgebnisse.length > 0 && (() => {
                  const TYP_LABEL: Record<string, string> = { schueler: 'Schüler', klassenbuch: 'Klassenbuch', mail: 'Mails', termin: 'Termine', notiz: 'Notizen', aktion: 'Aktionen' };
                  const TYP_EMOJI: Record<string, string> = { schueler: 'person', klassenbuch: 'menu_book', mail: 'mail', termin: 'event', notiz: 'sticky_note_2', aktion: 'checklist' };
                  const gruppen = suchErgebnisse.reduce((g, e) => { (g[e.typ] = g[e.typ] ?? []).push(e); return g; }, {} as Record<string, typeof suchErgebnisse>);
                  return Object.entries(gruppen).map(([typ, items]) => (
                    <div key={typ}>
                      <div style={{ padding: '10px 20px 6px', fontSize: 11, fontWeight: 700, color: '#8E8E93', letterSpacing: 0.5 }}>
                        {TYP_LABEL[typ] ?? typ}
                      </div>
                      {items.map((item, i) => (
                        <button key={item.id + i} onClick={() => {
                          // Welle U2/U6b: Overlay schließen, dann den Eintrag selbst öffnen. Der
                          // Such-Eintrag in der History wird dabei ersetzt (navigiere, kein back()).
                          aktuellesModalRef.current = null;
                          setSucheOffen(false); setSucheQ(''); setSuchErgebnisse([]);
                          suchTrefferOeffnen(item);
                        }} style={{
                          width: '100%', textAlign: 'left', padding: '10px 20px', display: 'flex', alignItems: 'center', gap: 12,
                          background: 'none', border: 'none', cursor: 'pointer', borderTop: i === 0 ? 'none' : '1px solid #F5F5F7',
                        }}
                          onMouseEnter={e => (e.currentTarget.style.background = '#F8F9FF')}
                          onMouseLeave={e => (e.currentTarget.style.background = 'none')}
                        >
                          <div style={{ width: 34, height: 34, borderRadius: 10, background: '#F0ECF7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 }}>
                            <MIcon name={TYP_EMOJI[typ] ?? 'circle'} size={18} />
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ld-text-primary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.titel}</div>
                            <div style={{ fontSize: 12, color: '#6B7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.untertitel}</div>
                          </div>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#D1D5DB" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
                        </button>
                      ))}
                    </div>
                  ));
                })()}
              </div>
            </div>
          </div>
        )}
      </div>
    </SchuelerProvider>
    </FabProvider>
    </KlassenProvider>
  );
}

// ── Welle S8: Admin-Konto ohne Schülerdaten ───────────────────────────────────────
// Angemeldet mit Admin-Recht: nur die Admin-Konsole mit „Konto“ und „Abmelden“ — keine Klassen,
// Kinder oder Unterricht (der Server sperrt diese Routen für das Admin-Konto ohnehin mit 403).
function AdminBereich() {
  return (
    <>
      <ToastContainer />
      <ConfirmHost /><MikrofonHinweisHost />
      <SitzungWaechter />
      <div style={{ minHeight: '100vh', background: 'var(--ld-surface-page-gradient)' }}>
        <React.Suspense fallback={<div style={{ padding: 40, textAlign: 'center', color: 'var(--ld-text-secondary)' }}>Verwaltung wird geladen …</div>}>
          <AdminKonsole onAbmelden={() => void abmeldenUndAufraeumen()} konto={<DsgvoAnsicht ohneZurueck onAbmelden={() => void abmeldenUndAufraeumen()} />} />
        </React.Suspense>
      </div>
    </>
  );
}

export default function App() {
  // Token und Profil sagen, ob ein Admin angemeldet ist; die Rechte prüft der Server
  const adminAngemeldet = !!holeToken() && (tokenDaten()?.is_admin === true || ladeNutzer()?.is_admin === true);
  return adminAngemeldet ? <AdminBereich /> : <LehrkraftApp />;
}
